import { exchangeZh } from './exchange';

export const LANG = {
    validation: {
        email_invalid: "邮箱格式有误",
        trade_evidence_required: "请上传贸易真实性材料",
        withdrawal_amount_required: "请输入提现金额",
        checkbox_required: "请勾选",
        english_name_required: "请输入英文名称",
        english_name_characters: "只能输入英文字母、数字、空格及符号/-?:().,'+",
        expiry_date_required: "请输入有效期",
        name_invalid: "名称格式有误",
        industry_required: "请选择行业类别",
        entity_category_required: "请选择主体类别",
        main_products_required: "请输入主要经营商品",
        annual_gmv_required: "请输入年度GMV",
        document_expiry_date_required: "请选择证件有效日期",
        company_registration_location_required: "请选择企业注册地",
        company_type_required: "请选择企业类型",
        shop_payment_required: "请输入至少选择一个店铺并输入付款金额",
        max_length: "最大长度为{max}个字符",
        payment_amount_required: "请输入付款金额",
        account_nickname_required: "请输入账号昵称",
        registration_location_required: "请选择企业/个人注册地",
        bank_card_required: "请选择银行卡",
        english_half_width_characters: "只能输入英文字母、数字、空格及 - ? : ( ) . , ' +，且不能以 - 开头",
        chinese_name_invalid: "名称格式有误,请输入中文",
        issue_date_required: "请输入签发日期",
        login_password_confirmation_required: "登录密码确认不能为空",
        payment_password_confirmation_required: "支付密码确认不能为空",
        chinese_english_max_length: "请输入中英文且不超过 {max} 字符",
        login_password_required: "登录密码不能为空",
        phone_in_use: "手机号码被占用",
        document_validity_required: "请选择证件有效期",
        passport_number_required: "请输入护照号",
        passport_validity_required: "请选择护照有效期",
        passport_issue_date_required: "请选择护照签发日期",
        sms_code_required: "请输入手机验证码"
    },
    page: {
        exchange: exchangeZh,
        kyc: {
            "companyDto": {
                "NationalityoftheDirector": "国籍",
                "NameofDirector": "姓名",
                "NameofDirectorEn": "英文姓名",
                "ChineseFirstName": "中文名",
                "ChineseLastName": "中文姓",
                "DateofBirthoftheDirector": "出生日期",
                "EnglishFirstName": "英文名",
                "EnglishLastName": "英文姓",
                "empty_text": "暂无数据",
                "not_completed_account_holder_info": "您还未完成账户持有人信息设置，请先完成设置",
            },
            step2Person: {
                titleCert: "证件信息",
                titleDomicile: "户籍地址",
                titleResidence: "居住地址",
                nationality: "国籍",
                certType: "证件类型",
                idCardFront: "身份证人像页",
                idCardBack: "身份证国徽页",
                passport: "护照",
                certNo: "证件号码",
                certExpDate: "证件有效期",
                certIssueDate: "证件签发日期",
                holdIdCard: "手持本人证件照",
                nameCn: "姓名",
                nameEn: "英文姓名",
                birthday: "生日",
                domicileAddr1: "户籍详细住址行1",
                domicileAddr1En: "户籍详细英文地址行1",
                domicileAddr2: "户籍详细住址行2",
                domicileAddr2En: "户籍详细英文地址行2",
                domicileCountry: "户籍国家/地区",
                domicileProvince: "户籍省",
                domicilePostCode: "户籍邮编",
                domicileCity: "户籍城市",
                notSameCheck: "我的居住地址不同",
                residenceAddr1: "居住详细住址行1",
                residenceAddr1En: "居住详细英文地址行1",
                residenceAddr2: "居住详细住址行2",
                residenceAddr2En: "居住详细英文地址行2",
                residenceCountry: "居住国家/地区",
                residenceProvince: "居住省",
                residencePostCode: "居住邮编",
                residenceCity: "居住城市",
                placeholderNationality: "请选择国家地区",
                placeholderName: "请填写姓名",
                placeholderNameEn: "请填写英文姓名",
                placeholderAddr: "请填写居住地址",
                placeholderAddrEn: "请填写英文地址",
                placeholderAddrCont: "请填写居住地址（续）",
                placeholderAddrContEn: "请填写英文地址（续）",
                placeholderPostCode: "请输入邮编",
                errCertType: "请选择证件类型",
                errNationality: "请选择国籍",
                errNameCn: "请输入姓名",
                errNameEn: "请输入英文姓名",
                errBirthday: "请选择生日",
                errDomicileAddr: "请填写户籍详细住址行1",
                errDomicileAddrEn: "请填写户籍详细英文地址行1",
                errDomicileCountry: "请选择户籍国家/地区",
                errDomicileProvince: "请选择户籍省",
                errDomicilePostCode: "请输入户籍邮编",
                errDomicileCity: "请选择户籍城市",
                errResidenceAddr1: "请填写居住详细住址行1",
                errResidenceAddr1En: "请填写居住详细英文地址行1",
                errResidenceAddr2: "请填写居住详细住址行2",
                errResidenceAddr2En: "请填写居住详细英文地址行2",
                errResidenceCountry: "请选择居住国家/地区",
                errResidenceProvince: "请选择居住省",
                errResidenceCity: "请选择居住城市",
                errResidencePostCode: "请输入居住邮编",
                errCertExpired: "此证件有效期小于当前日期，请更换有效证件",
                otherAttachmentPlaceholder: "请上传其他附件",
                otherAttachment: "其他附件",
            },
            step3: {
                name_placeholder: "请输入姓名",
                name_en_placeholder: "请输入英文姓名",
                name_required: "请输入姓名",
                name_en_required: "请输入英文姓名",
                residential_address: "居住地址",
                residential_address_en: "居住英文地址",
                residential_address_placeholder: "请输入完整居住地址",
                residential_address_en_placeholder: "请输入完整居住英文地址",
                residential_address_required: "请输入居住地址",
                residential_address_en_required: "请输入居住英文地址",
                holder_section_title: "账户持有人信息",
                holder_relation_title: "注册人身份关联",
                holder_relation_tip: "将开户注册手机号对应的实名人员，与法人/董事、受益人或授权代理人进行关联。",
                holder_select_phone_tip: "请选择 {phone} 的实名信息",
                holder_select_phone_desc: "请从下方选择 1 人；不在名单中则填写授权代理人。",
                holder_type_legal: "法人/董事",
                holder_type_director: "董事",
                holder_type_ubo: "最终受益人",
                holder_type_agent: "指定授权代理人",
                holder_agent_tip: "手机号持有人不在以上名单中，请填写授权代理人信息并上传授权委托书。",
                holder_type_other: "其他持有人",
                holder_type_self: "本人",
                holder_self_tip: "本人将使用上方已填写的个人证件与姓名信息作为账户持有人",
                holder_name: "姓名",
                holder_cert_no: "证件号码",
                holder_id_front: "证件照片（人像面）",
                holder_id_back: "证件照片（国徽面）",
                holder_id_hk: "香港居民身份证",
                holder_id_passport: "护照",
                holder_agree_prefix: "我已阅读并同意",
                holder_guarantee_link: "《关于确认手机号码所有权的担保函》",
                holder_agree_required: "请阅读并勾选申明",
            },
            step2Company: {
                titleCertCN: "企业证件",
                titleCertHK: "企业证件（香港）",
                titleBasicInfo: "企业基本信息",
                titleBusinessAddr: "经营地址",
                titleAttachment: "附件",
                businessLicense: "营业执照",
                certNo: "证件号码",
                certRegDate: "证件注册日期",
                certExpDate: "证件有效日期",
                hkIncorpCert: "香港注册证书",
                hkBizRegCert: "香港商业登记证",
                hkBizRegCertNo: "商业登记证号码",
                hkRelatedCert: "企业相关证件",
                nar1Label: "周年申报表",
                nnc1Label: "法团成立表",
                nd2aLabel: "更改公司董事通知书",
                companyName: "企业名称",
                companyNameHint: "需与营业执照登记名称完全一致",
                nameCn: "企业中文名称",
                nameCnFull: "中文全称",
                nameCnPlaceholder: "请输入营业执照上的中文全称",
                nameEn: "企业英文名称",
                nameEnFull: "英文全称",
                nameEnPlaceholder: "Registered English name",
                translateCompanyName: "译为英文",
                translateGenerated: "已生成，请核对英文内容",
                translateFailed: "未获取到翻译结果，请重试",
                clearNameCn: "清空企业中文名称",
                clearNameEn: "清空企业英文名称",
                registCountry: "注册地址国家/地区",
                registProvince: "注册地址省",
                registCity: "注册地址城市",
                registAddress: "企业注册地址",
                registAddressEn: "企业注册英文地址",
                addressCn: "中文地址",
                addressEn: "英文地址",
                detailAddress: "详细地址",
                registAddressPlaceholder: "请输入完整的企业注册地址",
                registAddressEnPlaceholder: "请输入完整的企业注册英文地址",
                isSameAddress: "经营地址与注册地址是否相同？",
                yes: "是",
                no: "否",
                bizAddrProof: "经营地址证明",
                bizAddress: "企业经营地址",
                bizAddressEn: "企业经营英文地址",
                bizAddressPlaceholder: "请输入完整的企业经营地址",
                bizAddressEnPlaceholder: "请输入完整的企业经营英文地址",
                bizCountry: "经营地址国家/地区",
                bizProvince: "经营地址省",
                bizCity: "经营地址城市",
                bizPostCode: "经营地址邮编",
                equityDiagram: "股权架构图（选填）",
                otherAttachment: "其他附件（选填）",
                certNoPlaceholderCN: "企业16位商业登记证号码",
                certNoPlaceholder: "请填写证件号码",
                bizRegCertNoPlaceholder: "请填写商业登记证号码",
                errUpload: "请上传文件",
                errCertNo: "请输入证件号码",
                errCertRegDate: "请选择证件注册日期",
                errHkRegDate: "请选择注册日期",
                errHkRelatedCert: "请选择相关证件",
                errHkRelatedCertUpload: "请上传企业相关证件",
                errNameCn: "请输入企业中文名称",
                errNameEn: "请输入企业英文名称",
                errRegistAddress: "请输入企业注册地址",
                errRegistAddressEn: "请输入企业注册英文地址",
                errRegistCountry: "请选择注册地址国家/地区",
                errRegistProvince: "请选择注册地址省",
                errRegistCity: "请选择注册地址城市",
                errBizAddress: "请输入企业经营地址",
                errBizAddressEn: "请输入企业经营英文地址",
                errBizCountry: "请选择经营地址国家/地区",
                errBizProvince: "请选择经营地址省",
                errBizCity: "请选择经营地址城市",
                errBizPostCode: "请输入经营地址邮编",
                errCertExpired: "此证件有效期小于当前日期，请更换有效证件",
                errRegisterAmount: "请输入注册资本",
            },
        },
        quota: {
            "action_view_detail": "额度详情",
            "action_add_orders": "新增额度",
            "search_button": "搜索",
            "dialog_title": "新增额度",
            "label_upload_trade_materials": "上传贸易材料",
            "label_upload_trade_materials_required": "上传贸易材料：",
            "button_template_download": "模板下载",
            "upload_tip_click": "点击上传",
            "upload_tip_materials": "上传贸易材料",
            "upload_tip_or": "或",
            "upload_tip_drag": "拖拽至此处",
            "upload_format_hint": "附件支持 xlsx, .xls, .csv, .zip, .rar, 文件不超过10MB",
            "label_remark": "备注",
            "label_remark_required": "备注：",
            "placeholder_remark": "请输入备注",
            "button_cancel": "取消",
            "button_confirm": "确定",
            "label_kyc_id": "KYCID：",
            "placeholder_kyc_id": "请输入",
            "label_entity_name": "主体名称：",
            "placeholder_entity_name": "请输入",
            "label_operating_platform": "经营平台：",
            "placeholder_operating_platform": "请选择",
            "label_shop_name": "店铺名称：",
            "placeholder_shop_name": "请输入",
            "button_query": "查询",
            "table_column_kyc_id": "KYCID",
            "table_column_entity_name": "主体名称",
            "table_column_operating_platform": "经营平台",
            "table_column_shop_name": "店铺名称",
            "table_column_shop_currency": "店铺币种",
            "table_column_upload_quota": "上传额度",
            "table_column_create_time": "创建时间",
            "table_column_review_status": "审核状态",
            "table_column_review_time": "审核时间",
            "table_column_review_note": "审核备注",
            "table_column_action": "操作",
            "action_view_file": "查看文件",
            "action_download_failed_file": "失败文件下载",
            "status_approved": "审核通过",
            "status_rejected": "审核拒绝",
            "status_initialized": "初始化",
            "status_pending": "待审核",
            "status_processing": "审核中",
            "status_completed": "已完成",
            "label_plateForm_name": "业务类型：",
            "action_update_materials": "材料更新",
            "tab_single_add": "单个新增",
            "tab_batch_upload": "批量上传",
            "section_order_info": "订单信息",
            "label_order_no": "订单号",
            "placeholder_order_no": "请输入订单号",
            "label_transaction_time": "交易时间",
            "placeholder_select_time": "请选择时间",
            "label_transaction_amount": "交易金额",
            "label_currency": "币种",
            "section_product_info": "商品信息",
            "label_product_name": "商品名称",
            "placeholder_product_name": "请输入商品名称",
            "label_quantity": "商品数量",
            "label_unit_price": "商品单价",
            "label_product_type_code": "商品类型编码",
            "placeholder_select": "请选择",
            "section_logistics_info": "物流信息",
            "label_shipment_status": "发货状态",
            "label_estimated_shipping_time": "预计发货时间",
            "label_shipping_date": "发货日期",
            "label_trade_country": "贸易国家/地区",
            "label_tracking_no": "物流单号",
            "placeholder_tracking_no": "请输入物流单号",
            "label_logistics_company": "物流公司名称",
            "placeholder_logistics_company": "请输入物流公司名称",
            "section_buyer_info": "买家信息",
            "label_buyer_name": "买家名称",
            "placeholder_buyer_name": "请输入买家名称",
            "label_buyer_address": "买家地址",
            "placeholder_buyer_address": "请输入买家地址",
            "section_company_info": "公司/店铺信息",
            "label_company_website": "公司或店铺网址",
            "placeholder_company_website": "请输入公司或店铺网址",
            "shipment_status_not_shipped": "未发货",
            "shipment_status_shipped": "已发货",
            "error_order_no_required": "请输入订单号",
            "error_transaction_time_required": "请选择交易时间",
            "error_transaction_amount_required": "请输入交易金额",
            "error_transaction_amount_min": "交易金额必须大于 0",
            "error_currency_required": "请选择币种",
            "error_product_name_required": "请输入商品名称",
            "error_quantity_required": "请输入商品数量",
            "error_quantity_min": "商品数量必须大于 0",
            "error_unit_price_required": "请输入商品单价",
            "error_unit_price_min": "商品单价必须大于 0",
            "error_product_type_code_required": "请选择商品类型编码",
            "error_shipment_status_required": "请选择发货状态",
            "error_estimated_shipping_time_required": "请选择预计发货时间",
            "error_tracking_no_required": "请输入物流单号",
            "error_logistics_company_required": "请输入物流公司名称",
            "error_shipping_date_required": "请选择发货日期",
            "error_trade_country_required": "请选择贸易国家/地区",
            "error_buyer_name_required": "请输入买家名称",
            "error_buyer_address_required": "请输入买家地址",
            "error_company_website_required": "请输入公司或店铺网址",
        },
        fileTips: {
            "EQUITY_STRUCTURE_DIAGRAM": "股权架构图需穿透到自然人，每一层能显示股东名称和持股比例并注明日期加盖公司印章",
            "CERTIFICATE_BUSINESS_ADDRESS": "可提供注册地最近三个月内的水电煤账单、办公室租赁合同、带地址的银行账单",
            "BUSINESS_REGISTER_CERTIFICATE": "登记证号码要填写完整",
            "NNC1": "成立未满一年时提供",
            "NAR1": "注册满一年以上的必传，不满一年的只需要法团表",
            "ND2A": "如有董事变动",
            "ID_CARD_HOLD": "手持身份证件要求: 彩色件，清晰不反光",
            "UPDATE_TIME": "失效于",
            "store_status_frozen_title": "此主体已冻结",
            "store_status_frozen_description": "您的公司账户暂时无法使用，请联系您的客户经理或客服以获取帮助。",
            "store_status_frozen_description1": "该店铺主体已被冻结，请联系销售经理",
            "store_status_frozen_button": "确定",
            "verify_rejected": "审核拒绝",
            "verify_frozen": "已冻结",
            "frozen": '冻结'
        },
        shopBinding1: {
            "title": "您还未实名认证，无法直接绑定！",
            "subtitle": "需要您提交实名认证信息，我们将会优先在1个工作日内处理。",
            "subtitle_2": "实名审核通过后就可以自动为您分配收款账号，开启极速入账和全球付款服务。",
            "section_title_location": "企业注册地址",
            "mainland_china": "中国大陆",
            "hong_kong": "中国香港",
            "international": "境外",
            "account_nickname_label": "账户昵称",
            "nickname_placeholder": "请输入账户昵称",
            "go_verify_button": "去实名认证绑定",
            "title_switch_account": "切换账号",
            "createAccountLink": "创建新账户",
            "accountNumberLabel": "账户号码",
            "documentNumberLabel": "证件号",
            "businessRegistrationNumberLabel": "商业登记号码",
            "useAccountButton": "使用账号",
            "modalTitle": "通知",
            "modalDescription": "请确认是否已经完成绑定操作，点击【确定】将会返回首页退出绑定页面。点击【取消】继续完成绑定操作。",
            "cancelButton": "取消",
            "confirmButton": "确认",

            "pageTitle": "绑定Infinia账号",
            "modalTitle_2": "确认信息",
            "modalDescription_2": "请确认当前电商平台的卖家主体证件号：{idNumber}。如需使用其他证件号，请在电商平台后台修改后再重新发起绑定账号。",
            "cancelButton_2": "取消",
            "confirmButton_2": "确认",
            "actionButton_2": "确认绑定",
            "infiniaService": "INFINIA服务协议",
            "privacyPolicy": "隐私与安全政策",
            "and": "和",

            "updateDocumentTips": "{feature_name}功能已被暂停使用，因为您的证件过期。请点击【立即更新】上传证件，或前往“我的账户”页面完成更新，以恢复使用。",
            "shopExpiredTips": "店铺{shopName}主体证件已过期，暂无法进行提现/付款操作，请联系该管理账户更新上传证件，在“我的账户”页面完成更新，以恢复使用。",
            "multipleDocumentsExpiring": "您的{entityName}主体有{num}份证件将在{minExpire} {symbol }{maxExpire}到期，剩余{minExpireDay}天。为确保账户正常使用，请尽快更新。",
            "documentExpiredGracePeriodTips": "我们为您保留了{delayExpireDay}天宽限期（截至{maxExpire}），期间交易功能仍可正常使用。请点击【立即更新】上传新证件，或前往“我的账户”页面完成更新。如超过宽限期仍未更新，交易功能将被暂停。",

            "allBalance": "全部金额",
            "allBalanceTips": "可付款总金额：",
            "documentExpiringTips": "您的证件即将过期",
            "documentExpiringTips_2": "剩余{minExpireDay}天",
            "documentExpiringTips_3": "立即更新",
            "documentExpiringTips_4": "该店铺主体证件已过期",
            "documentExpiringTips_5": "您的证件已过期",
            "documentExpiringTips_6": "上传过期材料",
            "noLongerRemind": "不再提醒",
            "closeNoticeFail": "关闭提醒失败，请稍后重试",

        },
        shopBinding2: {
            "bindInfiniaAccount": "绑定Infinia账号",
            "yourLegalEntity": "您的主体证件号",
            "infiniaEntity": "Infinia实名认证主体证件号",
            "switchAccount": "更换账号",
            "reviewingNotice": "请注意：当前 Infinia 的实名认证信息正在审核中，如果审核通过后，我们将会自动绑定账号。",
            "ensureInfoMatch": "请确保您提供的实名认证信息与电商平台卖家主体一致",
            "confirmBinding": "确认绑定",
            "title": "账户预绑定提交！",
            "processingNotice": "我们将会优先在 1 个工作日内处理。请您及时关注相关邮件或者短信通知。",
            "approvalInfo": "您的实名认证审核通过后，如果信息一致就可以自动为您分配收款账号，开启极速入账和全球付款服务。",
            "returnHomeButton": "返回首页",
            "unverified": "未验证",
            "reviewing": "审核中",
            "verified": "已审核",
            "failed": "未通过",
            "certNoNotMatch": "该账号证件号与卖家证件号不一致，不可选择",
            "switchAccountError": "切换实体账户有误",
        },
        applyPayeeAccount: {
            "title_select_collection_platform": "选择您要开通的业务类型",
            "tab_other": "其他",
            "card_general_trade_title": "一般贸易",
            "card_general_trade_subtitle": "自主研发",
            "page_title_bind_store": "绑定店铺",
            "breadcrumb_path": "首页 / 我的店铺 / 绑定店铺",
            "label_platform": "店铺所在平台",
            "label_store_name": "店铺名称",
            "label_currency": "币种",
            "label_store_url": "店铺链接",
            "checkbox_agreement": "我已阅读并同意《申明》",
            "button_submit": "提交申请",
            "button_add_beneficiary": "添加收款人",
            "company_name": "公司名称",
            "card_no_mask": "Infinia账户号",
            "registerPhone": "注册手机号",
            "message_missing_required": "缺少必填信息，请刷新后重试",
            "message_submit_success": "提交成功",
            "b2b_list": "电商业务",
            "b2b_platform_name": "电商平台",
            "nav_name": "一般贸易/申请收款账号"
        },
        accountList: {
            "breadcrumb_account": "首页 / 我的账户",
            "collection_account": "收款账户",
            "total_assets_label": "总资产",
            "apply_overseas_collection": "申请境外收款账户",
            "withdraw_account_manage": "提现账户管理",
            "withdraw_now_button": "立即提现",
            "exchange_rate_note": "根据市场汇率换算，货币数值仅供参考",
            "basic_account_balance": "基本账户余额",
            "currency_label": "币种",
            "account_balance_label": "账户余额",
            "available_balance_label": "可用金额",
            "funds_in_transit_label": "在途资金",
            "requested_accounts_label": "已申请账户数",
            "currency_cnh": "CNH"
        },
        home: {
            "home_tab": "首页",
            "label_current_account": "当前账户",
            "available_balance": "可用余额",
            "total_balance": "合计",
            "no_account_info": "暂无账户信息",
            "account_tab": "我的账户",
            "account_tab_now": "当前账户管理",
            "kyc_tab": "实名认证管理",
            "collection_tab": "收款",
            "withdraw_tab": "提现",
            "payment_tab": "付款",
            "account_transfer_tab": "账户间转账",
            "transaction_query_tab": "交易查询",
            "quota_tab": "额度管理",
            "my_assets": "{name}的资产",
            "current_entity": "当前主体",
            "switch_manage_entity": "切换/管理主体",
            "total_assets": "总资产",
            "manage_button": "管理",
            "apply_overseas_account": "开通一般贸易",
            "bind_ecommerce_shop": "开通跨境电商",
            "withdraw_now": "立即提现",
            "recent_transactions": "最近交易",
            "no_label": "序号",
            "time_label": "时间",
            "transaction_type_label": "交易类型",
            "amount_label": "金额",
            "transaction_fee_label": "交易费用",
            "received_amount_label": "到账金额",
            "payment_cny": "人民币付款",
            "withdrawal_cny": "人民币提现",
            "collection_record": "收款",
            "store_overview": "店铺概览",
            "store_count_info": "您有 {count} 个店铺",
            "pending_store_info": "待入账店铺  {count} 个",
            "all_button": "全部",
            "notifications": "通知公告",
            "payment_rate_title": "汇率试算",
            "payment_rate_go_exchange": "去换汇",
            "payment_rate_caption": "根据当前客户的外币付款汇率换算",
            "payment_rate_source_currency": "卖出",
            "payment_rate_target_currency": "买入",
            "payment_rate_amount": "输入金额",
            "payment_rate_result": "换算结果",
            "payment_rate_swap": "互换币种",
            "payment_rate_label": "试算汇率",
            "payment_rate_currency_placeholder": "请选择",
            "payment_rate_no_currency": "暂无可用币种",
            "payment_rate_invalid_amount": "请输入有效的非负金额",
            "payment_rate_currency_error": "币种加载失败",
            "payment_rate_convert_error": "暂时无法获取付款汇率",
            "payment_rate_retry": "重试",
            "bank_holiday_title": "假期日历",
            "bank_holiday_month_suffix": "月",
            "bank_holiday_loading": "正在加载假期…",
            "bank_holiday_error": "假期加载失败，请重试",
            "bank_holiday_retry": "重试",
            "bank_holiday_empty": "当日暂无银行假期",
            "account_upgrade_notice": "账户升级提醒",
            "infinia_service_notice": "INFINIA 事务区公告",
            "market_rate": "市场汇率",
            "flip_rate": "一键翻转汇率",
            "rate_hint": "汇率仅供参考，实际汇率以交易页面显示为准",
            "boc_latest_rate": "中行最新的价格信息",
            "copyright": "版权所有",
            "about_us": "关于我们",
            "contact_manager": "联系客户经理",
            "title_switch_account": "切换账户",
            "label_select_account": "请选择账户",
            "link_create_new_account": "创建新账户",
            "account_filter_tooltip_show_all": "显示所有账号",
            "account_filter_tooltip_show_verified_only": "仅显示已实名账号",
            "label_nickname": "昵称：",
            "label_account_number": "账号号码：",
            "tag_not_verified": "未实名",
            "tag_pending_review": "待审核",
            "button_set_default": "设为默认",
            "button_cancel": "取 消",
            "button_confirm_switch": "切换账户",
            "tag_approved": "审核通过",
            "button_default_account": "默认账户",
            "menu_switch_account": "切换账号",
            "menu_user_center": "用户中心",
            "menu_logout": "退出登录",
            "locale_simplified_chinese": "简体中文",
            "locale_english": "English",
            "mobile_side_menu_title": "菜单",
            "label_business_reg_no": "商业登记号码：",
            "label_cert_expire_status": "证件过期状态：",
            "cert_status_expired": "已过期",
            "cert_status_valid": "未过期",
            "message_account_switched": "切换成功",
            "modal_title_service": "服务开通",
            "modal_greeting": "亲爱的",
            "modal_message": " 您好，我们为您精心准备了多种服务来满足您",
            "button_activate_now": "立即开通",
            "page_title_login": "登录 Infinia 账户",
            "button_back_infinia": "返回Infinia",
            "guide_title": "新手指南",
            "step_1_title": "用户注册",
            "step_1_status": "已完成",
            "step_2_title": "设置账户持有人",
            "step_2_status": "已完成",
            "step_3_title": "实名认证",
            "step_3_status": "已完成",
            "step_4_title": "开通业务",
            "step_4_title_1": "",
            "step_4_status": "已完成",
            "step_5_title": "入账成功",
            "step_5_status": "等待入账",
            "step_action_status": "去完善",
            "business_dialog_title": "开通业务",
            "business_ecommerce": "电商平台",
            "business_general_trade": "一般贸易",
            "title_register_infinia": "注册 Infinia 账户",
            "text_no_transaction": "暂无交易",
            "title_user_confirm_info": "用户确认信息",
            "checkbox_agree_statement": "我已阅读并同意",
            "link_statement": "申明",
            "tips_description": "总资产：将所有多币种账户余额按当前汇率折算为CNH后的总金额。",
            "menu_account_manager": "账户持有人管理",
            "nav_payment_batch": "批量结汇",

        },
        "createVa": {
            "title": "申请收款账户",
            "title_supplement": "补件",
            "notice_1": "1、收款人姓名须与银行账户姓名匹配，否则审核驳回或延误收款。",
            "notice_2": "2、建议使用一类银行卡，避免二类卡提现异常",
            "notice_3": "3、审核预计3-5个工作日完成，审核后可对该收款人进行付款",
            "section_basic": "基础信息",
            "section_supplement": "补件",
            "label_kyb": "所属业务",
            "label_account_name": "收款账户名称",
            "label_holder": "账户持有人",
            "label_quantity": "申请数量",
            "label_va_region": "收款账户开立地区",
            "label_bank": "开户银行",
            "label_currency": "申请币种",
            "label_description": "说明",
            "label_upload_material": "上传材料",
            "text_trade_material_upload": "贸易真实性材料",
            "text_material_later_tip": "收款人已添加，若材料未准备齐全，后续可在收款人管理列表中补充材料",
            "placeholder_select": "请选择",
            "placeholder_input": "请输入",
            "text_agree": "我已阅读并同意",
            "text_statement": "《申明》",
            "validation_select": "请选择",
            "validation_input": "请输入",
            "validation_upload_material": "请上传材料"
        },
        "payee": {
            "nav_collection": "店铺列表",
            "nav_store_manage": "店铺集中管理",
            "nav_order_manage": "收款订单",
            "nav_business_open_record": "一般贸易开通记录",
            "nav_cross_border_ecommerce_record": "跨境电商开通记录",
            "nav_va_manage": "收款账户",
            "tab_collection_account": "收款账户",
            "tab_collection_account_detail": "收款账户明细",
            "column_va_account_no": "账户号码",
            "column_va_account_name": "账户名称",
            "column_open_account_count": "开户数量",
            "column_payment_type": "付款方式",
            "column_bank_country_region": "银行所在国家地区",
            "label_account_no": "账号",
            "placeholder_account_no": "请输入账号",
            "label_account_holder_name": "户名",
            "placeholder_account_holder_name": "请输入户名",
            "title_business_open_record": "业务开通记录",
            "label_business_name": "业务名称：",
            "placeholder_business_name": "请输入业务名称/平台名称",
            "label_business_type": "业务类型：",
            "label_business_type_plain": "业务分类:",
            "label_business_line": "业务线:",
            "label_status_text": "状态：",
            "column_kyb_no": "KYB编号",
            "column_business_name": "业务名称",
            "column_business_type1": "业务线",
            "column_business_type": "业务类型",
            "column_industry_category": "行业分类",
            "column_bank_platform": "银行/地区",
            "column_bank_region": "收款银行地区",
            "column_bank_name": "收款银行",
            "column_main_business_region": "主要业务地区",
            "column_apply_time": "申请时间",
            "action_continue_open": "继续开通",
            "action_apply_va": "申请收款账户",
            "action_resubmit": "重新提交",
            "action_supplement": "补件",
            "status_passed": "已通过",
            "status_rejected": "已驳回",
            "status_pending_review": "待审核",
            "status_expired": "已失效",
            "business_status_init": "初始化",
            "business_status_process": "审核中",
            "business_status_passed": "审核通过",
            "business_status_close": "关闭",
            "business_status_supplement": "补件",
            "business_status_rejected": "审核拒绝",
            "business_status_finished": "成功",
            "status_init_open_supplement": "入网待补件",
            "status_init_va_supplement": "开户待补件",
            "status_reject_open_supplement": "入网补件审核驳回",
            "status_reject_va_supplement": "开户补件审核驳回",
            "status_va_init": "待处理",
            "status_va_process": "处理中",
            "status_va_supplement_init": "待补件",
            "status_va_supplement_process": "客户待补件",
            "status_va_supplement_pending": "补件审核",
            "status_va_supplement_reject": "补件拒绝",
            "status_va_finished": "成功",
            "status_va_failed": "失败",
            "account_status_init": "待处理",
            "account_status_process": "处理中",
            "account_status_pending_doc": "待补件",
            "account_status_success": "成功",
            "account_status_fail": "失败",
            "account_status_close": "已关闭",
            "business_line_goods": "货贸",
            "business_line_services": "服贸",
            "nav_shop_holder_manage": "店铺持有人",
            "table_amount": "余额",
            "table_status": "状态",
            "action_edit": "编辑",
            "breadcrumb_collection": "首页 / 收款",
            "kyc_tips_text": "未完成实名认证，为了不影响资金后续入账或相关操作，请及时完成实名认证",
            "title_collection_store": "收款账户/店铺",
            "store_status_label": "状态：",
            "store_status_all": "全部",
            "store_status_normal": "正常",
            "store_status_pending": "审核中",
            "store_status_rejected": "审核拒绝",
            "label_platform": "经营平台：",
            "label_currency": "币种：",
            "label_search": "账户/店铺名称：",
            "search_placeholder": "请输入",
            "button_search": "搜索",
            "button_business_open": "业务开通",
            "button_apply_overseas_account": "开通业务",
            "button_bind_shop": "绑定店铺",
            "button_apply_va": "申请VA",
            "store_overview": "店铺概览",
            "store_total_count": "您有 3 个店铺",
            "store_pending_count": "待入驻店铺数 0 个",
            "table_store_name": "店铺名称",
            "table_shop_url": "店铺网址",
            "table_currency": "币种",
            "table_expected_month_turnover": "预计月营业额",
            "table_expected_year_turnover": "预计年营业额",
            "table_business_scope": "经营范围",
            "table_shop_holder": "店铺持有人",
            "table_shop_screenshot": "店铺截图",
            "table_collection_account": "收款账户",
            "table_platform_name": "平台名称",
            "table_platform_name_b2b": "业务线",
            "table_available_amount": "可提现金额",
            "table_quota": "可结汇额度",
            "table_pending_amount": "待入账金额",
            "table_store_status": "账户/店铺状态",
            "table_actions": "操作",
            "action_view_detail": "查看详情",
            "message_no_detail_id": "缺少详情查询参数",
            "action_apply_collection_account": "申请收款账户",
            "action_view_orders": "查看订单",
            "button_batch_close": "批量关闭",
            "confirm_close_title": "关闭提示",
            "confirm_close_message": "VA账号关闭后不可使用且不可恢复，确认关闭吗？",
            "button_confirm_close": "确认关闭",
            "message_batch_close_select_first": "请先勾选需要关闭的电商平台店铺",
            "message_batch_close_success": "提交成功",
            "message_batch_close_fail": "关闭失败，请稍后重试",
            "pagination_page_1": 1,
            "b2b_text": "一般贸易",
            "collection_text": "电商平台",
            "bindOther": {
                "id_card": "身份证",
                "passport": "护照",
                "message_upload_file": "请上传文件",
                "title": "申请收款账号",
                "section_business_open": "业务开通",
                "section_account_apply": "收款账户申请",
                "section_supplement_material": "补充KYC/渠道必审资料",
                "section_business_supplement": "业务补充资料",
                "validation_enter_supplement_field": "请完善{title}",
                "validation_upload_supplement_field": "请上传{title}",
                "label_review_comment": "审核意见:",
                "label_business_type": "业务类型",
                "label_main_business_country": "主要业务所在国家/地区",
                "label_expected_turnover": "预计月营业额",
                "placeholder_expected_turnover": "请选择预计月营业额区间",
                "option_turnover_lt_50k": "小于 5 万",
                "option_turnover_50k_200k": "5 万 - 20 万",
                "option_turnover_200k_500k": "20 万 - 50 万",
                "option_turnover_gt_500k": "大于 50 万",
                "label_shop_url": "经营网址",
                "placeholder_shop_url": "请输入或粘贴网址或官网",
                "label_fundin_country": "入金交易最频繁的国家",
                "label_fundout_country": "出金交易最频繁的国家",
                "label_account_name": "收款账户名",
                "placeholder_account_name": "收款账户名",
                "label_bank_region": "收款银行地区",
                "placeholder_bank_region": "请选择收款银行地区",
                "label_bank_name": "收款银行",
                "placeholder_bank_name": "请选择收款银行",
                "label_account_currency": "收款账户币种",
                "placeholder_account_currency": "请选择申请开通账户的币种",
                "label_region_address_en": "注册地址英文",
                "placeholder_region_address_en": "请输入注册地址英文",
                "label_business_address_en": "经营地址英文",
                "placeholder_business_address_en": "请输入经营地址英文",
                "label_trade_type": "贸易类型",
                "trade_type_self_export": "自营出口",
                "trade_type_agent_export": "代理出口",
                "label_qualification_upload": "资质文件上传",
                "text_qualification_upload": "请上传相关资质文件",
                "label_legal_hold_photo": "法人手持证件照",
                "text_trade_material_upload": "贸易真实性材料",
                "text_material_later_tip": "收款人已添加，若材料未准备齐全，后续可在收款人管理列表中补充材料",
                "label_remark": "备注",
                "label_supplement_legal_hold": "补充法人手持证件照",
                "legal_person": "法人",
                "ubo_person": "受益人",
                "auth_signer_person": "代理人",
                "supplement_legal_hold_format": "{name}{category}的手持{type}",
                "text_supplement_legal_hold": "请上传法人手持证件照",
                "label_supplement_hk_corp_form": "补充法团成立表",
                "text_supplement_hk_corp_form": "请上传法团成立表",
                "label_supplement_hk_equity_diagram": "补充股权架构图",
                "text_supplement_hk_equity_diagram": "请上传股权架构图",
                "text_agree": "我已阅读并同意",
                "text_statement": "《申明》",
                "button_submit": "提交申请",
                "message_submit_success": "提交成功",
                "message_submit_failed": "提交失败",
                "validation_agree_statement": "请阅读并同意《申明》",
                "validation_select_business_type": "请选择业务类型",
                "validation_select_main_business_country": "请选择主要业务所在国家/地区",
                "validation_select_expected_turnover": "请选择预计月营业额",
                "validation_enter_shop_url": "请输入经营网址",
                "validation_url_format": "请输入正确的网址格式",
                "validation_select_fundin_country": "请选择入金交易最频繁的国家",
                "validation_select_fundout_country": "请选择出金交易最频繁的国家",
                "validation_select_bank_region": "请选择收款银行地区",
                "validation_select_bank_name": "请选择收款银行",
                "validation_select_currency": "请选择收款账户币种",
                "validation_enter_region_address_en": "请输入注册地址英文",
                "validation_enter_business_address_en": "请输入经营地址英文",
                "validation_enter_account_name": "请输入收款账户名",
                "validation_select_trade_type": "请选择贸易类型"
            },
            "businessOpenRecordDetail": {
                "title": "详情",
                "basic_info": "基本信息",
                "address_info": "地址信息",
                "material_info": "材料信息",
                "label_kyb_no": "KYB编号",
                "label_status": "状态",
                "label_business_type": "业务类型",
                "label_business_line": "业务线",
                "label_industry_category": "行业分类",
                "label_industry_subcategory": "行业小类",
                "label_account_name": "收款账户名",
                "label_main_business_country": "主要业务所在国家/地区",
                "label_shop_url": "经营网址",
                "label_fundin_country": "入金交易最频繁的国家",
                "label_fundout_country": "出金交易最频繁的国家",
                "label_trade_type": "贸易类型",
                "label_expected_turnover": "预计月营业额",
                "label_apply_time": "申请时间",
                "label_region_address_en": "注册地址英文",
                "label_business_address_en": "经营地址英文",
                "label_remark": "审核意见:",
                "label_remark_plain": "备注",
                "action_open_file": "查看",
                "action_back": "返回",
                "no_file": "暂无材料",
                "empty": "暂无详情",
                "load_failed": "详情加载失败，请稍后重试"
            },
            "button_upLoad": "上传",
            "button_errorFileDownload": "错误文件下载",
            "button_addQuota": "新增额度",
            "validation": {
                "rule_select_payout_method": "请选择到账方式",
                "rule_input_payee_name": "请输入收款人户名",
                "rule_select_type": "请选择对公/对私",
                "rule_select_bank_country": "请选择银行所在地",
                "rule_select_currency": "请选择币种",
                "rule_input_bank_name": "请输入收款银行名称",
                "rule_input_card_no": "请输入收款银行账号",
                "rule_card_no_pattern": "银行卡号不允许包含特殊字符",
                "rule_input_swift": "请输入SWIFT/BIC编码",
                "rule_swift_pattern": "SWIFT格式错误",
                "rule_input_branch": "请输入详细开户行",
                "rule_input_legal_name": "请输入法人名称",
                "rule_input_legal_id": "请输入法人身份证号",
                "rule_select_legal_country": "请选择法人国籍",
                "rule_input_bank_address": "请输入开户行地址",
                "rule_input_payee_city": "请输入地址",
                "rule_input_postal_code": "请输入",
                "rule_postal_code_pattern": "只能输入数字或英文字母",
                "rule_input_bank_code_3digits": "请输入3位数字",
                "rule_beneficiary_half_width": "仅支持英文字母、数字、半角空格及 - ? : ( ) . , ' +，不能包含全角字符或以 - 开头",
                "rule_remit_invalid_chars": "交易附言仅支持英文字母、数字、空格以及以下字符：/ - ? : ( ) . , ' +",
                "rule_remit_dash_start": "不能以连字符(-)开头",
                "rule_remit_colon_start": "不能以冒号(:)开头",
                "rule_cert_expire_min_today": "有效期不能小于当日",
                "rule_fill_bank_name_first": "请先填写收款银行名称"
            },
            "bindShop": {
                "rule_platform_required": "请输入店铺所在平台",
                "rule_name_required": "请输入店铺名称",
                "rule_url_required": "请输入店铺链接",
                "rule_owner_required": "请选择持有人",
                "rule_currency_required": "请选择币种",
                "rule_agree_protocol": "请阅读并同意《申明》",
                "label_store_address": "店铺地址",
                "label_monthly_turnover": "预计月营业额",
                "label_annual_turnover": "预计年营业额",
                "placeholder_annual_turnover": "请输入预计年营业额（{currency}）",
                "label_shop_holder": "店铺持有人",
                "label_shop_screenshot": "店铺截图",
                "upload_suffix_shop_screenshot_with_url": "店铺截图（含网址）",
                "label_owner": "店铺持有人（文本）",
                "label_operator": "操作人",
                "label_category": "业务分类",
                "rule_address_required": "请输入店铺地址",
                "rule_address_invalid": "请输入合法网址（http/https开头，且以指定后缀结尾）",
                "rule_monthly_turnover_required": "请选择预计月营业额",
                "rule_annual_turnover_required": "请输入预计年营业额",
                "rule_holder_required": "请选择店铺持有人",
                "confirm_apply_title": "申请提示",
                "confirm_apply_message": "请确认店铺信息无误后提交申请。",
                "confirm_apply_fee_message": "开通VA账号会产生相关费用，确认申请吗?\n({openFeeTypeDesc}{openFeeAmount}{openFeeCurrencyCode}/个，{mgmtFeeTypeDesc}{mgmtFeeAmount}{mgmtFeeTypeCurrencyCode}/个)",
                "fee_type_open": "开户费",
                "fee_type_mgmt": "管理费",
                "confirm_apply_confirm": "确认申请",
                "confirm_apply_cancel": "取消",
                "turnover_lt_100k": "月交易量10万美元以下",
                "turnover_100k_300k": "月交易量10万（含）-30万美元",
                "turnover_300k_500k": "月交易量30万（含）-50万美元",
                "turnover_gte_500k": "月交易量50万（含）美元以上",
                "label_expected_turnover_year": "预计年营业额",
            },
        },
        "payment": {
            "page_title": "付款",
            "label_available_amount": "可付款金额：",
            "label_available_amount_b2b": "可结汇额度：",
            "label_business_type": "业务类型",
            "label_platform": "平台",
            "label_account_currency": "账户币种",
            "section_amount_verify": "金额核对",
            "button_prev_step": "上一步",
            "breadcrumb_payment": "首页 / 付款",
            "step_fill_info": "填写支付信息",
            "step_verify_info": "核对支付信息",
            "step_complete": "完成",
            "section_payment_info": "付款信息",
            "label_select_business_type": "请选择业务类型",
            "label_select_platform": "选择平台：",
            "platform_all": "全部",
            "platform_trade": "一般贸易",
            "platform_joom": "Joom Platform",
            "platform_wildberries": "Wildberries",
            "label_select_account": "收款账户：",
            "placeholder_select_account": "请选择收款账户",
            "placeholder_select_shop": "请选择店铺",
            "link_manage_recipient": "收款人管理",
            "table_store_name": "店铺名称",
            "table_available_balance": "可用余额",
            "table_available_balance_label": "可结汇额度",
            "table_payment_amount": "付款金额",
            "placeholder_amount": "请输入金额",
            "placeholder_enter_amount": "请勾选此行后输入金额",
            "label_order_note": "订单备注：",
            "order_note": "订单备注",
            "placeholder_order_note": "请输入订单备注，方便日后查询",
            "tip_order_note": "仅用于订单记录，不会发送给收款方。",
            "label_total_amount": "付款总金额",
            "button_next": "下一步",
            "credit_insufficient_title": "提示",
            "credit_insufficient_message": "结汇额度不足，请上传订单材料补充结汇额度。",
            "credit_insufficient_confirm": "跳转",
            "title_verify_info": "请核对您的付款信息无误后进行安全验证",
            "section_payee_info": "收款人信息",
            "section_payer_info": "付款人信息",
            "label_payee_name": "收款人昵称：",
            "label_bank_account_name": "银行名称账户：",
            "label_bank_name": "银行名称：",
            "label_account_number": "收款银行账号：",
            "section_amount_summary": "金额汇总",
            "label_payment_amount": "付款金额：",
            "label_exchange_rate": "汇率：",
            "label_total_pay_amount": "付款总金额：",
            "label_shop_total_amount": "店铺余额：",
            "label_credit_total_amount": "店铺结汇额度：",
            "label_total_pay_count": "总付款笔数：",
            "file_parse_fail_title": "文件解析失败",
            "file_parse_fail_text": "文件解析失败：",
            "download_error_file": "下载错误文件",
            "file_upload_success_title": "文件上传成功",
            "email_verify": "邮箱验证：",
            "send_verify_code": "发送验证码",
            "email_code_sent_tip": "已发送（有效期5分钟）",
            "send_success": "已发送",
            "label_fee": "费用合计：",
            "section_date_note": "日期和备注",
            "label_transaction_date": "交易日期：",
            "label_security_code": "安全验证码",
            "placeholder_security_code": "请输入验证码",
            "button_get_code": "Verification Code",
            "link_resend_code": "更换邮箱验证",
            "note_code_sent": "为了账户安全，验证码已发送至",
            "button_back_return": "返回修改",
            "label_total_payment": "付款总金额：",
            "label_expected_arrival": "到账金额：",
            "button_submit": "提交",
            "breadcrumb_beneficiary_manage": "首页 / 付款 / 收款人管理",
            "title_beneficiary_manage": "收款人管理",
            "status_all": "全部",
            "status_approved": "审核成功",
            "status_rejected": "审核失败",
            "status_pending": "审核中",
            "status_to_complete": "待完善",
            "label_search": "搜索：",
            "placeholder_enter_name": "请输入收款人姓名",
            "button_add_beneficiary": "添加收款人",
            "table_beneficiary_id": "收款人ID",
            "table_beneficiary_name": "收款人姓名",
            "table_bank_name": "银行名称",
            "table_account_number": "收款账号",
            "table_status": "收款人状态",
            "table_action": "操作",
            "action_delete": "删除",
            "refuse_reason": "拒绝原因",
            "reason_for_refuse": "原因",
            "action_edit_info": "编辑信息",
            "action_edit_material": "编辑材料",
            "action_submit_material": "提交资料",
            "title_add_beneficiary": "新增收款人",
            "note_approval_time": "审核预计3-5个工作日完成，审核后可对该收款人进行付款",
            "note_name_match_warning": "收款人姓名须与银行账号信息匹配，否则会导致审核失败",
            "note_use_primary_bank": "建议使用一类银行卡，避免二类卡提现异常",
            "section_basic_info": "基础信息",
            "label_bank_country": "银行所在地区",
            "label_account_name": "户名",
            "label_account_type": "账户类型",
            "option_corporate": "企业对公",
            "option_individual": "个人对私",
            "label_remark_name": "账户昵称",
            "section_bank_info": "银行账户信息",
            "label_beneficiary_bank": "收款银行名称",
            "label_account_number_full": "收款账号",
            "label_branch_name": "详细开户行",
            "label_currency": "币种",
            "label_swift_code": "SWIFT编码",
            "section_beneficiary_info": "收款人信息",
            "label_uscc": "统一社会信用代码",
            "label_legal_name": "法人名称",
            "label_legal_id_number": "法人身份证号",
            "label_id_number": "收款人身份证号",
            "label_legal_nationality": "法人国籍",
            "label_address": "详细经营地址",
            "button_cancel": "取消",
            "button_confirm_submit": "确认添加",
            "note_review_time": "审核预计3-5个工作日完成，通过后可对该收款人进行付款",
            "note_name_account_match": "收款人姓名须与银行账号信息匹配，否则会导致审核失败",
            "note_use_tier1_card": "建议使用一类银行卡，避免二类卡提现异常",
            "tab_beneficiary_info": "收款人信息",
            "tab_trade_doc": "上传贸易材料",
            "note_trade_doc_required": "仅添加的收款人仍需提交",
            "label_recipient": "收款人",
            "label_note_choose_doc_type": "请选择与收款人的贸易类型并提交相关材料，审核通过后可发起付款",
            "placeholder_select_type": "请选择",
            "label_upload_trade_doc": "贸易材料",
            "button_upload_doc": "点击上传 贸易单据类附件",
            "note_file_types_supported": "支持的附件格式 jpg, jpeg, png, pdf, zip, rar，文件大小不能超过10MB",
            "button_assign_later": "稍后指定",
            "button_submit_now": "确认提交",
            "note_upload_later": "收款人已添加，若材料未准备齐全，后续可在收款人管理列表中补充材料",
            "title": "补充材料",
            "section_title": "上传贸易材料",
            "beneficiary_label": "收款人",
            "bank_info_label": "招商银行(尾号1|银行所在地：中国)",
            "trade_type_label": "贸易类型",
            "trade_type_placeholder": "请选择与收款人的贸易类型并提交相应材料，审核通过后可发起付款",
            "trade_type_option": "电商平台业务",
            "upload_label": "贸易材料",
            "upload_link_trade_doc": "贸易真实性材料",
            "delete_button": "删除",
            "download_link": "下载已上传贸易材料",
            "cancel_button": "取消",
            "submit_button": "确认提交",
            "footer_note": "收款人已添加，若材料未准备齐全，后续可在收款人管理列表中补充材料",
            "bank_address": "开户行地址",
            "beneficiary_info_label": "收款人信息",
            "beneficiary_city": "收款方城市",
            "beneficiary_address": "收款方地址",
            "postal_code": "邮编",
            "confirm_edit_button": "确认编辑",
            "bulk_upload": "批量结汇",
            "bulk_upload_label": "批量上传",
            "bulk_currency_cnh": "离岸人民币",

            "single_payment": "单笔付款",
            "template_download": "模板下载",
            "store_list": "店铺列表",
            "store_list_placeholder": "收款账户",
            "store_list_placeholder1": "批量结汇文件",
            "security_verification": "安全验证",
            "security_input_placeholder": "请输入验证码",
            "send_code_button": "发送验证码",
            "switch_to_email_verify": "更换邮箱验证",
            "Switch_to_SMS_Verification": "更换短信验证",
            "sms_notice": "验证码将发送至",
            "safety_tip": "为了账户安全，请完成验证进行操作",
            "account_currency": "账户币种：",
            "label_payment_method": "付款方式：",
            "add_account_transfer_recipient": "添加Infinia账户间转账收款人",
            "greeting": "尊敬的客户",
            "successMessage": "操作成功",
            "returnButton": "返回",
            "infiniaAccountNo": "infinia账户号：",
            "paymentMethod": "支付方式：",
            "recipientName": "收款人姓名：",
            "accountToAccountTransfer": "账户间转账",
            "infiniaAccountTransfer": "Infinia账户间转账",
            "payMentSelect":"付款",
            "tag_shop_expire": "过期",
            "tag_shop_merge": "归集",
            "getVerificationCode": "获取验证码",
            "isPobo": "POBO",
            "isPobo_tooltip": "收款人收到资金时，显示的付款人名称为",
            "payer_name": "付款人名称",
            "payer_name_tip": "当同名pobo付款时，需选择付款人；若没有选择，则会默认展示PAYEASE及合作伙伴信息",
            "payer_name_default_display": "payease或payease的合作方",
            "payer_name_placeholder": "请选择付款人名称",
            "payer_management": "付款人管理",
            "add_payer": "新增付款人",
            "swift_payment_info_title": "SWIFT 付款信息",
            "pobo_payer_name": "付款人名称（POBO）",
            "specify_payer_name": "指定付款人名称",
            "specify_payer_name_help": "开启后，收款方将看到你指定的付款人名称；关闭后不指定，收款方看到的名称由实际付款方式决定。",
            "payer_picker_subtitle": "可使用当前主体英文名，或选择已添加并审核通过的付款人",
            "payer_search": "搜索",
            "payer_search_placeholder": "请输入企业英文名称",
            "payer_current_entity": "当前主体",
            "payer_added_payers": "已添加付款人",
            "payer_registration_no": "注册号",
            "payer_current_entity_english_name": "当前主体英文名",
            "payer_added": "已添加",
            "payer_no_match": "暂无匹配的付款人",
            "payer_name_unspecified": "不指定付款人名称",
            "payer_default_display_name": "PAYEASE 或合作伙伴名称",
            "payer_default_name_tip": "默认显示 PAYEASE 或合作伙伴名称",
            "payer_verified_name_tip": "当前实名主体的企业英文名称",
            "trade_material": "贸易材料",
            "trade_material_help": "为核实本次交易背景，请上传付款人与收款人之间的合同、发票等贸易材料。上传后可继续付款，无需等待审核。",
            "trade_material_upload": "POBO付款方与收款人之间的交易背景证明材料（如合同、发票等，需经双方签署或盖章确认）",
            "trade_material_required": "请上传贸易材料",
            "payment_purpose": "付款用途",
            "payment_purpose_help": "请选择与本次付款实际交易内容相符的付款用途。",
            "payment_purpose_placeholder": "请选择付款用途",
            "payment_purpose_required": "请选择付款用途",
            "swift_remittance": "交易附言",
            "remittanceInfo": "交易附言：",
            "placeholder_remittance_info": "请输入付款附言，方便收款方核对款项",
            "tip_remittance_info": "附言可能显示在收款方银行流水中，请避免使用特殊字符，以免显示不完整。",
            "remittance_info_error": "Transaction remark contains sensitive content.",
            "default_label": "默认",

        },
        "poboPayer": {
            "management_title": "付款人管理",
            "add_button": "新增付款人",
            "search_label": "搜索",
            "search_placeholder": "企业英文名称或注册号",
            "company_english_name": "企业英文名称",
            "company_english_name_placeholder": "请输入企业注册英文名称",
            "company_english_name_invalid": "支持字母、数字、英文空格及 / ( ) . , - ? : '，且不能为纯数字",
            "company_original_name": "企业原始名称",
            "company_original_name_placeholder": "请输入注册证明上的企业原始名称",
            "country_region": "注册国家/地区",
            "country_registration": "注册国家/地区",
            "province": "省",
            "province_state": "省 / 州",
            "city": "市",
            "post_code": "邮编",
            "registered_address": "注册地址",
            "registered_address_placeholder": "请输入证件上的注册地址（英文）",
            "registered_address_invalid": "支持字母、数字、英文空格及 / ( ) . , - ? : ' +，且不能为纯数字",
            "registration_no": "注册号",
            "credit_code": "统一社会信用代码",
            "br_number": "商业登记证（BR）号码",
            "registration_date": "注册日期",
            "business_license": "营业执照",
            "business_registration_certificate": "商业登记证",
            "company_registration_certificate": "公司注册证书或同等效力官方注册证明",
            "upload_hint": "支持 JPG、JPEG、PNG、PDF，文件不超过 20 MB。",
            "upload_required": "请上传注册证明",
            "status": "状态",
            "status_all": "全部",
            "status_approved": "审核通过",
            "status_pending": "处理中",
            "status_rejected": "审核拒绝",
            "submitted_at": "提交时间",
            "action": "操作",
            "reject_reason": "拒绝原因",
            "edit_resubmit": "修改并重新提交",
            "review_comments": "审核意见",
            "no_data": "暂无付款人资料",
            "add_page_title": "新增 POBO 付款人",
            "edit_page_title": "修改付款人资料",
            "submit": "提交审核",
            "resubmit": "重新提交审核",
            "load_failed": "付款人资料加载失败",
            "detail_load_failed": "付款人资料加载失败",
            "submit_success": "付款人资料已提交审核",
            "submit_failed": "付款人资料提交失败"
        },
        "shopManage": {
            "nav_store_central_manage": "店铺集中管理",
            "breadcrumb_store_central": "首页 / 收款 / 店铺集中管理",
            "page_title_store_manage": "店铺集中管理",
            "page_subtitle": "在不改变店铺所有权的前提下，将A用户下授权店铺对应的回款实时迁移至B用户下，实现资金在B用户下统一管理。",
            "section_tips_title": "温馨提示",
            "tip_1": "实时转账：被集中管理的店铺收款将自动转入接收方账户",
            "tip_2": "实名认证：发起方与接收方均需完成实名认证",
            "tip_3": "无在途交易：店铺需审核通过，且在途款或提现中的款项",
            "tip_4": "费率独立：发起方的收款费率不会同步至接收方",
            "tip_5": "额度独立：发起方的店铺额度不会同步至接收方",
            "tip_6": "角色互斥：同一主体不可同时作为发起方和接收方",
            "section_manage_tips_title": "操作流程",
            "tip_1_1": '发起方提交集中管理申请。',
            "tip_1_2": '接收方需在【集中管理记录】中确认接收，方可生效。',
            "tip_1_3": '管理成功后，接收方可在【集中管理店铺】中随时取消管理权限。',
            "tab_initiate_manage": "发起集中管理",
            "tab_view_managed_store": "查看集中管理店铺",
            "tab_view_manage_records": "查看集中管理记录",
            "search_placeholder": "请输入店铺名称或账号",
            "select_all_button": "全选",
            "table_column_owner": "主体名称",
            "table_column_store": "店铺名称",
            "table_column_account": "账号",
            "table_column_manageable": "是否可管理",
            "table_value_yes": "是",
            "table_value_no": "否",
            "selected_count_info": "已选中 {count} 条",
            "button_initiate": "发起集中",
            "column_store_name": "店铺名称",
            "column_platform": "站点",
            "column_store_status": "店铺状态",
            "column_pending_amount": "待入账金额",
            "label_time": "时间",
            "placeholder_start_date": "开始日期",
            "placeholder_end_date": "结束日期",
            "label_store_name": "店铺名称",
            "label_status": "状态",
            "dropdown_placeholder": "请选择",
            "button_query": "查询",
            "column_initiator_info": "发起方信息",
            "column_receiver_info": "接收方信息",
            "column_operation_type": "操作类型",
            "column_status": "状态",
            "column_creation_time": "创建时间",
            "column_action": "操作",
            // ----new----
            "confirm_dialog_title": "确认集中",
            "column_entity_name": "主体名称",
            "column_account": "账号",
            "column_phone_placeholder": "接收方手机号",
            "column_entity_name_placeholder": "接收方主体名称",
            "column_verification_code_placeholder": "验证码",
            "note_declaration": "申明：您在授权代理有效期间，我们会要求您更新或补充信息及继续使用本服务。此外，您必须保证您的企业状态仍在存续期间。若您未能向我们提供该等信息或资料，我们会终止您的账户，您的店铺资金将原路退回。",
            "button_confirm_initiate": "确认集中",
            "button_cancel_initiate": "取消",
            "agree_declaration": "同意以上声明和政策条款",

            "rule_phone_placeholder": "请输入接收方手机号",
            "rule_phone_error": "接收方手机号格式有误",
            "rule_phone_required": "接收方手机号不能为空",
            "rule_entity_name_placeholder": "接收方主体名称不能为空",
            "rule_agree_declaration": "请阅读并同意以上声明和政策条款",
            "rule_phone_code_placeholder": "接收方手机号国家区号不能为空",
            "status_pending": "待审核",
            "status_confirmed": "通过",
            "status_rejected": "拒绝",
            "confirm_dialog_title_cancel": "确认取消集中管理吗？",
            "approve_dialog_title": "审核确认",
            "approve_section_security": "安全验证",
            "approve_verification_tip": "为了账户安全，请完成验证进行操作，验证码将发送至 {maskUserInfo}",
            "approve_code_label": "验证码",
            "approve_code_placeholder": "请输入验证码",
            "approve_declaration": "申明：您在接收授权代理期间，我们仍需要您按照合规要求提供必要材料，若您未能向我们提供相关信息或资料，我们有权结束您的授权代理。",
            "approve_agree": "同意以上声明和政策条款",
            "approve_btn_cancel": "取消",
            "approve_btn_confirm": "同意",
            "table_column_control_cancel": "取消集中管理",
            "table_column_control_manage": "管理店铺",
            "operatorTypeMap": {
                "BIND": "绑定",
                "UNBIND": "解绑"
            },
            "please_read_and_agree": "请阅读并同意以上声明和政策条款",
            "please_input_verification_code": "请输入验证码",
            "send_verification_code": "发送验证码",
            "operation_success": "操作成功",
            "confirm_reject": "确认拒绝吗？",
            "button_agree": "同意",
            "button_reject": "拒绝",
        },
        "tradeSeach": {
            "menu_transaction_detail": "交易明细",
            "menu_balance_detail": "资金明细",
            "breadcrumb_transaction_detail": "首页 / 交易查询 ",
            "tab_refund": "退款",
            "label_deposit_time": "收款时间：",
            "placeholder_start_date": "开始日期",
            "placeholder_end_date": "结束日期",
            "label_platform_type": "平台类型：",
            "label_deposit_account": "收款账号：",
            "label_store": "店铺：",
            "table_order_number": "订单号",
            "table_deposit_time": "收款时间",
            "table_bizType_name": "业务类型",
            "table_platform_name": "平台名称",
            "table_store": "店铺",
            "table_payer": "付款方",
            "table_deposit_account": "收款账户",
            "table_collection_amount": "收款金额",
            "table_fee": "交易费用",
            "table_deposit_amount1": "打款金额",
            "table_deposit_amount": "收款金额",
            "table_status": "状态",
            "pagination_total": "Total 4",
            "pagination_page_1": 1,
            "title_balance_detail": "资金明细",
            "label_record_time": "记账时间：",
            "label_fund_direction": "资金方向：",
            "option_all": "全部",
            "table_record_time": "记账时间",
            "table_direction": "交易方向",
            "table_amount": "交易金额",
            "table_balance": "账户余额",
            "table_currency": "币种",
            "table_fund_type": "资金类型",
            "table_transaction_type": "交易类型",
            "value_outbound": "支出",
            "value_inbound": "收入",
            "value_cash": "本金",
            "value_fee": "手续费",
            "value_payment_cny": "人民币付款",
            "value_withdrawal_cny": "人民币提现",
            "value_collection": "收款",
            "page_title_transaction_detail": "交易明细",
            "tab_deposit": "收款",
            "tab_withdraw": "提现",
            "tab_payment": "付款",
            "tab_account_fee": "账户费",
            "tab_transfer": "转账",
            "label_withdraw_time": "提现时间: ",
            "label_transfer_time": "转账时间: ",
            "label_currency": "币种",
            "label_status": "状态: ",
            "label_receiver": "收款方:",
            "button_search": "搜索",
            "button_export": "导出",
            "column_order_number": "提现单号",
            "column_withdraw_time": "提现时间",
            "column_bank_account": "银行账户",
            "column_receiver_bank": "收款银行",
            "column_fee": "交易费用",
            "column_received_amount": "到账金额",
            "column_status": "状态 ",
            "column_status1": "状态: ",
            "column_action": "操作",
            "label_payment_time": "付款时间: ",
            "label_account_fee_order_time": "订单时间:",
            "label_account_fee_type": "费用类型:",
            "label_account_fee_status": "订单状态:",
            "label_account_fee_va_currency": "VA币种:",
            "label_currency_out": "出账币种: ",
            "label_store_name": "店铺: ",
            "label_store_name1": "店铺",
            "label_sender": "转出方/转入方: ",
            "column_payment_order_number": "付款单号",
            "column_account_fee_order_no": "费用单号",
            "column_account_fee_va_account": "VA账号",
            "column_account_fee_va_currency": "VA币种",
            "column_account_fee_type": "费用类型",
            "column_account_fee_amount": "金额",
            "column_account_fee_status": "订单状态",
            "column_account_fee_repaid_amount": "已还款金额",
            "column_account_fee_order_time": "订单时间",
            "column_account_fee_repay_time": "还款时间",
            "column_payment_time": "付款时间",
            "column_payment_amount": "付款金额",
            "column_transfer_order_number": "转账单号",
            "column_transfer_time": "转账时间",
            "column_sender": "转出方",
            "column_receiver": "转入方:",
            "column_receiver1": "转入方",
            "column_amount": "金额",
            "empty_text": "当前暂无交易明细记录",
            "fee_type_open": "开户费",
            "fee_type_mgmt": "账户管理费",
            "status_pending_repayment": "待还款",
            "status_repaid": "已还款",
            "label_platform_order": "平台订单号",
            "beneficiary_bank": "收款方银行",
            "beneficiary_account_no": "收款方账户号",
            "payment_amount_original_currency": "付款金额（原币）",
            "refund_fee_wallet_currency": "退款手续费（钱包币）",
            "refund_net_amount_wallet_currency": "退款净额（钱包币）",
            "payment_initiated_at": "付款发起时间",
            "refund_credited_at": "退款到账时间",
            "status": "状态",
            "remark_bank_response_code": "备注 / 银行反馈码",
            "payment_initiation_time_from_to": "付款发起时间",
            "refund_credited_time_from_to_optional": "退款到账时间",
            "payment_id": "付款单号",
            "refund_id": "退款单号",
            "payment_currency_multi_select": "付款币种",
            "status_success_processing_failed": "状态",
            "beneficiary_name": "收款方名称",
            "status_desc": {
                "NEW": "新建",
                "PENDING": "待处理",
                "PROCESSING": "处理中",
                "SUCCESS": "成功",
                "FAIL": "失败",
                "CANCEL": "退款"
            },
            "page_title_batch_detail": "批次明细",
            "tips_timeRange": "请选择时间范围",
            "export_confirm": "确定要导出吗？",
            "export_success": "操作成功，请到右上角下载中心查看文件下载状态",
            "export_fail": "操作失败",
            "export_button": "导出",
            "export_button_confirm": "确定",
            "export_button_cancel": "取消",
            "see_export_file": "查看导出文件",
            "download_center": "下载中心",
            "no_download_task": "暂无下载任务",
            "delete_confirm": "确定删除吗？",
            "delete_button": "删除",
            "download_button": "下载",
            "status_unknown": "未知状态",
            "status_success": "成功",
            "status_processing": "处理中",
            "status_failed": "失败",
            "start_download_file": "开始下载文件：",
            "delete_success": "删除成功",
            "delete_fail": "删除失败",
            "button_change_card": "换卡",
            "button_download_receipt": "凭证下载",
            "button_download_receipt_batch": "批量下载凭证",
            "button_select_all_receipt": "全选可下载凭证",
            "download_fail": "下载失败",
            "shortcut_today": "今天",
            "shortcut_last_1_month": "近1个月",
            "shortcut_last_3_months": "近3个月",
            "shortcut_last_6_months": "近6个月",
        },
        "kycList": {
            "breadcrumb_realname": "用户中心 / 实名认证",
            "title_realname_auth": "实名认证",
            "button_create_realname_info": "创建新的账号实名信息",
            "table_column_nickname": "账号昵称",
            "table_column_realname_info": "账号实名信息",
            "table_column_create_time": "创建时间",
            "table_column_business_scene": "已开通业务场景",
            "table_column_status": "状态",
            "table_column_error_reason": "错误原因",
            "table_column_action": "操作",
            "tag_unverified": "未实名",
            "tag_pending": "审核中",
            "tag_verified": "已实名",
            "tag_rejected": "实名失败",
            "tag_processing": "实名中",
            "button_start_verification": "去实名",
            "title_add_account": "新增账号",
            "label_nickname": "账号昵称",
            "label_registration_location": "企业/个人注册地址",
            "placeholder_select_location": "请选择",
            "label_user_type": "用户类型",
            "placeholder_select_user_type": "请选择用户类型",
            "checkbox_consent_statement": "本人已同意提供身份信息用于实名认证",
            "button_cancel": "取 消",
            "button_confirm": "确 定",
            "option_enterprise": "企业",
            "option_individual": "个人",
            "doc_hint_enterprise": "请准备以下文件：",
            "doc_business_license": "企业营业执照",
            "doc_legal_id": "法人证件照片（身份证或护照）",
            "doc_agent_id": "授权代理人证件照片（身份证或护照）（若您为授权代理人）",
            "type_joint_stock": "股份有限公司",
            "type_individual_business": "个体工商户",
            "type_wholly_owned": "独资企业",
            "type_limited_liability": "有限责任公司",
            "type_partnership": "合伙企业",
            "doc_hint_individual": "请准备以下文件：",
            "doc_mainland_id_photos": "大陆的永久居民身份证/护照的正反面照片",
            "step_authentication": "实名认证",
            "step_start": "开始",
            "step_basic_info": "基本信息",
            "step_business_info": "经营信息",
            "section_enterprise_cert": "企业证件",
            "label_business_license": "营业执照",
            "upload_hint_business_license": "点击上传 营业执照 Click to upload + Drag here",
            "upload_format_hint": "附件支持 jpg、jpeg、png，文件不超过10MB",
            "label_cert_number": "证件号码",
            "label_cert_issuance_date": "证件注册日期",
            "label_cert_expiry_date": "证件到期日",
            "label_cert_long_term": "长期",
            "section_basic_info": "企业基本信息",
            "label_company_name_cn": "企业中文名称",
            "placeholder_company_name_cn": "请输入企业中文名称",
            "label_company_name_en": "企业英文名称",
            "placeholder_company_name_en": "请输入企业英文名称，如无请填写中文拼音",
            "label_registered_country_area": "注册地址国家/地区",
            "label_registered_province_city": "注册地址城市",
            "label_registered_address": "企业注册地址",
            "placeholder_registered_address": "请输入企业注册地址",
            "label_operational_same_as_registered": "经营地址与注册地址是否相同？",
            "option_yes": "是",
            "option_no": "否",
            "label_operational_country_area": "经营地址国家/地区",
            "label_operational_province_city": "经营地址城市",
            "label_operational_address": "经营地址",
            "placeholder_operational_address": "请输入经营地址",
            "section_attachments": "附件",
            "label_authorization_doc": "授权证明件（选填）",
            "label_other_doc": "其他附件（选填）",
            "upload_hint_general": "点击上传 附件 Click to upload + Drag here",
            "upload_format_hint_general": "附件支持 jpg、jpeg、png、pdf，文件不超过10MB",
            "section_legal_person_info": "企业法人代表信息",
            "label_legal_nationality": "法人代表国籍",
            "label_legal_last_name": "法人代表姓氏",
            "label_legal_first_name": "法人代表名字",
            "label_legal_id_type": "证件类型",
            "label_legal_id_number": "证件号码",
            "label_legal_id_expiry": "证件有效期",
            "label_legal_id_long_term": "长期",
            "label_legal_birthdate": "法人代表生日",
            "label_legal_country_region": "国籍/地区",
            "label_legal_city": "所在城市",
            "section_ubo_info": "最终受益人信息",
            "hint_ubo_info": "最终受益人信息（所有持有≥25%股份或控制的个人，企业填写需至少提供自然人信息）",
            "label_ubo_nationality": "最终受益人国籍",
            "label_ubo_id_type": "证件类型",
            "label_ubo_id_number": "证件号码",
            "label_ubo_id_expiry": "证件有效期",
            "label_ubo_id_long_term": "长期",
            "label_ubo_birthdate": "最终受益人生日",
            "label_ubo_last_name": "最终受益人姓氏",
            "label_ubo_first_name": "最终受益人名字",
            "label_ubo_country_region": "国籍/地区",
            "label_ubo_city": "所在城市",
            "section_agent_info": "授权代理人信息",
            "radio_submitter_role": "资料填写的身份",
            "option_legal_representative": "法人代表本人",
            "option_authorized_agent": "授权代理人",
            "label_ubo2_nationality": "最终受益人国籍",
            "label_ubo2_id_type": "证件类型",
            "label_ubo2_id_number": "证件号码",
            "label_ubo2_id_expiry": "证件有效期",
            "label_ubo2_id_long_term": "长期",
            "label_ubo2_birthdate": "最终受益人生日",
            "label_ubo2_last_name": "最终受益人姓氏",
            "label_ubo2_first_name": "最终受益人名字",
            "label_ubo2_country_region": "国籍/地区",
            "label_ubo2_city": "所在城市",
            "label_agent_nationality": "代理人国籍",
            "label_agent_id_type": "证件类型",
            "label_agent_id_number": "证件号码",
            "label_agent_id_expiry": "证件有效期",
            "label_agent_id_long_term": "长期",
            "label_agent_name": "代理人姓名",
            "label_agent_birthdate": "代理人生日",
            "label_agent_country_region": "国籍/地区",
            "label_agent_city": "所在城市",
            "section_agent_doc_upload": "授权委托书上传",
            "upload_hint_power_of_attorney": "点击上传 授权委托书 Click to upload + 拖拽至此处",
            "upload_format_hint_pdf": "附件支持 jpg、jpeg、png、pdf，文件不超过10MB",
            "button_prev_step": "上一步",
            "button_next_submit": "提交",
            "modal_title_success": "提交成功",
            "step_register": "注册",
            "step_submit_review": "提交资料（审核中）",
            "step_account_activated": "账户激活",
            "status_success": "提交成功",
            "tip_review_notice": "我们将在核查您信息后，请耐心等待，结果会以页面和邮件的方式通知您，请及时关注！",
            "button_back_home": "返回首页",
            "button_update_document": "更新证件",
            "Verification_Status": "审核状态",
            "tag_audit_success": "审核通过",
            "tag_audit_failed": "审核失败",
            "tag_audit_processing": "审核中",
            "tag_audit_not_audit": "未审核",
            "no_need_to_upload_document": "证件正在审核"
        },
        withdraw: {
            "page_title": "提现",
            "title_withdraw_now": "立即提现",
            "label_select_currency": "请选择提现币种：",
            "option_cnh": "离岸人民币/CNH",
            "option_other": "其他",
            "label_select_platform": "请选择提现平台：",
            "label_total_available": "可提现总金额：",
            "table_column_store_name": "店铺名称",
            "table_column_balance": "余额",
            "table_column_withdraw_amount": "提现金额",
            "placeholder_amount": "请输入金额",
            "placeholder_enter_amount": "请勾选此行后输入金额",
            "button_select_all": "全选",
            "label_total_withdraw_amount": "提现总金额：",
            "label_total_withdraw_amount1": "可提现总金额：",
            "button_next_step": "下一步",
            "breadcrumb_withdraw_select_account": "首页 / 我的账户 / 立即提现",
            "title_select_account": "请选择您的收款账户",
            "button_add_new_account": "新增收款账户",
            "table_column_select": "选择",
            "table_column_bank_name": "银行名称",
            "table_column_bank_account_name": "银行账户名称",
            "table_column_account_type": "账户类型",
            "table_column_bank_location": "银行账户所在地",
            "table_column_currency": "账户币种",
            "table_column_account_number": "银行账号",
            "label_withdraw_amount": "提现金额：",
            "label_total_credit_amount": "结汇额度：",
            "label_total_fee": "费用合计：",
            "label_exchange_rate": "汇率：",
            "label_estimated_amount": "预计到账：",
            "label_security_code": "安全验证：",
            "placeholder_enter_code": "请输入验证码",
            "button_get_code": "获取验证码",
            "link_resend_email_code": "更换邮箱验证",
            "link_resend_sms_code": "更换短信验证",
            "note_verification_tip": "为了账户安全，请完成验证后进行操作，验证码将发送至",
            "button_back": "返回上一步",
            "button_confirm_withdraw": "确认提现"
        },
        shopHolder: {
            "holdType": "持有人类型",
            "holdType_personal": "个人",
            "holdType_company": "企业",
            "add_page_title": "添加店铺持有人",
            "detail_page_title": "店铺持有人详情",
            "label_holder_type": "持有人类型",
            "holder_type_personal": "个人",
            "holder_type_enterprise": "企业",
            "label_id_number": "证件号",
            "label_country": "国家地区",
            "label_city": "城市",
            "label_address": "证件地址",
            "label_address_en": "证件英文地址",
            "label_id_front": "身份证（人像面）",
            "label_id_photo": "证件照",
            "label_id_photo_hk": "香港永久性居民身份证",
            "label_id_photo_other": "护照/身份证/驾照",
            "label_id_back": "身份证（国徽面）",
            "label_company_name": "企业名称",
            "label_company_name_en": "企业英文名称",
            "label_registration_no": "证件号",
            "cert_no_tip_cn": "请填写统一社会信用代码",
            "cert_no_tip_non_cn": "请填写境外企业证件号（如注册登记号码）",
            "label_business_license": "企业营业执照图片",
            "hint_select_country_for_docs": "请先选择国家/地区后再上传对应证件",
            "hint_formats_image_pdf": "支持 jpg、jpeg、png、pdf 格式",
            "hint_formats_other_materials": "支持 jpg、jpeg、png、pdf、zip、rar 格式",
            "label_reject_reason": "拒绝原因",
            "button_submit_apply": "提交申请",
            "button_back": "返回",
            "button_view_file": "查看",
            "button_download_file": "下载",
            "label_last_name": "持有人姓",
            "label_last_name_en": "持有人英文姓",
            "label_first_name": "持有人名",
            "label_first_name_en": "持有人英文名",
            "label_status": "持有人状态",
            "button_search": "搜索",
            "button_reset": "重置",
            "button_add": "添加持有人",
            "button_view_detail": "查看详情",
            "button_confirm": "确定",
            "drawer_detail_title": "持有人详情",
            "dialog_add_title": "添加持有人",
            "message_add_success": "添加成功",
            "column_last_name": "持有人姓",
            "column_first_name": "持有人名",
            "rule_no_chinese": "不允许输入中文",
            "column_email": "邮箱",
            "column_status": "持有人状态",
            "column_create_time": "创建时间",
            "column_remark": "备注",
            "status_pending": "审核中",
            "status_normal": "正常",
            "status_rejected": "审核拒绝",
            "button_edit": "编辑",
        },
        addWithdrawAccount: {
            "breadcrumb_add_withdraw_account": "首页 / 我的账户 / 添加提现卡",
            "title_add_new_account": "添加新的提现银行账户",
            "note_security_reminder": "添加的银行账户信息需与认证的信息安全信息保持一致",
            "note_account_match_warning": "收款人姓名须与银行账户姓名匹配，否则审核驳回或延误收款",
            "note": "注",
            "note_doc_warning": "建议使用一类银行卡，避免二类卡提现异常",
            "label_account_type": "账户类型",
            "option_corporate": "对公",
            "option_personal": "对私",
            "label_bank_country": "银行所在国家/地区",
            "label_bank_name": "银行名称",
            "label_bank_branch": "银行支行名称",
            "label_account_name": "账户户名",
            "label_swift_code": "SWIFT/BIC编码",
            "label_bank_account_number": "银行账号",
            "label_bank_iban": "IBAN",
            "label_bank_phone_number": "银行预留手机号",
            "label_bank_address": "开户行地址",
            "label_beneficiary_city": "收款方城市",
            "label_beneficiary_address": "收款方地址",
            "label_beneficiary_postal_code": "邮编",
            "button_back": "返回",
            "button_submit": "提交",
            "bank_branch_detail": "详细开户行",
            "label_is_legal": "是否需要法人信息",
            "label_is_legal_yes": "是",
            "label_is_legal_no": "否",
            "label_transfer_method": "到账方式",
            "option_local_transfer": "本地转账",
            "option_swift_transfer": "SWIFT电汇",
            "tip_local_transfer": "本地银行转账方式，到账时效0-1个工作日",
            "tip_swift_transfer": "国际银行转账方式，到账时效0-3个工作日",
            "label_bank_code": "银行代码",
            "rule_select_payout_method": "请选择到账方式",
            "rule_select_common": "请选择",
            "rule_input_card_no": "请输入银行账号",
            "rule_card_no_pattern": "银行卡号不允许包含特殊字符",
            "rule_input_tel": "请输入手机号",
            "rule_tel_pattern": "只能输入纯数字",
            "rule_input_bank_name": "请输入银行名称",
            "rule_input_swift": "请输入SWIFT/BIC编码",
            "rule_swift_pattern": "SWIFT格式错误",
            "rule_input_branch": "请输入详细开户行",
            "rule_input_bank_address": "请输入开户行地址",
            "rule_input_payee_city": "请输入地址",
            "rule_input_bank_code_3digits": "请输入3位数字",
            "rule_input_postal_code": "请输入",
            "rule_postal_code_pattern": "只能输入数字或英文字母",
            "card_bin_confirm_title": "请核对收款卡号",
            "card_bin_confirm_desc": "您填写的卡号与所选银行不一致，请确认卡号是否填写正确。",
            "card_bin_confirm_selected_bank": "所选银行",
            "card_bin_confirm_card_no": "收款卡号",
            "card_bin_confirm_tip": "如确认银行及卡号填写无误，可继续提交。提交后需经审核，审核通过后方可使用。",
            "card_bin_confirm_back": "返回修改",
            "card_bin_confirm_submit": "确认无误并提交"
        },
        myShop: {
            "breadcrumb_my_store": "首页 / 收款 / 我的店铺",
            "title_my_store": "我的店铺",
            "label_store_name": "店铺名称：",
            "label_account_number": "账 户：",
            "label_platform": "经营平台：",
            "label_pending_settlement": "提现中或结算资金",
            "label_withdrawable_balance": "可提现余额",
            "currency_cnh": "CNH 0.00",
            "breadcrumb_pending_details": "首页 / 收款 / 待入账明细",
            "title_pending_details": "待入账明细",
            "table_column_collection_time": "收款时间",
            "table_column_platform": "经营平台",
            "table_column_store_name": "店铺名称",
            "table_column_order_number": "平台订单号",
            "table_column_total_amount": "收款金额",
            "table_column_pending_amount": "待入账金额",
            "table_column_payer": "付款方",
            "table_column_audit_remark": "审核备注",
            "table_column_actions": "操作",
            "table_no_data": "暂无数据",
            "modal_title_upload_trade_doc": "上传贸易材料",
            "label_platform1": "平台",
            "label_store": "店铺",
            "label_upload_order": "上传贸易材料",
            "label_upload_withdraw_screenshot": "上传提现截图",
            "text_upload_requirement": "文件大小不超过20MB, 支持 xlsx、csv、zip、rar",
            "link_template_download": "模板下载",
            "button_upload_order_doc": "“订单文件”",
            "note_fill_and_upload": "请下载模板并按模板填写后上传",
            "button_upload_other_doc": "“合同、发票、物流单、报关单等业务资料”",
            "button_upload_withdraw_screenshot": "“平台提现截图（含VA账户）”",
            "note_upload_other_doc": "上传相关的卖家之间的合同或发票或结算单据",
            "validation_upload_material": "请上传材料",
            "validation_upload_withdraw_screenshot": "请上传提现截图",
            "modal_title_upload_trade_material": "上传交易材料",
            "section_store_info": "店铺信息",
            "section_material_info": "材料信息",
            "label_store_name_required": "店铺名称",
            "label_store_url": "店铺网址",
            "label_currency": "币种",
            "label_gmv_month": "预计月营业额",
            "label_gmv_year": "预计年营业额",
            "label_product_category": "经营范围",
            "label_store_owner": "店铺持有人",
            "label_shop_screenshot": "店铺截图",
            "label_withdraw_screenshot": "提现截图",
            "label_other_attachment": "其他附件（选填）",
            "upload_suffix_other_attachment": "其他附件",
            "placeholder_input": "请输入",
            "placeholder_store_name": "请选择店铺名称",
            "placeholder_gmv_month": "月交易量10万（含）-30万美元",
            "upload_suffix_shop_screenshot_with_url": "“店铺截图（含网址）”",
            "upload_suffix_withdraw_screenshot_with_va": "“平台提现截图（含VA账号）”",
            "action_add_store": "新增店铺",
            "action_edit_store": "编辑店铺",
            "action_cancel_store_edit": "取消",
            "action_save_store": "保存店铺",
            "hint_store_select": "可选择已有店铺，也可新增店铺后提交本次交易材料",
            "validation_platform": "请选择平台",
            "validation_store_name": "请选择店铺名称",
            "validation_store_url": "请输入店铺网址",
            "validation_currency": "请输入币种",
            "validation_gmv_month": "请输入预计月营业额",
            "validation_gmv_year": "请输入预计年营业额",
            "validation_product_category": "请选择经营范围",
            "validation_store_owner": "请输入店铺持有人",
            "validation_upload_shop_screenshot": "请上传店铺截图",
            "validation_save_store_first": "请先保存店铺信息",
            "validation_missing_kyb_id": "缺少KYB ID，无法查询网点列表",
            "message_store_list_failed": "网点列表查询失败，请稍后重试",
            "message_store_save_success": "店铺保存成功",
            "message_store_save_failed": "店铺保存失败，请稍后重试",
            "modal_title_supplement_material": "补充材料",
            "text_transaction": "交易",
            "text_supplement_subtitle": "请完善网点信息并上传材料",
            "section_branch_info": "网点信息",
            "label_select_branch": "选择网点",
            "placeholder_select_branch": "请选择网点",
            "action_add_branch": "新增网点",
            "action_confirm_add_branch": "确认新增",
            "placeholder_branch_name": "网点名称",
            "placeholder_branch_code": "网点编号",
            "placeholder_branch_region": "所属地区",
            "placeholder_branch_contact": "联系人",
            "placeholder_branch_phone": "联系电话",
            "placeholder_branch_address": "详细地址",
            "section_branch_attrs": "网点属性",
            "status_branch_editable": "可编辑",
            "status_branch_locked": "已锁定",
            "hint_branch_select": "可随时切换网点；选中后根据网点状态决定属性是否可改",
            "hint_branch_editable": "当前网点状态允许修改属性（网点名称除外）",
            "hint_branch_locked": "当前网点状态为已锁定，属性不可修改，仍可切换选择其他网点",
            "section_supplement_material": "补充材料",
            "label_material_type": "材料类型",
            "placeholder_select": "请选择",
            "material_invoice": "发票 / 收据",
            "material_contract": "合同 / 协议",
            "material_id": "身份证明",
            "material_bank": "银行流水",
            "material_other": "其他",
            "label_supplement_remark": "补充说明",
            "placeholder_supplement_remark": "请简要说明材料用途或审核关注点",
            "label_upload_attachment": "上传附件",
            "button_upload_supplement_material": "上传补充材料",
            "validation_select_branch": "请选择网点",
            "validation_select_material_type": "请选择材料类型",
            "validation_branch_name": "请填写网点名称",
            "validation_branch_name_exists": "网点名称已存在",
            "validation_upload_supplement_material": "请上传补充材料",
            "message_supplement_check_failed": "补充材料校验失败，请稍后重试",
            "text_current_store": "当前店铺",
            "button_submit_doc": "确 定",
            "button_cancel_upload": "取 消",
            "breadcrumb_pending_upload": "首页 / 收款 / 待入账明细",
            "title_pending_upload": "待入账明细",
            "column_collection_time": "收款时间",
            "column_platform": "经营平台",
            "column_store_name": "店铺名称",
            "column_order_number": "平台订单号",
            "column_amount": "待入账金额",
            "column_currency": "待入账币种",
            "column_payer": "付款方",
            "column_action": "操作",
            "action_pending_review": "待审核",
            "action_upload": "上传",
            "upFile_tis1": '请确保表格中每个数值都为文本格式。',
            "label_account_info": "我的账户",

            "form_label_1": "户名",
            "form_label_2": "账号",
            "form_label_3": "币种",
            "form_label_4": "付款方式",
            "form_label_5": "银行名称",
            "form_label_6": "银行所在国家",
            "form_label_7": "银行地址",
            "form_label_8": "国际银行账户路由码",
            "form_label_9": "汇路类型",
            "label_account_status": "账户状态",
            "table_column_fee": "手续费",
            "table_column_exchange_rate": "入账汇率",
        },
        shopBinding: {
            "title_bind_account": "绑定 Infinia 账号",
            "modal_title_confirm_info": "确认信息",
            "text_confirm_id": "请确认当前电商平台的卖家主体证件号：",
            "text_change_id_notice": "如需使用其他证件号，请在电商平台后台修改后再重新发起绑定账号。",
            "button_cancel": "取消",
            "button_confirm": "确认",
            "button_bind_now": "确认绑定",
            "title_pre_bind_submitted": "账户预绑定提交！",
            "text_pre_bind_notice": "我们将会优先在1个工作日内处理。请您及时关注相关邮件或者短信通知。",
            "text_auto_assign_notice": "您的实名认证审核通过后，如果信息一致就可以自动为您分配收款账号，开启接入账户和全球付款服务。",
            "button_back_home": "返回首页",
            "msg_binding_done": "该店铺已经绑定完成，请返回电商平台确认",
            "button_return_platform": "返回电商平台",
            "button_return_home": "返回首页",
            "message_loading": '页面加载中，请耐心等待'
        },
        userSettings: {
            "menu_user_settings": "用户设置",
            "menu_account_manager": "专属客户经理",
            "section_entity_info": "实体信息",
            "section_user_info": "用户信息",
            "label_entity_name": "实体名称",
            "label_account_nickname": "账户昵称",
            "label_merchant_no": "商户号",
            "label_bound_phone": "绑定手机",
            "label_bound_email": "绑定邮箱",
            "label_login_password": "登录密码",
            "button_edit": "编辑",
            "modal_bind_email_title": "绑定邮箱",
            "label_email": "邮箱",
            "button_cancel": "取消",
            "button_confirm": "确认",
            "modal_reset_password_title": "重置登录密码",
            "label_current_password": "现有密码",
            "label_new_password": "新密码",
            "label_confirm_password": "确认密码",
            "label_verification_code": "验证码",
            "button_send_code": "发送验证码",
            "notification_code_sent": "验证码将被发送至",
            "page_title_account_manager": "专属客户经理",
            "label_customer_hotline": "客服热线",
            "label_contact_method": "联系方式",
            "label_customer_wechat": "客服微信",
            "step_0_5_status": "去完善",
            "label_identity_status": "当前用户未实名认证",
            "prompt_nickname_title": "请输入昵称",
            "prompt_nickname_tip": "提示",
            "prompt_nickname_error": "昵称格式不正确",
            "message_nickname_success": "修改成功",
            "message_nickname_fail": "修改失败",
            "validation_input_new_password": "请输入新密码",
            "validation_new_password_format_error": "密码格式有误",
            "validation_input_confirm_password": "请输入确认密码",
            "validation_confirm_password_format_error": "确认密码格式有误",
            "validation_confirm_password_not_equal": "确认密码与新密码不相等",
            "validation_input_sms_code": "请输入验证码",
            "validation_input_current_password": "请输入现有密码",
            "validation_get_code_first": "请先获取验证码",
            "message_reset_success": "修改成功",
            "message_reset_fail": "提交失败",
            "validation_input_new_password_placeholder": "请输入新密码",
            "validation_input_confirm_password_placeholder": "请输入确认密码",
            "message_get_user_info_fail": "获取用户信息失败",
        },
        accountHolder: {
            "page_title": "账户持有人管理",
            "form_label_name": "姓名",
            "form_placeholder_name": "请输入姓名",
            "form_label_nationality": "国籍",
            "form_placeholder_nationality": "请选择国籍",
            "form_label_phone": "手机号",
            "form_hint_phone": "带入注册手机号（不许修改，加前缀的）",
            "form_label_id_number": "身份证号",
            "form_label_passport_number": "证件号",
            "form_placeholder_id_number": "请输入身份证号",
            "form_placeholder_passport_number": "请输入证件号",
            "form_hint_id_number": "如果国籍是中国，证件必须是身份证，其他的无所谓",
            "form_label_verify_code": "图形验证码",
            "form_placeholder_verify_code": "请输入图形验证码",
            "button_submit": "提交",
            "china": "中国",
            "validation_name_required": "请输入姓名",
            "validation_nationality_required": "请选择国籍",
            "validation_id_required": "请输入身份证号",
            "validation_id_format_invalid": "请输入正确的18位身份证号码",
            "validation_passport_required": "请输入证件号",
            "validation_id_china_required": "中国国籍必须填写身份证号",
            "validation_verify_code_required": "请输入验证码",
            "modal_guarantee_title": "关于确认手机号码所有权的担保函",
            "modal_content_intro": "本人【账户持有人全名】，【持有身份证/护照】【证件号码】特此向 PayEase Technology (Hong Kong) Limited 公司及 INFINIA 平台作出如下确认和保证：",
            "modal_content_item1": "1. 本人是手机号码【手机号码】的合法且唯一持有人。",
            "modal_content_item2": "2. 本人对该号码及与之绑定的 SIM 卡拥有完全且独占的控制权。",
            "modal_content_item3_title": "3. 本人对使用该号码进行的一切活动承担全部责任，包括但不限于接收与本人 INFINIA 平台账户相关的短信、电话和双重认证信息。",
            "modal_content_item3_content": "本人对使用该号码进行的一切活动承担全部责任，包括但不限于接收与本人 INFINIA 平台账户相关的短信、电话和双重认证信息。",
            "modal_content_item4": "4. 本人提供的以上所有信息均真实准确。本人知悉，如故意提供虚假信息可能导致本人账户被暂停或关闭，并承担相应的法律责任。",
            "modal_content_item5": "5. 本人同意 PayEase Technology (Hong Kong) Limited 公司及 INFINIA 平台为识别身份、进行联系及保障账户安全之目的使用该号码。",
            "modal_content_item6": "6. 本人特此同意，为进行身份验证之目的，根据 PayEase Technology (Hong Kong) Limited 公司及 INFINIA 平台为的条款处理我提供的个人数据，包括手机号码、身份证件副本、本人图像及其他相关数据。",
            "modal_checkbox_item1": "本人对使用该号码进行的一切活动承担全部责任，包括但不限于接收与本人 INFINIA 平台账户相关的短信、电话和双重认证信息。",
            "modal_checkbox_item2": "本人提供的以上所有信息均真实准确。本人知悉，如故意提供虚假信息可能导致本人账户被暂停或关闭，并承担相应的法律责任。",
            "modal_checkbox_item3": "本人同意 PayEase Technology (Hong Kong) Limited 公司及 INFINIA 平台为识别身份、进行联系及保障账户安全之目的使用该号码。",
            "modal_checkbox_item4": "本人特此同意，为进行身份验证之目的，根据 PayEase Technology (Hong Kong) Limited 公司及 INFINIA 平台为的条款处理我提供的个人数据，包括手机号码、身份证件副本、本人图像及其他相关数据。",
            "modal_button_confirm": "确认",
            "modal_button_cancel": "取消",
            "confirm_submit_title": "确认",
            "confirm_submit_tip": "姓名和证件号必须与注册手机号一致。",
            "message_code_sent": "验证码已发送",
            "message_submit_success": "提交成功",
            "message_all_checkboxes_required": "请勾选所有确认项",
            "description_text": "请完善账户持有人信息，以便我们更好地为您服务。如果您不是中国大陆国籍，需要确认手机号码所有权。"
        },
        subAccount: {
            "menu_sub_account_manager": "子账户管理",
            "page_title": "子账户管理",
            "page_desc": "子账户归属于当前商户主账户，权限范围与可操作KYC主体可单独配置。",
            "button_add": "新增子用户",
            "button_search": "搜索",
            "button_reset": "重置",
            "button_cancel": "取消",
            "button_confirm": "确认",
            "button_save": "保存",
            "filter_keyword": "手机号 / 邮箱",
            "filter_role": "角色",
            "filter_status": "状态",
            "filter_entity": "KYC主体",
            "placeholder_keyword": "请输入手机号或邮箱",
            "placeholder_role": "全部",
            "placeholder_status": "全部",
            "placeholder_entity": "全部",
            "column_user_name": "用户名",
            "column_name": "姓名",
            "column_mobile": "手机号",
            "column_email": "邮箱",
            "column_role": "角色",
            "column_scene": "场景",
            "column_entities": "可操作KYC主体",
            "column_status": "状态",
            "column_last_login": "最近登录",
            "column_action": "操作",
            "action_edit": "编辑",
            "action_enable": "启用",
            "action_disable": "禁用",
            "footer_tip": "说明：子账户归属于商户管理员账号；KYC主体多选用于控制可见与可操作范围。",
            "drawer_create_title": "新增子用户",
            "drawer_edit_title": "编辑子用户",
            "section_basic": "基础信息",
            "section_permission": "权限配置",
            "form_user_name": "用户名",
            "form_name": "姓名",
            "form_mobile": "手机号",
            "form_email": "邮箱",
            "form_password": "初始密码",
            "form_role": "角色",
            "form_scene": "场景权限",
            "form_entities": "KYC主体",
            "form_status": "状态",
            "placeholder_user_name": "请输入用户名（仅支持英文和数字）",
            "placeholder_name": "请输入用户姓名",
            "placeholder_mobile": "请输入手机号",
            "placeholder_email": "请输入邮箱",
            "placeholder_password": "请输入初始密码",
            "placeholder_scene": "场景权限",
            "placeholder_entity_select": "请选择至少一个KYC主体",
            "role_operator": "操作员",
            "role_auditor": "审核员",
            "status_enabled": "启用",
            "status_disabled": "禁用",
            "rule_title": "校验规则",
            "rule_1": "手机号、邮箱建议唯一。",
            "rule_2": "角色单选。",
            "rule_3": "至少选择一个KYC主体。",
            "rule_4": "禁用后不可登录。",
            "rule_5": "角色或KYC权限变更需记录日志。",
            "validation_user_name": "请输入用户名",
            "validation_user_name_format": "用户名仅支持英文和数字",
            "validation_name": "请输入姓名",
            "validation_mobile": "请输入手机号",
            "validation_email": "请输入邮箱",
            "validation_email_invalid": "请输入正确的邮箱格式",
            "validation_password": "请输入初始密码",
            "validation_password_length": "密码长度需为 6-32 位",
            "validation_role": "请选择角色",
            "validation_entity": "请至少选择一个KYC主体",
            "message_save_success": "保存成功",
            "message_status_success": "状态更新成功",
            "confirm_title": "确认",
            "confirm_status": "确认要{action}该子账户吗？"
        },
        batchDetail: {
            "page_title_batch_detail": "批次明细",
            "label_payment_time": "付款时间",
            "label_status": "状态",
            "button_search": "搜索",
            "column_batch_number": "批次号",
            "column_time": "时间",
            "column_uploaded_file": "上传文件",
            "column_store_name": "店铺名称",
            "column_amount": "金额",
            "column_total_count": "总数",
            "column_success_count": "成功数",
            "column_failure_count": "失败数",
            "column_status": "状态",
            "column_details": "详情",
            "column_action": "操作",
            "summary_total": "合计",
            "action_detail": "详情",
            "action_approve": "通过",
            "action_reject": "拒绝",
            "action_input_captcha": "输入验证码",
            "action_send_captcha": "发送验证码",
            "dialog_captcha_title": "安全验证",
            "dialog_detail_title": "付款明细",
            "dialog_approve_title": "审核通过",
            "dialog_reject_title": "审核拒绝",
            "label_captcha_code": "验证码",
            "label_email_code": "邮箱验证码",
            "label_current_balance": "当前主体余额",
            "label_current_shop_balance": "当前店铺余额",
            "label_credit_total_amount": "店铺可结汇额度",
            "label_kyc_entity": "KYC主体",
            "label_batch_total_amount": "付款总金额",
            "label_batch_total_count": "总付款笔数",
            "button_send_captcha": "发送验证码",
            "button_confirm_submit": "确认提交",
            "button_confirm_approve": "确认通过",
            "button_confirm_reject": "确认拒绝",
            "tip_captcha_valid_time": "验证码有效期5分钟，请及时输入并提交。",
            "placeholder_email_code": "请输入验证码",
            "reject_confirm_text": "确认拒绝吗?",
            "warning_enter_captcha": "请输入验证码",
            "warning_enter_reject_remark": "请输入备注",
            "detail_column_business_type": "业务类型",
            "detail_column_payment_number": "付款单号",
            "detail_column_payment_time": "付款时间",
            "detail_column_amount": "付款金额",
            "detail_column_payer": "转入方",
            "detail_column_receive_bank": "收款银行",
            "detail_column_fee": "交易费用",
            "detail_column_received_amount": "到账金额",
            "detail_column_remark": "备注",
            "status_success": "成功",
            "status_all": "全部",
            "status_new": "待处理",
            "status_pending": "待审核",
            "status_pass": "已通过",
            "status_reject": "审核拒绝",
            "status_processing": "处理中",
            "message_approve_success": "审核通过成功",
            "message_reject_success": "审核拒绝成功",
            "status_success1": "成功",
            "status_failed": "失败",
            "status_partial_success": "部分成功",
            "status_complete": "完成",
            "status_expired": "过期"
        },
        "commonStatus": {
            "option_status_new": "新建",
            "option_status_pending": "待处理",
            "option_status_processing": "处理中",
            "option_status_success": "成功",
            "option_status_failed": "失败",
            "option_status_refunded": "退款",
            "option_status_partial_success": "部分成功",
            "option_currency_hkd": "港币",
            "option_currency_eur": "欧元",
            "option_currency_gbp": "英镑",
            "option_currency_usd": "美元",
            "option_currency_cnh": "离岸人民币",
            "option_currency_rub": "卢布",
            "option_fund_direction_all": "全部",
            "option_fund_direction_income": "收入",
            "option_fund_direction_expense": "支出",
            "dropdown_status_new": "新建",
            "button_select_all": "全选",
            "button_deselect_all": "取消全选"
        },
        "withdrawAccount": {
            "page_title_withdraw_account_list": "提现账户列表",
            "label_bank_name": "银行名称",
            "label_bank_account_name": "银行账户名称",
            "label_account_type": "账户类型",
            "label_bank_location": "银行账户所在地",
            "label_currency": "账户币种",
            "label_bank_account_number": "银行账号",
            "button_add_beneficiary": "添加收款人",
            "button_search": "查询",
            "column_bank_name": "银行名称",
            "column_account_name": "银行账户名称",
            "column_account_type": "账户类型",
            "column_bank_location": "银行账户所在地",
            "column_currency": "账户币种",
            "column_account_number": "银行账号",
            "column_status": "状态",
            "column_remarks": "备注",
            "status_new": "初始",
            "status_pending": "待审核",
            "status_approved": "通过",
            "status_rejected": "拒绝",
            "remark_rejected": "当前暂无法添加该收款人银行账户。请更换其他收款账户后重新提交。",
            "column_action": "操作",
            "action_delete": "删除",
            "option_corporate": "对公",
            "option_personal": "对私",
            "breadcrumb_path_account": "首页/我的账户/提现账户",
        },
    },
    public: {
        solgan1: '畅联全球·支付无忧',
        solgan2: '革新全球支付的领先企业',
        infoSave: '信息保存',
        OnlineService: "在线客服",
        next: "继续",
        pleaseEnter: "请输入",
        pleaseSelect: "请选择",
        unit_ten_thousand: "万元",
        unit_ten_thousand1: "万",
        retry: "重试",
        retryAgain: "重试",
        loginSuccess: "登录成功",
        verificationcodesent: "验证码发送成功",
        backHome: "返回首页",
        filter: "筛选",
        status: "状态",
        downloadList: "下载列表",
        noData: "没有数据",
        reset: "重置",
        apply: "确定",
        startDate: "开始日期",
        endDate: "结束日期",
        actions: "操作",
        jilufilter: "记录筛选",
        Logout: "退出登录",
        nextStep: "下一步",
        edit: "编辑",
        logoutSuccess: "退出成功",
        Globalacquiring: "全球收单",
        Marketplacepayout: "全球收款",
        Marketplacepayout2: "全球付款",
        Aboutus: "关于我们",
        Contactus: "联系我们",
        submit: "提 交",
        querying: "查询中……",
        back: "返回",
        backTo: "返回",
        start: "开 始",
        deleteFile: "是否要删除此文件？",
        Uploading: "上传中",
        all: "全部",
        Accountlist: "账户列表",
        Transactionlist: "交易列表",
        Changemailbox: "更换绑定邮箱",
        ChangePhone: "更换绑定手机",
        Mobileverification: "手机验证",
        Returncenter: "返回安全中心",
        Useemailauthentication: "使用邮箱验证",
        Verifysent: "验证邮件已发送",
        notreceivedyoucan: "如一直未收到邮件，您可",
        Changephonenumber: "更换邮箱/手机号",
        reregister: "重新注册",
        or: "或",
        delivered1: "您正在修改支付密码，激活邮件已送达",
        delivered2: "您正在设置支付密码，激活邮件已送达",
        delivered3: "您正在修改登录密码，激活邮件已送达",
        delivered4: "您正在更换绑定邮箱，激活邮件已送达",
        delivered5: "您正在更换绑定手机，激活邮件已送达",
        delivered6: "您正在重置登录密码，激活邮件已送达",
        delivered7: "",
        delivered8: "您正在重置支付密码，系统验证邮件已送至",
        Sendwhile: "正在发送邮件，请稍后...",
        Emailsuccessfully: "邮件发送成功！",
        Emailverification: "邮箱验证",
        Pleaseverificationemail: "请输入验证邮箱",
        Verifyphone: "使用手机验证",
        enteraddress: "请输入验证邮箱地址",
        Accountsuccessfully: "账号密码设置成功！",
        Thankregistering: "感谢注册使用ipaylinks收款服务，您可以使用邮箱或者手机号进行登录",
        Accountfailed: "账号密码设置失败！",
        Startnow: "立即进行全球收款",
        uploadFollowFile: "请上传以下文件",
        uploadClick: "点击上传文件",
        supportJPG: "支持不超过10个共10MB的JPG、PNG、JPEG、BMP、PDF、ZIP、RAR格式文件",
        supportJPG2: "支持不超过10个共10MB的PNG、JPEG、PDF格式文件",
        uploadSuccess: "上传成功",
        recharge: "充值",
        collection: "收款",
        noArea: "没有地区",
        telPhone: "电话咨询",
        complete: "完成",
        close: "关闭",
        download: "下载",
        switchtoversion: "一键切换到新版本",
        autoLogin: "自动登录中...",
        tradeManager: "交易管理",
        Resendcaptcha: "重发验证码",
        systemError: "系统错误",
        cancel: "取 消",
        confirm: "确 定",
        correct_id_card: "正确的身份证号码",
    },
    otherPage: {
        Sorryregisterorlogin: "抱歉，当前链接已失效，请重新注册或登录。",
        characters20: "8~20位字符",
        includingonlyletters: "密码必须同时包含数字、字母和特殊字符，字母不限大小写，特殊字符仅支持：! # @ ? . + ; = ~ ` ",
        pleaseenterboundMobile: "请输入绑定的手机号",
        Confirmloginpassword: "确认登录密码",
        Newpasswordempty: "新密码不能为空",
        Verificationtoyourmobile: "验证码获取成功，请注意手机查收",
        setLoginPw: "请设置登录密码",
        ConfirmLoginPwagain: "再确认登录密码",
        cannotEmpty: "手机号不能为空",
        signup: "注册",
        confirmPw: "确认密码",
        expired: "链接已失效，请重新获取",
        setPWtitle: "设置密码",
        accounts: "登录账号",
        doubleEnter: "再次输入密码",
        strong: "强",
        middle: "中",
        low: "弱",
        registeredsuccessfully: "您已成功注册",
        accountnumber: "注册账号",
        pc: "为了更安全便捷的操作体验",
        mobile: "请您移至PC电脑端登录iPayLinks账号",
        Emailssuccessfully: "验证邮箱发送成功！",
        Thankyou: "感谢您注册iPayLinks，激活邮件已送达",
        Please24hours: "请登录邮箱，点击激活链接完成注册，激活链接24小时内有效",
        Notreceiveanyemail: "没有收到邮件？",
        Pleaseemail: "1.请检查垃圾邮件",
        Ifcorrect: "2.如果还没有收到邮件，",
        resent: "3.请检查邮件地址是否正确",
        Pleasehours: "请至邮箱查收邮件并完成验证，验证链接24小时内有效",
        Mailspamadmail: "邮件可能被移至垃圾/广告邮件",
        lxkf: "若有疑问，可以联系客户经理或拨打",
        lxkf2: "客服热线 ",
        lxkf3: "我们将竭诚为您服务！ ",
        lxkf4: "电脑端地址：https://mp.ipaylinks.com",
        kyc1: "您还未进行实名认证!",
        kyc2: "抱歉，您的实名认证未通过！",
        kyc3: "您的实名认证还在审核中！",
        kyc4: "为了保证您的使用体验，请在电脑端登录进行相关操作。",
        kyc5: "根据相关法律法规， 为了保证您的账户安全和使用体验，请尽快在电脑端登录进行实名认证。",
        kyc6: "为了保证您的使用体验，请您尽快在电脑端重新进行实名认证。",
        kyc7: "为了保证您的使用体验，请您尽快在电脑端登录查看审核情况。",
    },
    notice: {
        unreadmesages: "条未读公告",
        current: "当前",
        Announcements: "公告",
        markallasread: "标记为全部已读",
        NoAnnouncement: "当前暂无公告",
        gotit: "已知晓",
        Viewallannouncements: "查看全部公告",
        BacktoHome: "回到首页",
        enterkeywords: "输入关键词搜索",
        selectDate: "选择日期",
        qwcl: "前往处理",
    },

    loginPage: {
        Login: "登录",
        LogOut: "退出登录",
        PhoneNumberEmail: "登录手机号",
        Password: "登录密码",
        VerificationCode: "验证码",
        merchantNo: "商户号",
        enterMerchantNo: "请输入商户号",
        LoginEmail: "登录邮箱",
        noAccount: "还没有账号？",
        Signupnow: "立即注册",
        ForgetPassword: "忘记密码",
        pleaseenter1: "请输入手机号",
        enterEmail: "请输入邮箱",
        enterpassword: "请输入密码",
        enterVerificationCode: "请输入验证码",
        subUserLogin: "子用户登录",
        loginSubAccount: "登录子账户",
        adminLogin: "返回管理员登录",
        rules: "请按规则输入",
    },

    forgetPasswordPage: {
        ResetPassword: "请确认账号并重置密码",
        PhoneNumber: "手机号",
        email: "邮箱",
        VerificationCode: "验证码",
        Sendverificationcode: "发送验证码",
        NextResetPassword: "下一步：重置密码",
        back: "返回",
        Login: "登录",
        enterpassword1: "请输入您的验证码",
        enterpassword2: "请输入邮箱",
        enterpassword3: "请输入手机号",
        PhoneNumbercorrect: "请输入正确的手机号码",
        emailcorrect: "请输入正确的邮箱",
        passwordRules: "密码必须包含字母和数字，且不能包含特殊字符，长度8-20位",
        passwordRules2: "请再次输入密码",
        passwordRules3: "请输入密码",
        passwordRules4: "两次输入密码不一致",
    },

    registerPage: {
        Signup: "注 册",
        PhoneNumberEmail: "邮箱或手机号",
        ContactNumber: "联系方式",
        UserName: "用户名称",
        PhoneNumber: "手机号",
        enterpassword2: "请输入邮箱",
        email: "邮箱",
        password: "密码",
        enterPasswword: "请输入密码",
        enterPasswword2: "请再次输入密码",
        ConfirmNewPassword: '确认新密码',
        Pleaseenterusername: "请输入用户名称",
        PleaseenteremailPhone: "请输入邮箱或手机号",
        PleaseenterePhone: "请输入手机号",
        PleaseentercontactNumber: "请输入联系方式",
        registrationAgreement: "我已阅读并同意",
        agreement: "《用户注册协议》",
        agreementys: "《隐私协议》",
        LoginNow: "已拥有账号？马上",
        Login: "登录",
        PleaseenterNumber: "请输入数字",
        VerificationCode: "获取验证码",
        emailUsed: "邮箱被占用",
        max50characters: "长度为1-50位",
        max512characters: "长度为1-512位",
        max100characters: "长度为1-100位",
        tishi: "暂不支持此号段的手机号注册，请更换手机号！",
    },

    homePage: {
        QuickStart: "快捷操作",
        Add1stMoney: "充值",
        Send1stMoney: "付款",
        Open1stCollectionAccount: "开收款账户",
        Link1stStore: "绑定店铺",
        QuickStartD1: "账户余额可用来换汇、提现和付款至第三方",
        QuickStartD2: "付款前请先维护收款人银行账户",
        QuickStartD3: "平台收款需要先开通收款账户",
        QuickStartD4: "人民币入境需要绑定店铺获取订单明细",
        Balance: "账户余额",
        MyCurrencyWatchlist: "我的币种列表",
        TransactionCountsin30Days: "本月交易统计",
        Shownfluctuations: "参考汇率：仅供参考，实际适用汇率以付款/换汇页面展示汇率为准。（CNY：在岸人民币； CNH：离岸人民币）",
        SendMoney: "付款",
        Exchange: "换汇",
        Collections: "全球收款",
        AddMoney: "充值",
        ManageMyWatchlist: "管理我的关注币种列表",
        TransatcionAmountSummary: "交易金额概览",
        Incoming: "收入",
        Outcoming: "支出",
        toChinaMainland: "怎样提现或付款至中国大陆？",
        Weknowregulations: "中国大陆资金入境监管严苛，正常付款手续繁多；在iPaylinks, 您只要绑定店铺，剩下的都交给我们。",
        more: "查看更多",
        more2: "了解更多",
        Commonexchange: "您可将常用币种兑换在岸/离岸人民币或其他常用货币兑展示在列表中，方便随时查看最新汇率",
        save: "保存",
        cancel: "取消",
        sell: "卖出",
        buy: "买入",
        Removefromwatchlist: "从列表中删除",
        Addupto5: "最多可添加5条",
        Youraccountinprogress: "您的账户验证正在进行中",
        notcompletedverification: "您尚未完成账户实名验证",
        completeverificationfirst: "请先完成账户实名验证",
        nopermission: "抱歉，您暂无查看权限，如您需增加权限，请以管理员身份通过账户设置-授权管理分配对应权限",
        contactaccountadmin: "请联系该账户管理员",
        waitamoment: "请稍后",
        message: "消息",
        stores: "店铺",
        CollectionAccount: "收款账户",
        movedaccount: "have been moved to your account",
        saveSuccess: "保存成功",
        dbsx: "待办事项",
        mores: "更多",
        zwdbsx: "暂无待办事项",
        a1: "您的账户实名认证信息已提交，请返回首页刷新页面查看",
    },

    kyc: {
        quickCopy: '一键复制法人/董事信息',
        nar1: '周年申报表',
        businessRegistercertificateNumber: '商业登记证号码',
        verifyFail: "验证信息未通过",
        verifyFail2: "请修改后重新提交",
        modifyKyc: "修改认证信息",
        AccountVerification: "账户认证",
        toverifyyouraccount: "基于合规需要，在开始交易前，您需要先花几分钟提交一些资料验证账户。",
        Youraccountprogress: "您的账户验证正在进行中",
        Wearereviewingyourmaterials: "我们正在审核您的材料，审核完成后会第一时间以邮件或短信通知您",
        Verifying: "审核中",
        Toverify: "去验证",
        latterVerify: "稍后验证",
        Confirm: "确 认",
        startVerify: "开始您的验证",
        tip: "根据相关金融监管要求及保障您的账户资金安全，iPayLinks需对您的真实身份信息进行验证。iPayLinks承诺将对您提供的实名信息严格保密并且不会将您的信息用于其他用途！",
        entityType: "主体类型",
        region: "所在国家/地区",
        upload: "证件上传",
        idCard: "身份证",
        passport: "护照",
        personalDoc: "个人证件",
        idNumber: "证件号码",
        basicInfo: "基本信息",
        uploadImg: "确保上传的图片文字清晰可见，最大不超过10M，支持JPG、PNG、JPEG",
        qiyeInfo: "企业信息",
        ziliaoUp: "资料上传",
        businessCer: "商业证件",
        infoCheck: "信息检查",
        zuizhongSyr: "最终受益人",
        deleteSyr: "移除该最终受益人",
        addSyr: "添加最终受益人",
        tongFaren: "同上述「法人代表」信息。",
        tongSyr: "同上述「被授权人」信息。",
        countryOrRegion: "签证签发国家或地区",
        a1: "提供法定代表人，被授权人以及最终受益人 (如适用)的身份证复印件。最终受益人是指直接或间接持有公司25%以上股份的个人。",
        a2: "该法人代表同时是最终受益人",
        a3: "该被授权人同时是最终受益人",
        gudongFile: "股东文件",
        farenDb: "法人代表",
        Corporatestructure: "企业结构",
        Legalperson: "主管",
        Tofollowingdocuments: "为设立一个账户，请提供以下文件",
        businesslicense: "营业执照",
        LegalrepresentativeID: "法人代表身份证件",
        BusinessRegistrationCertificate: "商业登记证",
        YourpersonalID: "您的个人身份证",
        personalID: "个人身份证",
        Companycertificate: "公司注册证明书",
        uploadCompanycertificate: "请上传公司注册证明书",
        Partnershipagreement: "合伙协议",
        Ifnotmanagingpartner: "持有公司25%以上股份的最终受益人的个人身份证件，若无，则请提供主管合伙人的身份证件",
        Iconfirmfillcompany: "我确认本人将会是此企业账户的管理员并已获得授权代表本企业填写此表格",
        uploadbusinesslicense: "请上传营业执照复印件",
        uploadPartnershipagreement: "请上传合伙协议",
        uploadbusinessregistrationcertificate: "请上传商业登记证复印件",
        LegalrepresentativeYOU: "法人代表 (您本人)",
        LegalpersonYOU: "主管 (您本人)",
        providesupervisorshares: "请提供主管，被授权人以及最终受益人 (如适用)的身份证复印件。最终受益人是指直接或间接持有公司25%以上股份的个人。",
        supervisoralsobeneficiary: "该主管同时是最终受益人",
        FrontphotoIDcard: "身份证正面照片",
        PhotobackID: "身份证背面照片",
        Passportpersonalinformation: "护照个人信息",
        idcardPhoto: "身份证照片",
        IDperson: "被授权人身份证件",
        notnecessary: "选填",
        Maximum10Msupportziprar: "最大不超过10M，支持zip、rar",
        personaldocuments: "个人文件",
        provideapplicableshares: "请提供个人身份证以及最终受益人 (如适用)的身份证复印件。最终受益人是指直接或间接持有公司25%以上股份的个人。",
        Licenseedocuments: "被授权人文件",
        Corporatedocuments: "法人文件",
        UltimateBeneficialOwner: "最终受益人",
        Samelegal: "同上述「法人代表」信息",
        Sameperson: "同上述「被授权人」信息",
        Samelegal2: "同上述「主管」信息",
        enteIDnumber: "请输入证件号",
        uploadallfiles: "请上传全部文件",
        alreadyused: "此证件已被使用，请更换证件",
        verificationsubmitted: "实名资料验证提交成功",
        reviewiscompleted: "我们正在审核您的材料，审核完成后会第一时间以邮件或短信通知您",
        Forexample: "例如",
        Businessempty: "商业登记证为空",
        China: "中国大陆",
        ChinaHongKong: "中国香港",
        Personalholdsshares: "持有公司25%以上股份的最终受益人的个人身份证件",
        providepersonalID: "请提供个人身份证",
        Theindividualbeneficiary: "该个人同时是最终受益人",
        AuthorizedpersonYOU: "被授权人 (您本人)",
        Individualmerchants: "个体商户",
        partner: "合伙",
        company: "公司",
        Legalpersonfile: "主管文件",
        Authorizedperson: "被授权人",
        Licensedphoto: "持证照片",
        Examplescertificatestyles: "证件样例",
        Verificationstatus: "验证状态",
        Pleaseupload: "请上传",
        Pleaseconfirmandcheck: "请确认并勾选",
        uploadIDphoto: "请上传证件照片（护照个人信息页）",
        uploadIDphoto2: "护照个人信息页",
        uploadJPGPNGJPEG1: "请上传商业登记证复印件，确保上传的图片文字清晰可见，最大不超过10M，支持JPG、PNG、JPEG",
        uploadJPGPNGJPEG2: "请上传公司注册证明书，确保上传的图片文字清晰可见，最大不超过10M，支持JPG、PNG、JPEG",
        uploadJPGPNGJPEG3: "请上传合伙协议，确保上传的图片文字清晰可见，最大不超过10M，支持JPG、PNG、JPEG",
        uploadJPGPNGJPEG4: "请上传个人身份证，确保上传的图片文字清晰可见，最大不超过10M，支持JPG、PNG、JPEG",
        Pleaseshares2: "请提供法定代表人，被授权人以及最终受益人 (如适用)的身份证复印件。最终受益人是指直接或间接持有公司25%以上股份的个人。",
        Countryissued: "证件签发国家或地区",
        uploadPhotoID: "请上传身份证照片，确保上传的图片文字清晰可见，最大不超过10M，支持JPG、PNG、JPEG",
        passportPhoto: "护照照片",
        Countryorregion: "所在国家或地区",
        IDphoto: "证件照片（护照个人信息页）",
        Greatcreated: "太棒了，新账户已创建",
        Greatready: "太棒了，您的新账户一切就绪",
        Youhavethe: "您刚刚创建了",
        masteraccount: "主账户",
        Accountreview: "账户验证信息正在审核中",
        expecteddays: "预计需要1~2个工作日",
        Stayaccount: "留在当前账户",
        Switchaccount: "切换至新账户",
        Accountverificationinformation: "账户验证信息",
        Validationstatus: "验证状态",
        Verificationpassed: "验证通过",
        pngOnly: "仅支持jpeg、png、jpg 格式！",
        zipOnly: "仅支持zip、rar格式！",
        bncg: "文件不能超过",
        exampleDescribe: {
            a1: "上传完整的营业执照正本图片，图片中信息完整清晰可识别并真实有效。",
            a2: "上传完整的公司注册说明书图片，图片中信息完整清晰可识别并真实有效。",
            a3: "上传完整的商业登记证图片，图片中信息完整清晰可识别并真实有效。",
            a4: "上传完整的护照图片，图片中信息完整清晰可识别并真实有效。",
            a5: "上传完整的身份证正面图片，图片中信息完整清晰可识别并真实有效。",
            a6: "上传完整的身份证反面图片，图片中信息完整清晰可识别并真实有效。",
            a7: "上传完整的手持身份证图片，图片中信息完整清晰可识别并真实有效。",
            a8: "上传完整的身份证人像页图片，图片中信息完整清晰可识别并真实有效。",
            a9: "正确示例",
        },
        zlxg: "资料修改",
        userOverdue1: "您的账户",
        userOverdue2: "，请点击下方“修改认证信息按钮”去更新您的证件，我们会对您的资料进行再次审核，在审核期间，您仍可以正常进行账户操作，如有任何疑问可以联系您的销售经理协助处理，谢谢",
        userOverdue3: "，账户暂时无法继续使用，请点击下方修改认证信息按钮去更新您的证件，我们会对重新提交资料进行审核，通过后账户将恢复，如有疑问可以联系您的销售经理协助处理，谢谢。",
        guoqi1: "实名认证材料已过期",
        guoqi2: "请按提示更新资料后提交",
        OCRMesJsonKey: {
            certExpirationBegin: "有效期开始时间",
            certExpirationEnd: "有效期结束时间",
            certificateNumber: "身份证号",
            dateOfBirth: "出生日期",
            gender: "性别",
            issuingAuthority: "签发机关",
            companyName: "姓名",
            nationality: "民族",
            specificAddress: "地址",
            sfsbxx: "身份识别信息",
        },

        companyDto: {
            Individual: '用户类型',
            PostCode: '邮政编码',
            region: "国家地区",
            certificateofIncorporation: '注册证书',
            CertificateNo: '注册证书号',
            BusinessActivityLicense: '业务登记证',
            CountryRegionoftheRegisteredAddress: '注册地址国家/地区',
            CompanyName: '企业名称（英文）',
            CompanyOriginalName: '企业名称',
            ProvinceStateoftheRegisteredAddress: '注册地址省/州',
            CityoftheRegisteredAddress: '注册地址城市',
            Theregisteredaddressofthecompany: '企业注册地址',
            sameBusiness: '经营地址与注册地址是否相同？',
            CountryRegionoftheBusinessOperationAddress: '经营地址国家/地区',
            ProvinceStateoftheBusinessOperationAddress: '经营地址省/州',
            CityoftheBusinessOperationAddress: '经营地址城市',
            Thebusinessoperationaddressofthecompany: '企业经营地址',
            CertificateofBusinessAddress: '公司注册地址证明',
            BusinessAddressProof: '公司经营地址证明',
            BankAccountOpeningDocuments: '公司银行开户文件',
            TaxPaymentCertificate: '税单',
            BusinessWebsite: '公司网站',
            ArticlesofAssociation: '公司章程',
            NumberofShares: '股份数量',
            ShareholdingStructure: '股权架构图',
            Other: '其它附件(选填)',
            holdingRatio: '持股百分比',
            holdingRatioMinError: '持股比例不能小于25',
            holdingRatioMaxError: '持股比例不能大于100',
            holdingRatioNotNumberError: '持股比例必须为数字',

            // step3
            NationalityoftheDirector: '董事国籍',
            FirstName: '董事名',
            LastName: '董事姓',
            EnglishFirstName: '董事英文名',
            EnglishLastName: '董事英文姓',
            TypeofCertificate: '证件类型',
            TheDirectorCertificate: '证件上传',
            CertificateNumber: '证件号码',
            Certificateexpirationdate: '证件有效期',
            CertificateregistrationDate: '证件开始时间',
            CertificateexpirationdatePermanent: '长期 ',
            Thedirectordateofbirth: '董事生日',
            CountryRegionoftheResidentialAddress: '居住国家/地区',
            ProvinceStateoftheResidentialAddress: '居住省/州',
            CityoftheResidentialAddress: '居住城市',
            ResidentialAddress: '居住地址',
            NationalityoftheUltimateBeneficialOwner: '最终受益人国籍',
            TheUBOCertificate: '证件上传',
            uboFirstName: '受益人名',
            uboLastName: '受益人姓',
            uboEnglishFirstName: '受益人英文名',
            uboEnglishLastName: '受益人英文姓',
            DateofBirthoftheUltimateBeneficialOwner: '最终受益人生日',
            AuthorizedAgent: '授权代理人',
            authFirstName: '代理人名',
            authLastName: '代理人姓',
            authEnglishFirstName: '代理人英文名',
            authEnglishLastName: '代理人英文姓',
            DateofBirthoftheAgent: '代理人生日',
            PowerofAttorney: '授权委托书',
            CertifiedTrueCopy: '经认证的真实副本',
            CTCdocuments: '文件上传',
            lastUboInfoTitle: `最终受益人信息`,
            lastUboInfoContent: `（ 所有持有≥25%股权或股份的个人，企业持股需追溯到最终自然人股东 ）`,

            // placeholder
            inputPlaceholder: '请输入',
            selectPlaceholder: '请选择',
            registerAmount: '注册资本',


            // 侧边栏
            registeLocation: `企业/个人注册地`,
            companyType: `企业类型`,
            step1: '开始',
            step1Desc: '选择实名注册地区',
            step2: '基本信息',
            step2Desc: '填写企业基本信息和上传相关证件',
            step3: '经营信息',
            step3Desc: '法人代表/董事、最终受益人、授权人有效证件',
            step4: 'CTC',
            step4Desc: 'Certified True Copy (CTC)',
            agreeInformation: `本人已同意提供身份信息用于实名认证。`,
            nextStep: '下一步',

            docuDesByCompany: {
                doc1: '请准备以下文件:',
                doc2: '公司注册证书',
                doc3: '业务经营许可证（如适用）——注明业务性质及经营范围的文件',
                doc4: '公司章程',
                doc5: '股份数量证明',
                doc6: '注册地址证明——近三个月内的地址证明（如法律文件或水电费账单）；如使用家庭办公室，地址须与董事或最终受益人地址一致',
                doc7: '股权架构图',
                doc8: '董事身份证件',
                doc9: '最终受益人（持股25%以上）身份证件',
                doc10: '公证书（仅限经认证真实副本）',
                doc11: '如上述任何文件非中文或英文，请提供经认证的真实副本（CTC）。CTC须由具备相关认证资质和经验的注册会计师事务所出具。',
            },
            docuDesBySelfProprietor: {
                doc1: '商业登记证——必须提供',
                doc2: '业务经营许可证（如适用）——注明业务性质及经营范围的文件',
                doc3: '经营地址证明——近三个月内的水电费账单或租约',
                doc4: '银行开户文件——银行账户确认函或开户证明',
                doc5: '完税证明（如有）——选填',
                doc6: '所有相关人员近三个月地址证明：',
                doc7: '企业主：',
                doc8: '身份证件',
                doc9: '近三个月水电费账单或银行对账单等',
                doc10: '如上述任何文件非中文或英文，请提供经认证的真实副本（CTC）。CTC须由具备相关认证资质和经验的注册会计师事务所出具。',
            },
            docuDesByHK: {
                enterprise_doc1: '注册证书',
                enterprise_doc2: '商业登记证书',
                enterprise_doc3: '法团成立表格和周年申报表（企业成立一年以上）',
                enterprise_doc4: '董事证件照片（香港居民身份证 / 身份证 / 护照）',
                enterprise_doc5: '授权代理人证件照片（香港居民身份证 / 身份证 / 护照）（若您为授权代理人）',
                personal_doc1: '香港永久居民身份证 / 护照正反面照片',
            },
            CompanyDocuments: `企业证件`,
            CompanyBasicInformation: `企业基本信息`,
            Attachment: "附件",
            yes: '是',
            no: '否',
            LegalRepresentativeInformation: `企业法人代表信息`,
            IdentityInformation: '身份信息',
            UltimateBeneficialOwner: `最终受益人`,
            selfProdisUBOS: `个体工商户法人视为最终受益人；企业持有股权或股份≥25%视为最终受益人之一；`,
            uboAllProd: `最终受益人信息（ 所有持有≥25%股权或股份的个人，企业持股需追溯到最终自然人股东 ）`,
            ubo: '最终受益人',
            addUbo: `添加最终受益人信息`,
            AuthorizedRepresentativeInformation: `授权代理人信息`,
            LegalRepresentative: `法人代表人`,
            AuthorizedRepresentative: `授权代理人`,
            RepresentativeNationality: `代理人国籍`,
            plaseTip: `请填写公司法人代表签署的 授权委托书（点击下载），或相同效力的董事会决议，加盖公司公章，上传授权委托书照片或 PDF 文件。请注意授权书信息清晰可见`,
            ArethedocumentsinChineseorEnglish: `以上文件是否是中文或者英文`,
            prevStep: `上一步`,
            delete: '删除',
            Identityverification: '实名认证',
            Director: '董事',
            IsthistheUBO: '是否为最终受益人',
            Addinformationofdirectors: '添加企业其他董事信息',
            Nameofultimatebeneficialowner: '最终受益人姓名',
            EnglishNameofultimatebeneficialowner: '最终受益人英文姓名',
            Provinceofresidence: '居住省',
            Cityofresidence: '居住城市',
            Englishname: '英文姓名',
            Name: '姓名',
            Authorizedaccountoperator: '账号操作授权人',
            Clicktoupload: '点击上传',
            Or: '或',
            Draganddrophere: '拖拽至此处',
            Supportedattachments: '附件支持',
            Filesizemustnotexceed: '文件大小不能超过{size}MB',
            fileTypeNotSupported: '仅支持 {types} 格式的文件，请重新选择',
            uploadFailed: '上传失败',
            imageMaxDimension: '图片长宽不能超过 {width}px*{height}px',
            reloadUpload: '重新上传',
            NotarialCertificate: "公证书",
            Proofofaddress: "地址证明",
            passport: '护照',
            Idcard: '身份证',
            IDCardFrontPage: '身份证人像页',
            IDCardBackPage: '身份证国徽页',
            IDCardHoldPage: '手持身份证',
            IDCardHoldPageTips:'开通B2B业务时，请上传手持证件照片。',
            IDCardHoldPage2: '手持证件照',
            submit: '提交',

            successDialog: {
                title: '提交成功',
                first: '注册',
                second: '提交资料',
                secondInfo: `审核中`,
                third: '账号激活',
                content: "提交成功",
                tips: `我们将尽快审核您的信息，请耐心等待。结果会以短信和邮件的方式通知您，请及时关注！`,
                returnHome: "返回首页",
            }
        }
    },

    //    多账户
    multipleAccounts: {
        hasOneAccount: "您当前仅有1个账户",
        noPermission: "当前账户下您暂无创建权限，请切换至您有权限的账户下进行创建",
        switchAccount: "切换账户",
        selectAccount: "请选择账户",
        audited: "已审核",
        underReview: "审核中",
        accountNo: "账户号码",
        role: "角色",
        createNewAcc: "创建新账户",
        basicInfo: "基本信息",
        accountVerify: "账户验证",
        createAcc: "确认提交",
        setNickName: "请设置账户昵称",
        accountNickName: "账户昵称",
        pleaseSet: "请设置一个账户昵称便于查找和切换账户",
        a1: "新账户是否用于已有公司或个人信息",
        nextStep1: "下一步：验证账户",
        a2: "仍在审核中的公司或个人信息暂不可选择",
        a3: "提交新的公司或个人信息",
        back: "返回上一步",
        chooseHasAccount: {
            b1: "以下信息将作为新账户的验证信息",
            b3: "请最后确认以下信息并创建账户",
            accountType: "账户类型",
            location: "所在地",
            entityName: "实体名称",
            idNumber: "证件号码",
            legalPerson: "法人姓名",
            b2: "我确认本人为此企业账户的管理员，并已获得授权代表本企业开设新账户",
            nextStep: "下一步：确认账户信息",
            nextStep2: "下一步：上传法人证件",
        },
        chooseNewAccount: {
            baseInfo: "请提供基本信息",
            pleaseSelectLocation: "请选择所在地",
            type: "类型",
            a1: "下一步您需提供以下验证材料：",
            a2: "1）身份证正反面照片",
            a3: "2）手持身份证照片",
            a4: "根据相关金融监管要求及保障账户资金安全，iPayLinks需对您的真实身份信息进行验证，iPayLinks承诺将对您提供的实名信息严格保密且不会用于其它用途。",
            a5: "请提供验证材料",
            cardPhoto: "身份证照片",
            a6: "请上传最新办理的二代身份证，确保上传的图片文字清晰可见，最大不超过10M，支持JPG、PNG、JPEG",
            holdCard: "手持身份证照片",
            a7: "请上传本人手持身份证正面的照片，确保脸部和身份证正面信息清晰可见，最大不超过10M，支持JPG、PNG、JPEG",
            a8: "为保障信息准确，请输入以上证件号码",
            personDoc: "个人证件",
            a9: "以上验证材料提交后需要1~2个工作日进行审核",
            id: "身份证",
            passport: "护照",
            industryCategory: "行业类别",
            website: "网站地址",
            pleaseEnterWeb: "请输入网站地址",
            selectIdentity: "请选择您的身份",
            legalRepresentative: "法人代表",
            a10: "您被公司授予法律权力、依照法律或公司章程代表公司签订具有约束力的合约",
            authorizedPerson: "被授权人",
            a11: "您被授权代表企业处理事务",
            a12: "1）营业执照",
            a13: "2）法人代表身份证件",
            a14: "3）持有公司25%以上股份的最终受益人的个人身份证件",
            a15: "根据相关金融监管要求及保障账户资金安全，iPayLinks需对您的真实身份信息进行验证，iPayLinks承诺将对您提供的实名信息严格保密且不会用于其它用途。",
            businessLicense: "营业执照",
        },
        tip: "当前账户下您暂无创建权限，请切换至您有权限的账户下进行创建",
        setDefault: "设置为默认账户",
        isDefault: "默认账户",
        v0429: {
            a1: "（输入您主营的可看到商户具体信息的网站地址或者店铺地址。）",
            a2: "（如果您经营多个平台/多种类型，选择您主营的一个类型/平台。）",
            a3: "（请输入纳税人识别码，非证件编号）",
            a4: "（请保持图片清晰并露出四角，勿遮盖隐藏）",
            a5: "请上传所有占股25%以上的股东证件，如果漏传会影响审核速度。",
        },
    },
    //    收款
    collection: {
        collectionAccountLocation: "收款账户所在地区",
        collectionAmount: "收款金额",
        otherInfo: "其他信息",
        amountInfo: "金额信息",
        collectionAccount: "收款账号",
        PleasebindFirst: "请先到收款账号列表绑定店铺",
        a1: "让收款更加容易",
        a2: "我们的收款账号允许您在全球范围内收款，创建账号只需几分钟。",
        learnMore: "查看更多",
        addAccount: "新建全球收款账户",
        addAccount2: "添加收款账号",
        firstAccount: "创建首个收款账号",
        currency: "币种",
        accountNickName: "账户昵称",
        location: "账户所在国家/地区",
        bankAccount: "银行账号/IBAN",
        basicInfo: "基础信息",
        accountName: "账户名称",
        accountNameHl: "店铺注册名称",
        createTime: "创建时间",
        accountTime: "账号状态",
        bankMes: "银行账号信息",
        accountCurrency: "账户币种",
        bankLocation: "银行所在地",
        bankName: "银行名称",
        bankNo: "银行账号",
        accountType: "账户类型",
        bankAdd: "银行地址",
        bankPost: "银行所在地邮编",
        tips: "提示",
        time: "到账日期",
        transactionId: "交易编号",
        amount: "金额",
        a3: "收款账号证明信",
        a4: "开证明信的目的是什么",
        a5: "Amazon证明信",
        a6: "普通证明信",
        a7: "请在下面确认信息",
        a8: "Amazon注册用户/公司名称",
        a9: "Amazon注册邮箱",
        add: "地址",
        postCode: "邮编",
        a10: "我确认上述信息准确无误并与Amazon注册的详细信息一致。我同意并授权iPayLinks在账户证明信中使用上述信息。",
        a11: "下载账户证明信",
        add2: "账号持有人地址",
        a12: "使用什么币种收款",
        a13: "请选择币种",
        a14: "您需要开设哪个地区的收款账号",
        a15: "如何选择账号",
        a16: "给您的账号起个昵称",
        back: "收款账户列表",
        a17: "设置昵称以便快速检索收款账户，例如店铺名称、账号备注信息等",
        a18: "（与您在平台的注册名称保持一致）",
        a181: "（选择您在平台注册的店铺）",
        a182: "按香港银行要求，账户名称必须使用您认证时的英文名称。若您需要更换账户名称时，请联系您的客户经理。",
        a19: "收款账号用途",
        a20: "（为保障您后续正常收款，请根据您的实际收款用途选择）",
        queryNickName: "快速检索账户昵称",
        b1: "银行代码",
        b2: "分行代码",
        city: "城市",
        b4: "若此账号超过90天无入账，为不影响您的正常使用，建议联系您的客户经理重新激活。",
        b5: "如需重新使用，请联系您的客户经理重新开通账号",
        b6: "店铺注册名称",
        // b8: '您的收款账户名称默认为在iPayLinks中注册的账户名称。从Amazon等电子商务平台收取资金时，请使用平台注册名称作为收款账户名称',
        b8: "此名称会做为您的收款账户名称。您有多个店铺时，可通过收款账户名称进行区别。",
        b9: "该收款账号既支持本地付款，也支持SWIFT付款",
        b11: "（该账号不支持SWIFT转账）",
        b13: "该收款账号只能接受SWIFT方式付款",
        b14: "请输入详细地址",
        b15: "国家/地区",
        Province: "省",
        modifyNickName: "修改账户昵称",
        modifyAccName: "修改账户名称",
        jyms: "交易描述",
        sczl: "上传资料",
        sc: "上传资料",
        creatSuccess: "创建全球收款账号成功",
        than90days: "若此账号超过90天无入账，为不影响您的正常使用，建议联系您的客户经理重新激活。",
        AmazonenterTip: "如您的Amazon无法使用全角片假名，请在填入账户持有人时使用半角片假名",
        AmazonenterTip1: "半角片假名",
        Duringmanager: "",
        Transferaccount: "收款账户迁移确认",
        TransferSuccess: "迁移成功",
        CollectionAccount: "个收款账户",
        b16: "请选择是否绑定店铺",
        b17: "绑定新店铺",
        b18: "绑定已有店铺",
        b19: "暂无店铺",
        b20: "绑定已有店铺",
        c1: "关联银行账号",
        c2: "申请新账号",
        c3: "账号绑定/切换失败反馈",
        c4: "绑定失败原因",
        c5: "抱歉，当前收款账号无法关联店铺，请联系客服为您解决",
        c6: "账户详情",
        c7: "请谨慎选择您的收款账号用途，该收款账号添加成功后，请按照您所选的用途使用该收款账号，如未按该用途正确使用，可能会导致您的入账资金被退回，且会被银行收取1~30USD/GBP的退款手续费，具体以实际银行扣费为准。",
        c8: "若当前申请的账号添加至电商平台时候显示无法绑定/切换，则可以在此点击按钮，录入平台反馈的失败原因之后，将会再次分配新的银行账号供您使用；",
        c9: "创建账户",
        c10: "当前账号未激活，无法进行资金入账，为避免资金到账失效收到影响，请收款账号状态更新为正常后在操作；",
        c11: "重新激活",
        c12: "激活失败原因",
        c13: "处理方式",
        c14: "更新店铺信息",
        c15: "换绑新店铺",
        c16: "换绑已有店铺",
        c17: "店铺地址",
        c18: "请保持店铺名称与店铺地址一致，避免因填写错误导致收款账号激活失败",
        c19: "请先前往“添加店铺”页面绑定新店铺后，再返回该页面选择“换绑已有店铺”，将店铺换绑成新添加的店铺",
        c20: "请选择店铺",
        c21: "选择店铺",
        c22: "账号无法绑定到平台？",
        bankAccountName: "收款账号",
        shopnames: "店铺名称",
        realFundinAmount: "实际入账金额",
        c23: "单笔收款限额: 个人账户10万以内，企业账户30万以内。超限额入金造成的退款手续费由商户自行承担。",
        c24: "注：",
        c25: "1. IDR收款入账时会结算为SGD新加坡元，如需其他币种请结算后进行货币兑换。",
        c26: "2. IDR收款首次入账需上传Shopee店铺中此收款账号的收入报表证明资金来源，否则将会退回资金。",
        drzzj: "待入账资金",
        hkrmc: "汇款人名称",
        drzzl: "资料",
        ddsm: "调单说明",
        ddshsm: "调单审核说明",
        rejectedMes: "资金退回，一般需要2～5个工作日，具体到账时间以银行为准。",
        rejectedMes2: "我司已收到您的款项，会在稍后给您入账，若需要补充资料会发通知给您",
        nameOfRemitter: "汇款人名称",
        jiesuanInfo: {
            title: "结算信息",
            amount: "结算金额",
            fee: "手续费合计",
            rate: "结算汇率",
        },
        cksl: "查看示例",
        qxzskzhyt: "请选择收款账户用途",
        returnShui: "收款账号是否用于退税",
        returnCare: "仅支持欧洲、英国、美国地区local收退税款，其他地区暂不支持。",
        saleCategory: "销售类目",
        platReceviable: "平台收款",
        standReceviable: "独立站收款",
        other: "其他",
        payeeMethod: "收款方式",
        stsk: "收退税款",
        kjmy: "跨境贸易",
        taxCare: "收退税款只接受税局来款，且只有在iPayLinks缴税的退税款可用于结汇。",
    },
    //    换汇
    exchange: {
        exchange: "换汇",
        exchange2: "立即换汇",
        sell: "卖出",
        buy: "买入",
        rate: "参考汇率",
        rate2: "交易汇率",
        date: "交割日期",
        a1: "此为参考汇率会自动刷新并可能会波动，请以最终提交时的汇率为准。",
        createDate: "创建日期",
        sellAmount: "卖出金额",
        sellCurrency: "卖出币种",
        buyAmount: "买入金额",
        buyCurrency: "买入币种",
        download: "下载明细",
        comDate: "完成日期",
        a2: "请确保在2020-07-15 18:00换汇截止日期之前有足够的余额",
        a3: "因余额不足该换汇订单已关闭",
        to: "兑换",
        exchangeDetail: "交易详情",
        unsufficientBalance: "余额不足",
        sufficientBalance: "余额充足",
        balance: "余额",
        a4: "交易金额小于最低限额",
        a5: "换汇信息确认",
        a6: "保证换汇汇率",
        a7: "页面汇率可能会发生变化，请注意金额的变化。",
        success: "换汇成功",
        again: "再次换汇",
        toList: "查看换汇列表",
        a8: "您刚卖出",
        a9: "买入",
        attentionmanagementlist: "您可通过“换汇列表”查看订单状态，并可通过“账户余额”查询余额变动状态",
        Selectsellingcurrency: "选择卖出币种",
        Selectbuyingcurrency: "选择买入币种",
        Selectdate: "选择日期",
        Exchangeraterefreshed: "汇率已刷新",
        noteratefluctuation: "请注意，由于汇率波动，换汇金额已发生变动",
        Incorrectformat: "格式不正确",
        Scaleerror: "小数位数错误",
        Pendinginquiries: "待查询",
        Queryexchangerate: "查询汇率",
        copySuccess: "复制成功！",
        copyFailed: "复制失败！",
        exchangeList: "换汇列表",
    },
    //店铺
    store: {
        a1: "资金转入中国大陆",
        a2: "合规要求可能很复杂，但是我们可以简化您的操作，只需通过关联您的店铺来提供相关订单信息，即可获得足够的资金来源证明，从而可以将资金转入中国大陆。",
        a3: "将资金转入入境管制的国家时需要使用订单信息",
        a4: "有效订单额度",
        learnMore: "查看更多",
        payToChina: "付款到中国大陆",
        storeName: "店铺名称",
        plat: "平台",
        sync: "订单数据同步",
        sync2: "同步订单数据",
        sync3: "上传订单数据",
        update: "更新授权",
        authSuccess: "授权成功",
        reBind: "重新绑定",
        authFail: "授权过期",
        auto: "自动",
        shoudong: "手动",
        addNewStore: "添加新店铺",
        choosePlat: "请选择店铺所属平台",
        addStore: "添加店铺",
        searchName: "快速搜索店铺名称",
        a5: "检查需要更新的店铺",
        firstStore: "添加首个店铺",
        storeFilter: "店铺筛选",
        a6: "关于如何手动同步订单数据的用户指南",
        a7: "授权失败或过期，请更新您的店铺信息并重新授权。授权后将自动获取90天内的订单。",
        a8: "添加您的店铺并授权给iPayLinks以便获得订单信息。",
        a9: "新授权的店铺会在24小时内完成订单数据同步",
        a10: "您有",
        a11: "个店铺授权失效。请更新授权以获取订单数据。",
        a12: "店铺授权",
        change: "更换",
        storeDetail: "店铺详情",
        sellerId: "卖家编号",
        auth: "授权",
        devName: "开发者名称",
        devId: "开发者ID",
        mwsToken: "MWS授权令牌",
        a13: "为了让我们能自动获取订单信息，您需要使用以下信息在平台中授权给iPayLinks",
        a14: "这是什么，我该如何授权？",
        a15: "为了让我们能够自动获取订单信息，页面将会跳转到ebay网页授权给iPayLinks。",
        a15shopee: "为了让我们能够自动获取订单信息，页面将会跳转到Shopee网页授权给iPayLinks。",
        a15shopify: "为了让我们能够自动获取订单信息，页面将会跳转到Shopify网页授权给iPayLinks。",
        a16: "您在ebay中授权后店铺将会关联成功并保存相关信息。",
        a16shopee: "您在Shopee中授权后店铺将会关联成功并保存相关信息。",
        a16shopify: "您在Shopify中授权后店铺将会关联成功并保存相关信息。",
        a17: "页面将跳转到",
        website: "网站",
        url: "店铺网址",
        verify: "验证",
        area: "主要销售地区",
        order: "订单信息",
        a18: "请提供您在Noon平台上注册的email，以验证店铺信息",
        getEmail: "如何获取email？",
        a19: "Noon注册email",
        tip: "温馨提示：",
        a20: "Noon店铺需要手动同步订单数据",
        b1: "添加您的Noon店铺后，您可以根据我们的用户指南手动同步店铺订单数据。",
        guide: "用户指南",
        updateStore: "更新店铺",
        addSuc: "添加成功!",
        storeManagement: "店铺管理",
        orderManagement: "订单管理",
        b2: "正在授权中…",
        b3: "请不要离开或关闭画面",
        b4: "在授权完成前，请勿关闭窗口",
        b5: "验证完成",
        b6: "授权未成功，请重试！",
        close: "关 闭",
        reQuery: "重新查询",
        b9: "为了自动获取订单信息，请至您的Cdiscount卖家后台设置API账户，并在下方提供API相关信息。",
        b20: "为了自动获取订单信息，请至您的OnBuy卖家后台查看API的信息，并在下方提供API相关信息。",
        b10: "如何获取店铺API信息？",
        b11: "请输入正确的店铺地址",
        b12: "输入值不能都为空格",
        b13: "卖家编号必须为数字值",
        b14: "长度为1-64位",
        b18: "长度为1-200位",
        b15: "请输入正确的邮箱地址",
        b16: "添加成功!",
        b17: "店铺更新授权成功!",
        bRebind: "店铺重新绑定成功！",
        b19: "因送至监管的店铺订单不能拆分，送至监管的数据订单总金额可能会比付款到账金额大",
        c1: "请选择是否同时创建收款账号",
        c2: "否",
        c3: "是",
        c4: "绑定店铺成功，分配的银行账号为",
        c5: "查看银行账号信息",
        c6: "店铺授权成功，请返回之前的页面继续完成流程",
        c61: "店铺授权失败，请联系您的客户经理。",
        c7: "关联银行账号",
        c10: "关联银行账号",
        c8: "API账号",
        c9: "API密码",
        c11: "分配的银行账号为",
        shopOrderManagement: {
            tranId: "文件批次号",
            quickSFName: "快速搜索文件名称",
            upTime: "上传时间",
            plat: "平台",
            fileName: "文件名称",
            edu: "生成订单额度",
            status: "审核状态",
            up: "上传订单",
            a1: "请勿增加/删除/修改模版中表头字段及其顺序（含中文表头和英文表头）；",
            a2: "相同的订单号+物流单号将被视为同一笔订单，如您的订单包含多个子订单，请导出子订单或在主订单号上标注-1/-2等；",
            a3: "依据监管要求，订单信息将作为人民币结汇的依据，请保证信息的真实性，否则将影响款项到账。",
            a4: "支持不超过10MB的.xls及.xlsx格式文件，单次只能添加一个文件",
            a5: "请上传订单文件",
            a6: "下载模板",
            a7: "将文件拖到此处，或",
            a8: "订单所属类型",
            a9: "平台名称",
            submit: "提交订单文件",
            a10: "太棒了，订单已提交",
            a11: "处理订单文件可能需要一些时间，请您耐心等待并在文件处理完成后至订单管理记录下查看详情。",
            a12: "继续上传订单",
            a13: "查看订单列表",
            a14: "明细结果下载",
            a15: "您的订单",
            a16: "解析成功笔数/失败笔数",
            a17: "解析失败数据下载",
            d1: "用于获取额度的订单有效期默认为180天（约六个自然月），请及时关注额度有效期。避免额度过期失效影响正常使用；",
        },
        c12: "请选择收款账号币种",
        c13: "请选择收款账号开设地区",
        d1: "店铺注册信息截图上传",
        d2: "确保上传的图片文字清晰可见，最大不超过10M，支持JPG、PNG、JPEG",
        d3: "如何查看Amazon店铺注册信息？",
        d4: "店铺注册信息截图",
        d5: "审核拒绝",
        cared5: "店铺审核未通过，请重新绑定店铺",
        d6: "收款账号申请提交成功，请稍后在全球收款-账户管理页面查看账号；",
        d7: "收款账号分配成功，请稍后在全球收款-账户管理页面查看账号",
        d8: "店铺绑定成功",
        d81: "店铺绑定",
        d9: "绑定店铺成功，请稍后在全球收款-账户列表中查看新分配的银行账号信息。",
        d10: "待审核",
        d11: "如何获取Token？",
        d12: "收款账号分配成功",
        d13: "什么是有效订单额度？",
        d14: "将于30天后过期，请合理安排使用",
        d15: "如何获取订单额度？",
        d16: "店铺列表",
        d17: "为满足中国大陆外汇监管政策，当您提现/付款人民币时，需要您提供入账资金对应的近180天的订单信息以证明资金来源的合理性。",
        d18: "iPayLinks将会根据获取到的订单明细按照近180天内的规则实时汇总生成您的有效订单额度，您可以在有效订单额度内发起提现/付款；如果发起金额超过现有有效订单额度，则您需要重新获取订单明细以更新额度。",
        d19: "鉴于上述规则，",
        d20: "建议您在资金入账后180天内完成提现/付款，否则可能影响您的人民币付款体验。",
        d21: "您可以通过以下四种方式获取：",
        d22: "1、绑定您的店铺到您的iPayLinks账户来获取额度，",
        d23: "2、如果您绑定了阿联酋及沙特站，您可以通过手动同步订单数据获取额度，",
        d24: "3、如果您通过以上两种方式仍无法完成，您可通过“订单管理”上传订单获取额度，",
        d25: "4、您可以随时联系客户经理或在线客服获取协助",
        d26: "付款订单编号",
        d27: "订单创建时间",
        d28: "订单状态",
        d29: "订单额度",
        d30: "前往添加",
        d31: "前往上传",
        d32: "店铺注册信息填写指引",
        d33: '如何填写"店铺注册信息"',
        howAddShopUrl: "如何填写店铺网址",
        d34: "点击添加店铺，您需要登录亚马逊卖家账户，勾选授权协议，点击继续，即可完成。",
        d34re: "点击添加收款账号，您需要登录亚马逊卖家账户，勾选授权协议，点击继续，即可完成。",
        d35: "请确保您的授权操作是在该店铺的常用IP环境来进行操作，以免发生店铺关联。",
        d36: "跳转授权",
        d37: "填写授权信息",
        d39: "前往亚马逊后台授权",
        d40: "电商平台",
        d41: "独立站",
        d42: "电商平台名称",
        d43: "独立站名称",
    },

    //账户设置
    accountSetting: {
        AccountName: "账户昵称",
        AccountNumber: "账户号码",
        Website: "网站",
        Individual: "用户类型",
        Enterprise: "个人/企业",
        EntityInformation: "个人信息",
        EntityName: "主体名称",
        farenzl: "法人资料",
        EntityInformation2: "企业信息",
        Industrytype: "行业类型",
        EnterpriseFile: "商业文件",
        EntityFile: "个人文件",
        IDCard: "个人身份证/护照",
        Verified: "已验证",
        country: "所在国家/地区",
        Youridentityfilling: "您填写这份表格的身份为",
        registerCountry: "企业注册国家或地区",
        BusinessLicense: "营业执照/公司注册证明书/商业登记证/合伙协议照片",
        AddNewUser: "新建用户",
        AddNewRoles: "新建角色",
        editUser: "编辑用户",
        editRoles: "编辑角色",
        Operations: "操作",
        Email: "用户邮箱",
        Username: "用户名称",
        Roles: "角色管理",
        Users: "用户",
        Role: "分配角色",
        ModifiedTime: "最后修改时间",
        Status: "状态",
        Edit: "编辑",
        Delete: "删除",
        Choosearole: "选择角色",
        Noroleyouneeded: "没有您要选择的角色？去角色管理中添加角色",
        RoleName: "角色名称",
        RoleDescription: "角色描述",
        Operablepermissions: "可操作权限",
        AccountSecurity: "安全验证",
        Securityverification1: "已开启安全验证，在重要资金交易前将发送动态验证码至",
        Securityverification2: "未开启安全验证，您可开启安全验证并指定验证手机号或邮箱，在重要资金交易前发送动态验证码。",
        Securityverification3: "未开启安全验证，交易时将不再发送动态验证码至",
        Edit2: "修改",
        verificationsentto: "验证码将发送至",
        verificationcode: "获取验证码",
        Confirm: "提 交",
        Cancel: "取 消",
        UserInfo: "用户信息",
        Basicinfo: "基本账户信息",
        PhoneNumber: "手机",
        ResetPassword: "重置密码",
        characters: "8~20字符，只能包含字母、数字、以及标点符号(除空格)，字母、数字、符号至少包含2种，字母区分大小写",
        newcharacters: "密码长度必须至少是8位字符，密码是以系统可支持的字符组成，必须同时包括数字、字母和特殊字符（!#@?.+;=~`）",
        manager: "为了账户及交易安全，当前仅可通过人工方式修改验证手机号或邮箱，请联系您的客户经理。",
        Toensure: "为了账户及交易安全，验证码将发送至",
        enterRolesName: "请输入角色名称",
        enterRolesDescription: "请输入角色描述",
        reSent: "重新发送",
        // pleasesetphonenumber: '请设置验证手机号或邮箱',
        pleasesetphonenumber: "请设置验证手机号",
        choosepermissions: "请选择权限",
        enabledsuccessfully: "安全验证开启成功",
        disabledsuccessfully: "安全验证关闭成功",
        cannotbemodified: "暂不可修改",
        gotit: "知道了",
        Newuserscreatedsuccessfully: "用户添加成功",
        Pleaseremindpassword: "请注意查收邮件，通过这封邮件设置用户的密码就即可登录。",
        Deletecontinue: "删除该用户, 是否继续?",
        Deletecontinue2: "删除该角色, 是否继续?",
        Permissions: "权限",
        successfully: "新建成功",
        tips: "提示",
        deleteSuccess: "删除成功",
        next: "下一步",
        Mobileboundsuccessfully: "手机绑定成功",
        Unbound: "未绑定",
        Verifymailbox: "验证原邮箱",
        Verifymobilephone: "验证原手机",
        Isavailable: "原邮箱是否可用？",
        CanSMS: "原手机是否能接收短信？",
        Cannotreceive: "不能接收",
        Contactforhelp: "请联系客户经理获取帮助。",
        Canreceive: "能接收",
        bindmailbox: "绑定邮箱",
        Modifymailbox: "修改邮箱",
        bindPhone: "绑定手机",
        ModifyPhone: "修改手机",
        ModifySuccess: "修改成功",
        modifyUsername: "修改用户名",
        modifyAccountName: "修改帐户昵称",
        Passwordupdated: "您的密码已更新",
        CurrentPassword: "现有密码",
        NewPassword: "新建密码",
        Newpasswordcurrentone: "新密码不能与现有密码一致",
        NewPasswordempty: "密码确认不能为空",
        passwordaboveone: "两次登录密码输入不一致",
        entercurrentpassword: "请输入现有密码",
        enternewpassword: "请输入新密码",
        confirmNewPass: "确认新建密码",
        Inorderfirstly: "为了不影响您使用iPayLinks服务，请先完成账户实名验证",
        View: "查 看",
        completedverification: "完成账户实名验证",
    },
    //店铺迁移
    storeTransfer: {
        trans: "店铺迁移",
        chooseTrans: "请选择需迁移的店铺",
        chooseTrans2: "请您先选择想要迁移的店铺平台",
        selectPlat: "请选择平台站点",
        searchName: "快速搜索店铺名称",
        a1: "待迁移店铺",
        a2: "请从左侧选择要迁移的店铺",
        a3: "请填写接收方账号信息",
        a4: "提交迁移申请后，店铺及相应的可用订单额度将移至接收方账户下（若店铺有关联的收款账号时对应收款账号、未入账资金也会迁移），请确认接收方的账户号码填写准确，并仔细核对接收方名称。",
        a5: "如何查询账户号码？",
        a6: "接收方账户号码",
        a7: "请填写接收方的账户号码",
        recipientName: "接收方名称",
        a8: "请填写账户号码后查看",
        confirmTrans: "确认迁移",
        a9: "接收方账户信息",
        a10: "登录iPayLinks后即可在菜单左上方查看到账户号码， 或进入“账户设置-账户信息”页面查看账户号码：",
        a11: "核对接收方名称",
        a12: "准确填写接收方账户号码后，请核对接收方的个人或公司名称 (名称以账户信息页为准)。",
        know: "知道了",
        confirmStore: "店铺迁移确认",
        a13: "您可申请将店铺迁移至其他iPayLinks账户。",
        a14: "迁移店铺的可用订单额度将在迁移完成后增加至接收方的账户下。",
        a19: "店铺有关联的收款账号时该店铺及其收款账号、未入账资金将全部移至接收方账户下",
        apply: "申请迁移",
        in: "迁入记录",
        out: "迁出记录",
        qysh: "迁移审核",
        faqi: "发起方",
        jieshou: "接收方",
        time: "迁移时间",
        status: "迁移状态",
        plat: "平台站点",
        a15: "请输入接收方账户号码",
        a16: "请输入发起方账户号码",
        backList: "店铺迁移列表",
        a17: "确认迁移",
        shop: "个店铺",
        modify: "返回修改",
        suc: "店铺迁移成功",
        a18: "迁移失败，待迁移的店铺中对应关联的收款账号与其他店铺同时存在关联关系，您可以同时选择所有关联店铺完成迁移",
        transferReason: "迁移原因",
        a20: "您二者主体之间无任何关系，请上传关系合作协议等关系说明，支持png,jep,jpeg,pdf，总数量不超过5张，最大小不超过2M",
        a21: "仅支持png,jep,jpeg,pdf",
        a22: "最大不超过2M",
        a23: "迁移说明?",
        a24: "1）收款账号/店铺迁移说明",
        a25: "如果收款账号跟店铺绑定了，则迁移账号/迁移店铺时会将二者一同迁移；如果一个收款账号下绑定了多个店铺，不能只迁移部分店铺，只能全部迁移。",
        a26: "2）关于 “收款账号/店铺迁移 ” 费率的说明",
        a27: "系统将自动为您在迁出账号（A账号）费率和迁入账号（B账号）费率间选取最优费率，若无法选取成功（可能由于费率模式不同导致），将维持迁入账号（B账号）费率，若您需要调整可联系您的客户经理。",
        a28: "3）关于 “收款账号/店铺迁移 ” 优惠的说明",
        a29: "相关的优惠权益限当前账户使用，不会随收款账号/店铺迁移而变动。\n",
        a30: "4）关于 “收款账号/店铺迁移 ”的入账说明",
        a31: "收款账号迁移后，收款入账会归属到新的账户下。如果只迁移了店铺，未迁移收款账号，则收款入账还是在原来的账户；如果原收款账号的入账资金想要转移到新的账户下，请通过“转账”进行操作。",
        a32: "5)  店铺迁移后，人民币还原额度说明",
        a33: "店铺迁移后，该店铺的未使用的还原明细也会迁移到新账户下。",
        a34: "具体说明",
        a35: "提交成功",
        a36: "请输入具体原因",
        a37: "店铺编号",
        a38: "请上传资料",
        a39: "审核通过",
    },
    //    收款账号迁移
    accountTransfer: {
        trans: "收款账户迁移",
        a1: "您可申请将收款账户迁移至其他iPayLinks账户。",
        a2: "快速搜索银行账号",
        a3: "请输入发起方账户号码",
        a4: "请输入银行账号",
        a5: "收款账户币种",
        a6: "收款账户昵称",
        a7: "申请收款账户迁移",
        a8: "快速搜索收款账户昵称或银行账号",
        a9: "全部收款账户",
        a10: "待迁移收款账户",
        a11: "请从左侧选择要迁移的收款账户",
        a12: "请填写接收方账号信息",
        a13: "提交迁移申请后，相应收款账户 (及暂未入账的收款金额) 将移至接收方账户下（若收款账号关联店铺则对应店铺及相应的可用订单额度也会迁移），请确认账户号码填写准确并仔细核对账户姓名等相关信息。",
        transferList: "收款账户迁移列表",
        a14: "请选择需迁移的收款账户",
        collectionaccount: "的收款账户",
        Selected: "已选择",
        a15: "为什么进行店铺绑定？",
        a16: "我知道了",
        a17: "1、绑定店铺是为了满足中国外汇监管的合规要求，所有资金入境均需要证明资金合法来源。",
        a18: "2、您绑定店铺所提供的所有商业信息，iPaylinks承诺会予以严格保密，不会将资料提供给与您收款服务无关的任何单位或个人，以及将商业信息用于收款外的任何其他商业用途。具体您可以参阅《用户注册协议》与《隐私协议》",
    },
    //钱包
    wallet: {
        walletDetail: "钱包详情",
        balance: "余额",
        recharge: "充值",
        set: "货币显示设置",
        tranId: "业务订单号",
        tranType: "业务类型",
        fundType: "资金类型",
        time: "入账时间",
        amount: "交易金额",
        miaoshu: "资金描述",
        yue: "余额",
        keyongyue: "可用余额",
        dongjie: "冻结金额",
        a1: "实际可用来付款或者换汇的金额",
        a2: "冻结金额，暂不可用",
        transactionId: "冻结流水号",
        tranAmount: "冻结金额",
        holdDetail: "冻结明细",
        downloadLiu: "下载流水",
        download: "导出",
        holdTime: "冻结日期",
        holdReason: "冻结原因",
        quickSearch1: "快速检索业务订单号",
        quickSearch2: "快速检索冻结流水号",
        addBalance: "充值到余额",
        chooseCurrency: "您希望以何种货币进行充值",
        available: "可用余额",
        a3: "请使用与注册人同名的银行账户通过网银或线下转账方式转入以下银行账户完成账户充值，非同名账户充值的资金将被退回。",
        newa3: "您如果首次使用该功能，请您务必联系客户经理进行报备，以便保证您的资金能够顺利到账，否则可能会被退回并发生退款手续费。",
        bankLocation: "开户地",
        accountName: "账户名称",
        swift: "SWIFT代码",
        bankCode: "银行号",
        branchCode: "分行代码",
        accountNumber: "银行账号",
        Reference: "交易附言",
        a4: "我们将通过附言确定您充值的账户，转账时请您务必正确填写充值附言；",
        newa4: " 我们将通过附言确定您充值的账户，转账时请您务必正确填写充值附言；",
        a5: "充值资金到账通常需要1~3个工作日，请提前转账以免出现交易延迟问题。",
        a6: "转账过程中可能会被中间行收取费用，请确保转账金额是充足的，以免出现到账金额不足。",
        a7: "一旦我们收到银行到账通知会立即进行资金入账。",
        a11: "请正确填写银行账户信息，若错误操作导致资金被退回可能被银行收取1-30USD/GBP的退款手续费，具体以实际银行扣费为准。",
        a12: "退款扣费1~30USD/GBP不等，具体以实际银行产生的费用为准；",
        toExchange: "进入换汇",
        turnover: "账户流水",
        display: "币种显示设置",
        currencyBalance: "有余额的币种",
        a8: "为了避免您错过重要信息，有余额的币种将自动展示在余额列表中且不可隐藏。",
        otherCurrency: "其他币种",
        a9: "您可选择是否将以下币种展示在余额列表中。",
        jl: "记录",
        a10: "为了您资金顺利入账，请使用与注册人同名的银行账户操作付款至我们提供给您的充值账户中。",
        newa10: "为了您资金顺利入帐，请使用",
        newa11: "与注册人同名的银行账户",
        newa12: "，通过网银或线下转账的方式转入我们提供给您的银行账户中，非同名银行账户充值的资金将被退回。",
        szlx: "收支类型",
    },
    // 付款
    sendMoney: {
        my: "我自己",
        other: "其他收款人",
        pleaseSElect: "请选择收款账户",
        addNew: "添加我的账户",
        addNew2: "新增收款人",
        send: "付款",
        recipient: "收款人",
        amount: "金额",
        detail: "详情",
        send2: "付款",
        toChina: "付款到中国大陆",
        guide: "用户指南",
        regulation: "请注意监管政策：",
        a1: "订单信息用来证明资金来源以满足付款到中国大陆的监管政策。",
        a2: "您可以通过绑定您的店铺到您的iPayLinks账户来提供这些信息。",
        next: "下一步：金额",
        sendTo: "付款至",
        a3: "您的有效订单额度",
        a4: "其他公司或者个人银行账户",
        a5: "本人银行账户、公司公账或者法人银行账户",
        a6: "您的付款金额",
        buchongxinxi: "补充信息",
        date: "付款日期",
        purpose: "用途",
        reference: "附言",
        nextDetail: "下一步：详情",
        nextSend: "下一步：预览并付款",
        receive: "预计收到",
        sendAmount: "付款金额",
        receiveAmount: "预计收到的金额",
        total: "您总共付款",
        feeDetail: " 费用详情",
        nickName: "收款人昵称",
        bankName: "收款人银行账户名称",
        currency: "付款币种",
        bankLocation: "收款人银行所在地",
        recipientInfo: "收款人信息",
        bankAccountName: "银行账户名称",
        totalFee: "手续费合计",
        a7: "付款人支付费用",
        fee1: "固定费",
        fee2: "比例费",
        fee3: "附加费用",
        Coupons11: "优惠券抵扣费用",
        a8: "请确认您的付款详情",
        payMethod: "支付方式",
        amountSum: "金额汇总",
        rate: "汇率",
        a9: "需要的订单额度",
        a10: "您请先提供订单信息以付款至中国大陆",
        a11: "提供订单",
        a12: "费用合计",
        a13: "您共计付款",
        a14: "日期和附言",
        a15: "付款已提交成功",
        a16: "您刚刚付款",
        a17: "至",
        a18: "您总共从余额支付",
        a19: "请您在付款前确认金额",
        a20: "费用金额",
        b1: "汇率已刷新",
        b2: "返回编辑",
        b3: "确认并付款",
        download: "下载历史记录",
        max: "最大金额",
        maxTitle: "最大付款金额",
        maxMes: "基于当前该币种的可用余额，扣除手续费后您可支付的最大付款金额。",
        normallyTake: "订单成功提交后，",
        // daoZhang:'到账，付款额度为',
        daoZhang: "到账",
        daoZhangEnd: "",
        noAccounts: "您还没有账户，请添加",
        addNewAccount: "添加账户",
        brmc: "显示本人名称作为付款方",
        brmc1: "此功能会收费，具体费用请在下一步“费用合计”中查看",
        defaultIpl: "默认将显示iPayLinks作为付款方信息，如需显示您本人名称作为付款人，请勾选本行内容。",
        fkfmc: "付款方名称",
        sufficientBalance: "账户余额充足",
        insufficientBalance: "账户余额不足",
        rmbedzg: "有效订单额度充足",
        rmbedbz: "有效订单额度不足",
        purposeDesc: "用途描述",
        taxNo: "请描述您的付款用途，比如：出口货物款",
        branchName: "支行名称",
        paymentPurpose: "交易用途",
        paymentReference: "交易附言",
        paymentReferencex: "交易附言（选填）",
        sdhl: "本次付款为您锁定汇率",
        hldjs: "倒计时后汇率可能会变化，请留意金额变化",
        gzddztbh: "请在交易管理列表及时关注订单状态的变化",
        yjdjs: "预计到账时间",
        continuePayment: "继续付款",
        viewDetails: "查看详情",
        yzmfsz: "为了账户及交易安全，验证码将发送至",
        securityVerification: "安全验证",
        inputVerificationCode: "请输入验证码",
        srzzs: "请输入正整数金额",
        srlwxs: "请输入两位小数的金额",
        jyfy: "可输入识别本次付款信息，如订单号等",
        onlyAllowed: "只允许输入半角英文空格",
        Supportnumbersandspaces: "仅支持大小写英文字母、数字、空格",
        VerificationCode: "获取验证码",
        pstpc: "请选择扣款币种",
        qxzskbz: "请选择收款币种",
        qxzskr: "请选择收款人",
        qxzjyyt: "请选择交易用途",
        cdbcg255: "长度不超过255位",
        qsrytms: "请输入用途描述",
        qsrswsbhm: "请输入税务识别号码",
        cdbcg20: "长度不超过20位",
        transactionID: "订单编号",
        BatchPaymentID: "批量付款编号",
        to: "至",
        payerNickName: "付款人昵称",
        bankNameOnly: "银行名称",
        fkbz: "付款币种",
        fkrq: "付款日期",
        yhszd: "银行所在地",
        upTo31Days: "日期最长可选择31天",
        processing: "加载中，请稍后",
        fkjr: "付款记录",
        all: "全部",
        fkg: "付款给",
        jsz: "缴税至",
        fkpz: "付款凭证",
        ddjcxx: "订单基础信息",
        ddzt: "订单状态",
        sbyy: "失败原因",
        fkrxx: "付款人信息",
        fkrmc: "付款人名称",
        tpje: "退款金额",
        tpxx: "退款信息",
        tksxf: "退款手续费",
        tpsj: "退款时间",
        tpyy: "退款原因",
        qxzbz: "请选择币种",
        Personal: "个人",
        enterprise: "企业",
        zbzcxclxskrfk: "暂不支持向此类型收款人付款",
        qsrqbnr: "请输入全部内容后提交",
        sjcf: "数据重复，请勿重复添加",
        xzcg: "下载成功",
        qxzskdq: "请选择收款地区",
        qxzskrlx: "请选择收款人类型",
        tj: "添加",
        rechargecontinuing: "请您在继续前先充值",
        dbfk: "单笔付款",
        b4: "最低不能小于：",
        b5: "最高不能超过：",
        b6: "您的付款金额最低不能小于：",
        b7: "您的付款金额最多不能超过：",
        ddcjsj: "订单创建时间",
        ddlx: "订单类型",
        //    批量付款
        bulkPayment: {
            Paymentlist: "付款列表",
            returnBack: "返回批量付款列表",
            bulkPayment: "批量付款",
            id: "批量付款编号",
            time: "上传日期",
            fileName: "批量付款文件",
            num: "总付款笔数",
            status: "处理状态",
            create: "创建批量付款",
            pId: "批次编号",
            createNew: "创建批量付款",
            uploadFile: "请上传批量付款文件",
            p1: "查看付款记录及详情",
            p2: "汇率波动和余额不足等原因仍可能导致付款失败，请至付款记录下关注付款结果",
            p3: "系统正在处理付款，请在处理完成后前往“付款列表”查看付款记录",
            a1: "请参考批量付款文件模板中的要求及示例进行填写。",
            a2: "如尚无文件模板或付款国家、付款币种等信息已改变，请先",
            a3: "下载批量付款模板",
            a4: "点击上传文件",
            a5: "支持不超过10MB的 .xlsx 格式文件，最多支持1000笔批量付款",
            pTemp: "批量付款模板",
            a6: "不同的付款国家、付款方式及收款人类型所需填写的付款信息不同，请在下方选择并下载模板",
            a7: "锁定付款金额",
            a8: "锁定预计收到金额",
            No: "序号",
            payTo: "付款至",
            accCurrency: "收款人账户币种",
            accType: "收款人类型",
            noData: "暂无记录，",
            pleaseAdd: "请添加",
            downTem: "下载模板",
            downing: "下载中，请稍后",
            uping: "文件上传中，请稍后",
            a9: "请考虑汇率波动、付款手续费等因素，提交批量付款前请留意各付款币种的余额是否充足。如包含至中国大陆的付款，请确保足够的可用订单额度，以避免付款失败。",
            a10: "提交批量付款文件后，请至“付款列表”查看付款详情。",
            submit: "提交批量付款文件",
            a11: "上传文件",
            sucTitle: "太棒了，您的批量付款指令已提交成功！",
            a12: "您的批量付款",
            a13: "正在处理中",
            payNum: "付款笔数",
            a14: "处理批量付款可能需要一些时间，请耐心等待并在文件处理完成后至“批量付款”或“付款列表”查看付款详情。",
            toPay: "继续批量付款",
            toDetail: "查看付款详情",
            a15: "该文件名曾经上传，建议再次核查信息以避免重复付款，请修改文件名后重试",
            qck: '请参考<span style="color: #34495e;font-weight: bold">批量付款文件模板</span>中的要求及示例进行填写。',
            tips: "提示",
            zzjc: "正在检查文件数据，请稍后",
            zzjy: "系统正在校验付款基本信息，处理中请勿离开或关闭页面",
            plfkqr: "批量付款确认",
            wjjywc: "文件校验完成，您将批量付款",
            bh: "包含",
            bi: "笔",
            fk: "付款。",
            wlzhaq: "为了账户资金安全，请完成验证后确认提交，验证码将发送至",
            qsryzm: "请输入验证码",
            tj: "提交",
            bfk: "笔付款",
            qclcw: "请处理错误的付款信息",
            cwfkxx: "错误付款信息，如格式错误、遗漏必填字段等原因。",
            qxzjgwj: "请下载结果文件，根据错误原因修改后重新提交批量付款文件",
            xzjgwj: "下载结果文件",
            wjbncg100MB: "文件不能超过10MB",
            wjbncg2MB: "文件不能超过2MB",
            xlsxOnly: "仅支持.xlsx 格式文件！",
            Processing: "文件上传中，请稍等……",
            verificationCode: "重新发送",
            retryAfter: "s后可重新发送",
            VerificationCode: "获取验证码",
            ksssplfkwjm: "快速搜索批量付款文件名",
            submitPay: "提交付款",
            batchpaymentfilename: "付款文件名",
            confirmSubmit: "是否确认提交",
            plfklb: "批量付款列表",
            a16: "备注：付款上传文件前请先检查余额是否充足，以免余额不足造成付款失败",
        },
        b8: "最大不超过10M，支持ZIP、RAR格式",
        b9: "文件压缩包",
        b10: "大额付款可能分多笔到账",
        b11: "优惠券抵扣总金额",
        b12: "不使用优惠券",
        SHA: "SHA：收款方和付款方共同承担中间行费用，到账金额请以收到金额为准。",
        OUR: "OUR：付款方承担中间行费用，到账金额请以收到金额为准。",
        BEN: "BEN：收款方承担中间行费用，到账金额不可控，差距可能较大。",
        b13: "额度不足原因",
        b14: "造成您订单额度不足的原因可能是：",
        b15: "5.若您无法确认您额度不足的原因，请联系客服（右边边栏）进行处理。",
        b16: "银行出款中",
    },
    // 收款人
    payee: {
        recipients: "收款人",
        newPayee: "新增收款人",
        bankLocation: "银行账户所在地",
        type: "收款人类型",
        currency: "账户币种",
        bankNo: "银行账号",
        bankInfo: "银行账户信息",
        a1: "收款人银行预留手机号码",
        phone: "收款人手机号码",
        email: "收款人邮箱",
        add: "收款人地址",
        addressRequired: "请输入收款人地址",
        addressInvalid: "仅支持英文大小写字母、数字、英文空格及特殊字符 / ( ) . , - ? : #，不支持回车换行，且不能为纯数字",
        post: "收款人邮编",
        option: "（可选）",
        contactInfo: "联系人信息",
        identityInfo: "认证信息",
        occ: "收款人职业",
        idType: "证件类型",
        deleteP: "删除收款人",
        delete: "删除",
        newPayees: "新的收款人",
        a2: "请您设置一个昵称以便您可以快速检索",
        a3: "快速检索收款人昵称",
        save: "保存",
        a4: "请您输入银行账户所在地和币种来查看可用的支付方式",
        p1: "编辑收款人",
        p2: "针对中国大陆收款人，收款人需要提供收款人证件给银行",
        p3: "请您确保图片是清晰的且四个边都清晰露出。文件最大为5MB",
        p4: "示例图",
        p5: "请您确认自动识别的身份证号码",
        p6: "公司注册号码",
        p7: "请输入公司注册号码",
        p8: "请上传身份证正反面",
        p9: "请上传营业执照",
        p10: "请上传身份证",
        p11: "查看全部",
        p12: "当前只支持法人名称",
        p13: "请您输入准确的账户名称",
        p14: "其他收款人账户",
        p15: "付款人民币至中国大陆境内的个人账户，当前仅支持付款至企业法人个人银行账户，请确保个人姓名和账户名称准确。",
        p16: "付款人民币至中国大陆境内的企业账户，当前仅支持付款至您注册验证时的企业银行账户，请至“我自己”的银行账户下添加",
        list: "收款人列表",
        accountDetail: "提现账户详情",
        payeeDetail: "详情",
        onlySpace: "空格，特殊字符等也需要是英文格式；",
        onlySpace2: "空格必须是英文半角",
        classify: "收款人分类",
        classify2: "分类",
        //    缴税机构
        taxpayer: {
            newTaxpayer: "新的缴税机构",
            editTaxpayer: "编辑缴税机构",
            addTaxpayer: "新增缴税机构",
            taxpayer: "常用缴税机构",
            taxType: "缴税机构账户类型",
            taxLocal: "缴税机构所在地",
            taxCurrency: "缴税币种",
            taxpayerName: "缴税机构账户名称",
            placeEnterTaxpayerName: "请您输入准确的缴税机构账户名称",
        },
    },
    // 提现
    withdraw: {
        w1: "添加我的银行账户",
        editAccount: "编辑我的银行账户",
        AccountNickname: "账户昵称",
        w2: "请您设置一个昵称以便您可以快速检索",
        BeneficiaryType: "收款人类型",
        enterprise: "企业",
        personal: "个人",
        companyName: "企业名称",
        inputCompanyName: "请输入企业名称",
        zhangsan: "张三",
        firstName: "名",
        w3: "请输入名",
        lastName: "姓",
        w4: "请输入姓",
        w5: "银行账户所在地区",
        w6: "请您选择银行账户所在地区",
        accountCurrency: "账户币种",
        w7: "请您选择币种",
        w8: "请您输入银行账户所在地和币种来查看可用的支付方式",
        w9: "暂不支持往此国家付款",
        w10: "需要收款人证件",
        w11: "请您稍后提供收款人证件",
        w12: "请选择账户名称",
        w13: "请输入银行名称",
        w14: "请填写银行全称，简称可能造成付款失败",
        branchName: "支行名称",
        w15: "请输入支行银行名称",
        w16: "银行预留手机号",
        w17: "请您输入银行预留手机号",
        w18: "请输入",
        w19: "必须填写英文",
        w20: "查询联行号",
        w21: "如果您只有IBAN，请输入IBAN的最后8位",
        w22: "请将分行号码一起输入",
        w23: "身份信息",
        occupation: "职业",
        w24: "请选择职业",
        w25: "身份证信息",
        w26: "身份证正面照片",
        w27: "身份证背面照片",
        w28: "无有效证件",
        w29: "身份证号码",
        w30: "请输入证件号",
        w31: "暂只支持中国大陆居民",
        w32: "企业信息",
        w33: "营业执照图片",
        w34: "营业执照号码",
        w35: "请输入营业执照号码",
        w36: "暂只支持中国大陆企业",
        w37: "联系人信息",
        w38: "收款人手机号码",
        w39: "请您输入收款人手机号码",
        w40: "收款人邮箱（可选）",
        w41: "请输入收款人邮箱",
        w42: "收款人地址",
        w43: "请选择国家/地区",
        w44: "请选择省/州",
        w45: "城市",
        w46: "请输入具体地址",
        w47: "收款人邮编（可选）",
        w48: "请输入收款人邮编",
        save: "保存收款人",
        w49: "请输入手机号码",
        w50: "请输入正确的手机号码",
        w51: "不可输入汉字",
        w52: "仅支持数字、字母、空格",
        w53: "请输入英文字母",
        w54: "仅支持英文大小写字母、数字、空格及,.-",
        w55: "请输入收款人昵称",
        w56: "长度为1-50位",
        w57: "请输企业名称入",
        w58: "长度为1-256位",
        w59: "长度为1-20位",
        w60: "请输入具体地址",
        w61: "请输入正确的邮箱地址",
        w62: "请选择证件类型",
        w63: "请输入证件号",
        w64: "请选择",
        w65: "请选择币种",
        w66: "请输入收款人银行名称",
        w67: "请输入银行支行名称",
        w68: "请输入收款人银行账号",
        w69: "请输入手机号",
        w70: "请选择付款方式",
        w71: "请选择职业",
        w72: "新增成功",
        w73: "请输入密码",
        w74: "请输入正确的",
        w75: "银行账户信息校验中，可能需要几分钟",
        w76: "验证中",
        w77: "收款人银行账户信息校验失败，请您检查收款人信息并重新提交。",
        w78: "验证失败",
        w79: "提现账户基本信息",
        w80: "收款人名",
        w81: "收款人姓",
        w82: "将删除, 是否继续?",
        w83: "提示",
        w84: "确定",
        w85: "取消",
        w86: "请稍后...",
        w87: "删除成功",
        w88: "我的银行账户",
        a4: "请您输入银行账户所在地和币种来查看可用的支付方式",
        Onlyspaces: "只支持英文字母数字空格和",
        enterregistrationemail: "请输入注册邮箱",
        entername: "请输入名称",
        w89: "仅支持英文大小写字母、数字、空格及,.",
        w90: "仅支持汉字、大小写字母、数字、空格及,.",
        w91: "支持中文 英文大小写字母 数字 :., 空格 &()@*;_- — ——",
        w92: "支持英文大小写字母 数字:., 空格 &()@*;_- — ——",
        w93: "支持中文 英文大小写字母 数字:., 空格 &()@*;",
        w95: "支持英文大小写字母 数字:., 空格 &()@*;",
        w94: "为了保证您能及时付款成功，我们可能会自动去除当前银行不支持的特殊字符，该操作不会影响您的正常付款。",
    },

    transfer: {
        Transfer: "转账",
        TransferAmount: "转账金额",
        Purpose: "转账用途",
        Confirmyourtransferdetails: "确认转账交易信息",
        Transferto: "转账到其他IPL账户",
        Transferto2: "转账到",
        enterAccountNo: "输入账户号码",
        BeneficiaryName: "输入收款方名称",
        Max: "最大付款金额",
        maxfee: "基于当前该币种的可用余额，扣除手续费后您可支付的最大付款金额。",
        Totalamount: "您总共转账",
        Accountbalance: "账户余额",
        Sufficientbalance: "账户余额充足",
        Insufficientbalance: "账户余额不足",
        Details: "转账详情",
        Pleaseselectpurpose: "请选择转账用途",
        PurposeDescription: "用途说明",
        enterpurposedescription: "请输入用途说明",
        TransferDate: "转账日期",
        TransferingDetails: "请确认您的转账详情",
        DateReference: "日期和附言",
        Transfersuccessfully: "您的转账申请已提交",
        Transferfailed: "抱歉，转账失败",
        TransferHistory: "请在转账交易列表中查看最新的转账状态",
        CNYtogether: "此笔转账会默认将订单额度一起转出",
        CreateTransfer: "继续转账",
        Checkdetails: "查看详情",
        Backto: "返回上一步",
        verificationsentto: "为了账户及交易安全，验证码将发送至",
        VerificationCode: "请输入验证码",
        Cancel: "取 消",
        Submit: "提 交",
        Pleaseenteramount: "请输入正整数金额",
        Pleaseenteplaces: "请输入两位小数的金额",
        Transferthan0: "转账金额必须大于0",
        Pleaseenterreferences: "请输入交易附言",
        Onlyallowed: "只允许输入半角英文空格",
        Supportnumbersspaces: "仅支持大小写英文字母、数字、空格",
        Transferreference: "交易附言",
        TotalAmount: "转账总额",
        FailedReason: "失败原因",
        BeneficairyInfo: "收款方信息",
        BeneficiaryEntityName: "对手方名称",
        ReceivingAmount: "收款方收到的金额",
        enterBeneficiaryname: "请输入对手方名称",
        searchbeneficiaryname: "快速检索对手方名称",
        sizetotally: "总文件大小不能超过10M",
        upto10files: "最多支持10个文件",
        max31days: "日期最长可选择31天",
        History: "付款记录",
        enterTransferreference: "请输入交易附言",
        transferdetails: "转账信息",
        BeneficiaryAccountNo: "对手方账户号码",
        enterBeneficiaryAccountNo: "请输入对手方账户号码",
        enterOrderId: "请输入订单编号",
        selectStatus: "请选择状态",
        a4: "请您输入银行账户所在地和币种来查看可用的支付方式",
        a5: "转账交易列表",
        AccountStatement: "账户证明信",
        dbzz: "单笔转账",
        a6: "账户间转账",
        dsfmc: "对手方名称",
        dsfzhhm: "对手方账户号码",
        zhjy: "转账交易",
        dbzjdd: "待补资金订单",
        yydh: "预约单号",
        sxsj: "失效时间",
        qxyy: "取消预约",
        ckyylb: "查看预约列表",
        qxyy2: "取消原因",
        qxyy3: "请输入取消原因（100字以内）",
        xybc: "您目前需要补充：",
        yyzzts: "请尽快补足余额，72小时后交易将自动关闭",
        ckzzlb: "查看转账列表",
    },
    //    账户关系 -- 平台账户
    merchants: {
        myMerchantsList: "我的商户列表",
        myMerchants: "我的商户",
        addMerchants: "新增商户",
        registerLink: "商户注册链接",
        quickQuery: "快速搜索账户号",
        accountNo: "账户号码",
        shitiName: "商户名称",
        faqiMethod: "发起方式",
        faqiPerson: "发起人",
        faqiTime: "发起时间",
        lookAll: "查看全部商户详情",
        a1: "全部商户交易信息",
        a2: "您可查看全部商户的账户余额、流水信息。",
        a3: "您可将链接发给商户，商户通过链接注册后，您可在我的商户页面看到授权信息。",
        zhuLink: "主子账户链接 ",
        daiLink: "代理与商户链接 ",
        saccountNo: "商户账户号码",
        accountType: "账户关系类型",
        shouquan: "授权",
        cshouquan: "查看授权",
        balance: "账户余额",
        turnover: "账户流水",
        currency: "币种",
        keyongBalance: "可用余额",
        yezhlx: "余额账户类型",
        frozen: "冻结金额",
        daijiesuan: "待结算金额",
        baozhengjin: "保证金",
        dingdanhao: "业务单号",
        yewuType: "业务类型",
        ruzhangTime: "入账时间",
        jiaoyiAmount: "交易金额",
        zijinmiaoshu: "资金描述",
        shouquanManagement: "授权管理",
        shouquanren: "授权人",
        checkAuth: "查看授权",
        reAuthorization: "重新授权",
        qrReAuth: "确认重新授权",
        a4: "提交后该商户可再次进行授权操作，是否确认重新发起授权？",
        agree: "同意",
        reject: "拒绝",
        ljsq: "立即授权",
        ysq: "已授权",
        yjj: "已拒绝",
        operateSuccess: "操作成功",
        jcsq: "解除授权",
        cxsq: "重新授权",
        shzc: "商户注册",
        jylx: "交易类型",
        rzrq: "入账日期",
        zjlx: "资金类型",
        returnList: "返回列表",
        goCreate: "继续创建",
        a5: "确认要删除该商户的信息?",
        zhyelx: "账户余额类型",
        a6: "确认解除？",
    },
    agreement: {
        a1: "如何绑定Shopify店铺",
        a2: "1. 打开店铺管理页面，点击 <b>+添加新店铺</b> 按钮：",
        a3: "2. 查看平台站点列表，选择 <b>Shopify：</b>",
        a4: "3.输入您的店铺URL, 点击 <b>添加店铺</b> 按钮：",
        a5: "4. 您将自动跳转至Shopify登录页，输入密码并点击 <b>Login</b> 按钮登录：",
        a6: "注意：",
        a7: "若您已经在iPayLinks关联过Shopify的店铺，此时点击按钮 “+添加新店铺“ 会直接登录已关联的Shopify店铺。当您继续关联第二个店铺时，您只需要在Shopify平台退出当前的店铺，并输入即将要关联店铺的账号和密码进行授权即可。",
        a8: "5. 查看信息及协议内容，并点击 安装未列出的应用 按钮进行授权：",
        a9: "6. 授权成功，关联Shopify平台成功，您可在店铺管理查看绑定平台信息：",
        amazon: {
            a1: "如何获取MWS授权令牌",
            a2: "第一步：",
            a3: "用您店铺对应的电脑环境登录亚马逊卖家中心： ",
            a4: "第二步：",
            a5: "在「合作伙伴网络」中点击管理您的应用；",
            a6: "第三步：",
            a7: "点击「为新开发者授权」，进入授权页面；",
            a8: "第四步：",
            a9: "将iPayLinks提供的开发商名称以及开发者ID填写至amazon后台，点击下一页；",
            a10: "第五步：",
            a11: "勾选同意亚马逊官方协议，点击下一页，获取卖家编号以及MWS授权令牌；",
            a12: "第六步：",
            a13: "请将您已获取到卖家编号以及MWS授权令牌填写至iPayLinks添加店铺页面的对应输入框中。",
        },
        noon: {
            a1: "如何获取email",
            a2: "第一步：<br>登录noon平台卖家账号，点击【Profile】",
            a3: "第二步：<br>复制Email并填写至添加店铺页面中",
        },
        cdiscount: {
            a1: "Cdiscount店铺绑定引导",
            a2: "1、请用Cdiscount账号密码登录卖家后台， ",
            a3: "2、点击卖家后台右上角“Settings”，查看店铺Seller ID。然后选择“Your personal settings and bank details”；",
            a4: "3、在“Your personal settings and bank details”选择“Connection informations”；查看您的API账户并修改API密码。",
            a5: "（1）若您之前已经设置过密码，只需找到API用户名，并将之前的密码填入， 如下图",
            a6: "（2）如果您之前还未设置过API密码，您需要咨询您的客户经理或者客服拿到初始密码后再重置密码，使用新密码进行店铺授权。",
            a7: "4、最后在ipaylinks后台店铺管理页面添加店铺并选择Cdiscount平台，将Seller ID、API账号及密码输入，进行绑定店铺。",
        },
        OnBuyShop: {
            a1: "1、请用OnBuy账号密码登录卖家后台，",
            a2: "2、点击卖家后台，查看店铺Seller ID。",
            a3: "3、在“Listing&Products”选择“Imports&Integrations”；查看您的API账户中查看Key。",
            a4: "4、最后在ipaylinks后台店铺管理页面添加店铺并选择OnBuy平台，复制Seller ID、consumer key和secret key，进行绑定店铺。",
            a5: "如何获取店铺API信息？",
        },
        getOrderFlow: {
            Howflow: "如何获取订单流水",
            Step1: "第一步",
            Step2: "第二步",
            Step3: "第三步",
            Step4: "第四步",
            Step5: "第五步",
            Step6: "第六步",
            Step7: "第七步",
            OpenChrome: "打开 Chrome 浏览器，鼠标点击右上角“…”出现下拉框，按下图操作选择 Chrome 扩展程序",
            Clickmenu: "点击左上角扩展程序，在菜单中选择“打开 Chrome 网��应用店”",
            Searchchrome: "在应用商店首页搜索“iPayLinks 贸易真实性信息采集工具”，然后点击“添加至 Chrome”",
            Afteradding: "添加完成后，插件会显示在浏览器上方",
            Loginto: "登录 noon 卖家后台，点击“iPayLinks 贸易真实性信息采集工具”图标，点击“开始采集”",
            Donotagain: "采集过程中不要关闭弹窗，待采集完成以后，工具会自动停止。此时返回MP付款页面， 重新进行出款即可",
            Tip: "提示：请在noon平台打款之后操作完成订单信息抓取，更新您在MP的订单信息，以免影响您的正常出款",
        },
        Shoplazza: {
            s1: "1.在Shoplazza后台选择应用市场，点击“private App”",
            s2: "2.点击右侧“创建应用”进行开发者应用创建",
            s3: "3.进行开发者应用创建",
            s4: "填写应用详情：应用名称（作为开发者备注）、开发者邮箱、Webhook API version 接口调用权限：选择“订单权限”、“店铺信息权限”仅需配置读取权限，配置完成后点击“保存”按钮",
            s5: "4.获取到的Token信息，复制填写到申请收款账户页“Token”输入框",
        },
    },
    page403: {
        a1: "抱歉，您暂无该页面的访问权限",
        a2: "请联系您的账户管理员",
        a3: "返回首页",
    },
    page404: {
        a1: "抱歉，无法找到该页面",
    },
    //    调单
    transferRecord: {
        id: "调单编号",
        xgyeid: "相关业务订单号",
        ddsm: "调单说明",
        gxsj: "更新时间",
        xzzl: "下载资料",
        ddjl: "调单记录",
        a1: "仅支持JPG、PNG、JPEG、BMP、PDF、ZIP、RAR格式文件",
        a11: "仅支持PNG、JPEG、PDF格式文件",
        createTime: "创建时间",
        op: "操作",
        a2: "这笔资金需要您提供说明材料后才能入账",
        a3: "收款账号",
        a4: "金额",
    },
    //    优惠券
    coupon: {
        myCoupon: "优惠券",
        available: "可用优惠劵",
        used: "已使用优惠券",
        beOverdue: "已过期优惠劵",
        a1: "使用/退回额度",
        a2: "剩余可用额度",
        a3: "订单类型",
        a4: "使用时间",
        a5: "使用记录",
        a6: "使用规则说明",
        a7: "总额度",
        a8: "已用额度：",
        a9: "剩余可用：",
        a10: "可用额度：",
        a10s: "可用额度",
        a11: "有效期：",
        a12: "查看详情",
        a13: "即将过期",
        a14: "费率",
        noCoupon: "您尚无优惠券可用",
        transId: "订单编号",
        type: "类型",
        a15: "返回优惠券",
        a16: "优惠券",
        dyq: "抵用券",
        edq: "额度券",
        a17: "特别提醒：额度券可叠加使用，抵用券不可叠加使用",
    },
    //    Vcc 虚拟卡
    vcc: {
        tranId: "订单号",
        ywType: "交易类型",
        zjDescribe: "资金描述",
        cardNick: "卡昵称",
        card4: "卡号后四位",
        rzTime: "入账时间",
        currency: "币种",
        jyAmount: "交易金额",
        cardId: "卡ID",
        createTime: "创建时间",
        holdName: "持卡人姓名",
        yxq: "有效期",
        status: "状态",
        vcList: " 卡列表",
        jyxz: "交易限制",
        maxAmount: "最大交易金额",
        maxNumber: "最大交易笔数",
        cardTime: "开卡日期",
        okrecharge: "确认充值",
        a1: "无需等待，即开即用",
        a2: "即刻创建您的多币种卡片，轻松付款全球。通过自定义卡消费设置，您可对每笔收款进行全方位控制。预约咨询，开启您的卡支付业务。 ",
        jylb: "交易列表",
        kz: "卡组",
        cardCurrency: "卡币种",
        cardCountry: "发卡国",
        kls: "卡流水",
        kzh: "卡账户",
        kzhxq: "卡账户详情",
        createNewCard: "创建新的虚拟卡",
        createNewCard2: "创建新卡",
        kzhls: " 卡账户流水",
        balance: "余额",
        createCard: "开卡",
        createCard2: "确认创建",
        Singapore: "新加坡",
        dj: "冻结",
        gk: "关卡",
        qsrje: "请输入金额",
        kgl: "卡管理",
        kh: "卡号",
        a3: "充值",
        a4: "账户",
        a5: "充值金额",
        a6: "最大交易限额",
        a7: "最大交易次数限制",
        Pleaseenteramount: "请输入正整数",
        a8: "不能超过",
        jjh: "已激活",
        qrdj: "是否冻结？",
        qrgk: "是否关卡？",
    },
    // vat缴税  0.3.2  20210318
    vat: {
        vatjs: "VAT缴税",
        vatjsjl: "VAT缴税记录",
        jsjl: "缴税记录",
        tanId: "订单编号",
        jsjg: "缴税机构名称",
        jsjg2: "缴税机构",
        jsjgLocation: "缴税机构所在国家",
        jsjgLocation2: "所在国家",
        jsAmount: "缴税金额",
        yjsdje: "预计收到金额",
        time: "缴税时间",
        jsfyType: "税务费用类型",
        status: "状态",
        createTime: "订单创建时间",
        taxIdentifyNumber: "税务识别号码",
        taxType: "税务费用类型",
        taxDate: "缴税时间",
        companyName: "公司名称（请输入在销售平台注册时填写的名称）",
        companyName2: "公司名称",
        otherMes: "其他缴税信息",
        vattaxMes: "缴税信息",
        taxMes: "缴税机构信息",
        confirmMes: "信息确认",
        bankNo: "银行账户号码",
        a1: "如没找到，请点击上方“添加常用缴税机构”，添加完成后再来选择。",
        chooseTax: "选择缴税机构",
        addTax: "添加常用缴税机构",
        bankName: "银行名称",
        zzsjg: "增值税机构",
        nextTaxAmount: "下一步：缴税金额",
        nextTaxMes: "下一步：缴税信息",
        youAmount: "您的缴税金额",
        a2: "缴税信息应包括付款附言信息：税务识别号（Steuernummer）、税务类型（Steuerart）、缴税时间段（Zeitraum），以及注册销售平台的公司名称（Nachnahme oder Firmenname）",
        a3: "所有特殊字符（比如./等标点符号，@#等特殊字符请用空格代替）",
        am: "按月",
        aq: "按季度",
        ay: "按年",
        q1: "第一季度",
        q2: "第二季度",
        q3: "第三季度",
        q4: "第四季度",
        chooseYear: "选择年",
        chooseMonth: "选择月",
        a4: "用于税务机关识别您的本次付款信息（税号、税务类型、缴税时间段无需填写），支持大小写英文字母、数字、空格",
        a5: "缴税信息已提交！",
        a6: "请在缴税记录中跟踪最新的交易状态",
        continueTax: "继续缴税",
        lookDetail: "查看缴税详情",
    },
    binPhoneJson: {
        title: "注意到您尚未绑定手机号",
        a1: "为了保障您的资金安全和账户功能使用，请尽快绑定您的手机号",
        btn: "去绑定",
        a2: "由于合规要求，您的以下收款账号（需下载）需要补充店铺注册信息，请及时前往完善",
        a3: "前往补充",
        a4: "下载账号列表",
    },
    keyManagement: {
        wd: "API文档",
        wdms: "如果您想要通过API方式使用iPayLinks 进行付款，请阅读此文档，此文档包括所有接口对接内容。",
        ckwd: "查看API文档",
        mygl: "密钥管理",
        ts1: "您暂未开通API，开通后可使用相关功能",
        an1: "申请开通",
        ts2: "您的请求已提交成功，我们将在1个工作日内完成审核，请耐心等待",
        ts3: "您的申请未通过，请修改后重新提交或咨询客服。",
        an2: "重新申请",
        jbxx: "基本信息",
        kfsz: "开发设置",
        bwyq: "响应报文验签",
        jmfs: "接口内容加密方式",
        jqfs: "接口加签方式",
        hddz: "回调地址",
        sz: "设置",
        ck: "查看",
        cz: "重置",
        sz1: "设置",
        ck1: "查看",
        cz1: "重置",
        aqyz: "安全验证",
        ts4: "尊敬的用户,为了您的账户安全，请完成验证，验证码已发送到",
        ts5: "尊敬的用户，您的APP Key 已重置为：",
        jqlx: "加签类型",
        gyzf: "公钥字符",
        ts6_1: "IPL会在调用接口时验签，您可以使用",
        ts6_2: "（第三方工具）生产秘钥",
        confirm: "确认",
        cancel: "取消",
        ts11: "尊敬的用户，您的APP Key 为：",
        ts7: "尊敬的用户，您的接口内容加密方式为：",
        ts8: "尊敬的用户，您的报文验签为：",
        ts9: "尊敬的用户，您的接口加签方式为：",
        ts10: "尊敬的用户，您的接口内容加密方式重置为：",
        sqcg: "审核提交成功",
        sqsb: "申请未通过",
        sbly: "未通过理由",
        ktsq: "API开通申请",
        ts12: "请设置接口加签方式",
        ts13: "请设置回调地址",
        ts14: "温馨提醒：为提高审核效率，请务必认真填写审核理由，我们将在1个工作日内完成审核。",
        ts15: "请输入通过秘钥生成器或OpenSSL生成的秘钥(20-2000个字符)",
        ts16: "请输入回调地址",
        ts17: "请填写不超过100个字的申请理由",
    },
    holderManagement: {
        type: "店铺注册类型",
        holdName: "店铺注册名称",
        holdNameCare: "（请填写店铺后台的公司或个人名称（中文或英文名））",
        country: "证件所属国家",
        idType: "店铺注册证件类型",
        idNo: "证件号码",
        address: "店铺注册地址",
        addHolder: "添加新的店铺注册信息",
        companyAdd: "公司地址",
        fddbssgj: "法定代表证件所属国家",
        fddbxm: "法定代表证件类型",
        fddbCardNo: " 法定代表证件号码",
        fddbName: "法定代表姓名",
        modifyHolder: "修改店铺注册信息",
        searchName: "搜索店铺注册名称",
        resubmit: "重新提交",
        addHolderBtn: "新增店铺注册信息",
        a1: "账号持有人信息审核中，请稍后查看银行信息",
        a2: "店铺注册信息",
        a3: "店铺信息",
        ghcyr: "更换店铺注册信息",
        glcyr: "选择店铺注册信息",
        holderBankMes: "店铺注册信息的银行信息",
        holderBankMesC: "（企业请填写公账）",
        continueEditMes: "您有未编辑完成的草稿，是否继续编辑？",
        fangqi: "放弃",
        qrbj: "编辑后关联此店铺注册信息的收款账号的店铺注册信息都会更改，确认是否编辑",
        jxbj: "继续编辑",
        ccyrygl: "此店铺注册信息已经关联收款账号，暂不支持删除，请先新增一个新的店铺注册信息，并去收款账号详情页面修改店铺注册信息，再来删除。",
        qrlkm: "您确认要离开吗？离开后当前页面信息不会保存。",
        ckycCopy: "复制实名认证信息",
    },
    AmazonHolderMes: {
        a1: "如何获取Amazon店铺持有人信息截图",
        a2: "亚马逊欧洲站和英国站",
        a3: "1. 登录亚马逊卖家中心后台，点击右上角的“设置”—“账户信息”，进入账户信息界面。",
        a4: "2. 点击“业务信息”下的“身份信息”。",
        a5: "3.“Business and Contact Information”下即可查看您的账户持有人名称（与公司法定名称一致）。",
        a6: "亚马逊北美站/日本站",
        a7: "1. 登录亚马逊卖家中心后台，点击右上角的“设置”—“账户信息”，进入账户信息界面。",
        a8: "2. 点击“业务信息”下的“公司名称”。",
        a9: "3. “法定公司名称”下即可查看您的账户持有人名称（与法定公司名称一致）。",
        a10: "亚马逊阿联酋站/沙特站",
        a11: "1. 登录亚马逊卖家中心后台，点击右上角的“设置”—“账户信息”，进入账户信息界面。",
        a12: "2. 点击“业务信息”下的“公司名称”。",
        a13: "3. “法定公司名称”下即可查看您的账户持有人名称（与法定公司名称一致）。",
        a14: "协议内容已确认",
        a15: "协议内容未确认",
        a16: "我已知晓内容并确认",
    },
    v0629: {
        a1: "申请记录",
        a2: "发起申请",
        a3: "申请时间",
        a4: "申请人",
        a5: "提现/付款金额",
        a6: "申请原因",
        a7: "审核状态",
        a8: "备注",
        a9: "特别提醒：目前系统默认的还原订单的有效期是180天（当前时间往前推180天创建的订单），如果您有特殊情况造成180天以前的订单资金要入境（比如Paypal资金被冻结等原因），可由此申请特殊配置。",
        a10: "如是正常的资金入境，请勿申请，申请会被驳回。",
        a11: "特殊申请",
        a12: "需要提现/付款的金额",
        a13: "钱包币种",
        a14: "申请原因",
        a15: "请填写不超过200字的申请原因",
        a16: "请输入金额",
        a17: "上传paypal冻结邮件截图、paypal站内信等，支持不超过10个共10MB的 JPG、PNG、JPEG、BMP、PDF、ZIP、RAR格式文件",
        a18: "上传证明，将文件拖到此处，",
        a19: "或点击上传",
        a20: "仅支持JPG、PNG、JPEG、BMP、PDF、ZIP、RAR格式文件",
        a21: "钱包余额不足，请修改金额",
    },
    v0819: {
        title: "账户注销须知",
        explain1: "在您选择注销账户前请务必仔细阅读以下说明，避免给您带来损失：",
        explain2: "注销一旦完成，您当前帐户的所有数据都将会被清除，无法以任何方式进行恢复。",
        explain3: "您当前帐户下授权登录的其他iPayLinks账号将无法登录。",
        explain4: "若您后续还希望与iPayLinks进行合作，无法恢复之前账户，只能重新申请开通新的账户。",
        apply: "申请注销",
        explain5: "为了您的合法权益，账户注销需要满足以下条件：",
        explain6: "1. 账户180天内无新增交易",
        explain7: "2. 全部账户余额为0",
        explain8: "3. 无应当履行而尚未履行完毕的义务，包括拒付、调单等",
        explain9: "4. 用户关联Account情况",
        explain13: "5. 其他为了保障您的账户安全和财产权益需要满足等内容",
        explain10: "已阅读确认并同意",
        explain11: "《iPayLinks账户注销协议》",
        confirm: "确认注销",
        explain12: "尊敬的用户您正在进行账户注销",
        explain14: "IPL客服将与您尽快取得联系，请注意您的邮箱和来电。",
        agreement: {
            title: "iPayLinks账户注销协议",
            a1: "在正式开始注销流程前，请您特别注意如下特别说明：注销iPayLinks帐户后，您将无法再以此账户登录和使用iPayLinks的相关产品与服务，iPayLinks也将同时终止为该账户提供我们高品质、多元化的产品与服务。且iPayLinks账户一旦注销完成，将无法恢复。请您在注销前慎重考虑。",
            a2: "若您经过慎重考虑后仍决定注销iPayLinks账户的，请您务必先行仔细阅读和充分理解本《iPayLinks账户注销协议》，您按照我们的注销操作指引勾选本注销协议并点击注销的操作行为即视为您已经同意签署和遵守本协议全部内容。如您在注销后需要再次使用我们服务的，欢迎您使用手机号码或iPayLinks允许的其他方式重新注册。",
            a3: "本注销协议指导您注销iPayLinks账户。请仔细阅读这些条款，因为它们构成了您和我们之间的法律关系。",
            a4: "最后更新：2021年4月",
            a5: "1.注销的要求",
            a6: "在您向我们申请注销iPayLinks账户之前或正在申请注销iPayLinks账户的过程中，为保障您的账户安全和财产权益，请您先行检查与确保您申请注销的iPayLinks账户已经同时满足以下几点，包括：",
            a7: "1.1 账户是通过我们的www.ipaylinks.com网站（“网站”）注册、符合《用户注册协议》及相关说明规范的账户，且为您本人注册的账户；",
            a8: "1.2 该账户处于安全状态，即在最近两周内，您没有进行密码修改、手机号码修改等操作；",
            a9: "1.3 该账户内无资金，即账户内所有币种账户余额已为零；",
            a10: "1.4 该账户已在其他App账号退出，微信小程序账户已登出；",
            a11: "1.5 该账户项下无应当履行而尚未履行完毕的义务；",
            a12: "1.6 该账户处于正常状态，即您账户的信息是最新、完整、正确的，且账户未被采取止付、有权机关冻结等限制措施；",
            a13: "1.7 其他为了保障您的账户安全和财产权益需要满足的内容。",
            a14: "上述问题您可首先尝试自行处理，如您无法处理的或在处理过程中有任何疑惑的，可联系iPayLinks客服支持部门协助处理。",
            a15: "2.注销的影响",
            a16: "账户注销将会对您产生如下影响：",
            a17: "2.1 iPayLinks账户一旦注销，您将无法登录、使用该账户，即您将无法再以此账户登录/使用/继续使用iPayLinks的相关产品与服务；",
            a18: "2.2 iPayLinks账户一旦注销，您曾通过该账户登录、使用的iPayLinks的产品与服务下的所有内容、信息、数据、记录将会被删除或匿名化处理，您也无法再检索、访问、获取、继续使用和找回，也无权要求我们找回（但法律法规另有规定或监管部门另有要求的除外），包括：",
            a19: "•该账户下您的个人资料及绑定信息（例如：绑定手机号、邮箱等）；",
            a20: "•该账户下您的个人身份信息（同时您亦不再享有iPayLinks《隐私政策》中约定的用户权利，但法律法规另有规定的除外）；",
            a21: "•该账户下您的交易记录；",
            a22: "•其他所有内容、信息、数据、记录。",
            a23: "2.3 账户注销后该账户使用期间已产生的但未处理完毕的资产或权益及未来的预期利益均将作废。即iPayLinks账户一旦注销，我们将会对该账户下的全部资产或权益做清除处理，包括：",
            a24: "•【未使用的优惠券】；",
            a25: "•【未使用的免费提现额度】；",
            a26: "•其他已产生但未处理完毕的权益或未来预期的收益。",
            a27: "2.4 iPayLinks账户一旦注销完成，将无法恢复（即使您在注销后以同一手机号码再次向我们申请注册iPayLinks账户，此时该账户为新的用户账户。",
            a28: "因此，我们提醒您在申请注销前对您认为需要备份的所有信息和数据提前自行做好备份，否则您自行承担因所需信息和数据丢失所产生的风险）；",
            a29: "2.5 iPayLinks账户一旦注销，您与我们曾签署过的《用户注册协议》等法律文件相应终止（但我们与您之间已约定继续生效的或法律法规另有规定的除外）；",
            a30: "2.6 如您在注销账户前存在违法违规、侵权违约等不当行为或未完结义务的，您仍将承担相应责任；",
            a31: "2.7其他因iPayLinks账户注销产生的结果。",
            a32: "3.如何注销iPayLinks账户",
            a33: "3.1我们的网站为您提供了在线注销功能，您可以按照页面操作指引进行在线注销。当然，您也可以直接与我们的客服支持部门联系进行账户注销。",
            a34: "3.2本《iPayLinks账户注销协议》中包含了账户注销对您权益产生的影响等多方面的内容阐述，请您仔细阅读与充分理解，在同意本《iPayLinks账户注销协议》的全部内容后再进行下一步注销操作。",
            a35: "3.3为保障您的账户安全和财产权益，我们需要进行注销申请的身份验证（例如：验证账户绑定的手机号码等），以确保该账户是您本人注册的。",
            a36: "3.4为了维护您和其他用户的合法利益，在您申请注销账户时，我们会进行风险审查，您的账户应当不存在未完结交易或其他未了结的权利义务，且不存在其他因注销可能引发纠纷的情况。如您的账户有余额或关联资产，请您在注销前先将您的账户下对应的可用款项全部提现，或者通过转账等途径支用完毕。",
            a37: "3.5账户注销的处理期限最长为【14】日，即在您已成功向我们提交了iPayLinks账户注销申请后的【14】日内（从成功提交申请之时起算），账户将被注销（本协议另有约定的除外）。在前述【14】日内，您任可以登录该账户。或联系客服支持部门来取消账户注销。",
            a38: "3.6如超过上述第3.5点所述期限后，该账户将被永久注销。",
            a39: "本协议未尽事宜，请参考iPayLinks《用户注册协议》、《隐私政策》及注销过程中的相关规则、说明等。",
            a40: "同时，您知悉并同意：即使您的iPayLinks账户被注销，也并不代表减轻或免除您应根据相关法律法规、相关协议、规则等（可能）需要承担的相关责任。",
        },
    },
    save: "保存",
    query: "查询",
    financeService: {
        Applicationdate: "申请日期",
        Today: "今天",
        Last7days: "近7天",
        Last30days: "近30天",
        Last90days: "近90天",
        Last1year: "近一年",
        Loanproduct: "借款产品",
        All: "全部",
        Status: "状态",
        ApplicationID: "申请编号",
        Productname: "产品名称",
        Approvalquota: "审批额度",
        Creditexpirationtime: "授信失效时间",
        Annualizedrate: "年化费率",
        Repaymentmethod: "还款方式",
        Accountmanager: "所属销售",
        myApplication: "我的申请",
        Myloan: "我的借款",
        Serialnumber: "序号",
        LoanID: "借款ID",
        Loanproduct2: "产品",
        Loanamount: "放款金额",
        Deadline: "期限",
        Loandate: "放款日期",
        Duedate: "到期日期",
        Overduedate: "逾期日期",
        Settlementdate: "结清日期",
        Repaymentrecord: "还款记录",
        Repaymentnumber: "还款编号",
        Repaymenttime: "还款时间",
        Capital: "本金",
        Interest: "利息",
        Totalrepayment: "还款总额",
        Repaymentcardnumber: "还款卡号",
        Repaymentplan: "还款计划",
        Periods: "期数",
        Capitalpayable: "应还本金",
        Interestpayable: "应还利息",
        Penaltypayable: "应还罚息",
        Amountpayable: "应还总额",
        Singlerepayment: "单笔还款",
        Totalrepayment2: "全额还款",
        Loanssupermarket: "极时予",
        CreditLoans2: "瞬息盈",
        CreditLoans: "瞬息盈：信用贷，0抵押",
        viewNow: "立即查看",
        Unfortunately: "很遗憾，您的申请未能通过审核，请1个月后再来尝试申请",
        questionsmanager: "若有疑问，请联系您的客户经理",
        ProductIntroduction: "产品介绍",
        BasicRequirements: "基本要求",
        OperationProcedures: "操作流程",
        FAQ: "常见问题",
        Openingconditions: "开通条件",
        Loansuccessfully: "贷款意向提交成功",
        pleaseaccountmanager: "贷款意向申请提交成功，我们会电话通知您进行下一步操作。若有疑问，也可以咨询您的客户经理。",
        gotit: "我知道了",
        processedmanager: "您的贷款申请正在处理中，若有疑问请联系您的客户经理！",
        expiredreapply: "您的额度已失效，请重新申请",
        Reapply: "重新申请",
        InProcess: "处理中",
        Applicationinprocess: "申请处理中",
        Waitingforwithdrawal: "待提现",
        myLoan: "我的贷款",
        totalamount: "总额度",
        Available: "剩余可用额度",
        Used: "已用额度",
        expirytime: "额度失效时间",
        annualizedrate: "年化费率",
        ask: "问：",
        answer: "答：",
        Storeauthorization: "店铺授权",
        Scancodeapply: "扫码申请",
        Wechatscancode: "微信扫码，立即申请",
        ViewProgress: "查看申请进度",
        Wechatwithdraw: "微信扫码，立即提现",
        WechatView: "微信扫码，立即查看",
        agreen: "同意",
        disagree: "不同意",
        Codescanningwithdrawal: "扫码提现",
        toRepayment: "我要还款",
        repaymentSuccess: "还款成功！",
        backList: "返回列表",
        confirmRepayment: "确认还款",
        // Periods:'期数',
        // Duedate:'到期日',
        // Capitalpayable:'应还本金',
        // Interestpayable:'应还利息',
        // Penaltypayable:'应还罚息',
        // Amountpayable:'应还总额',
        Totalamountpayable: "全部应还金额",
        Amountperiod: "当期应还金额",
        Youoperation: "您正在进行还款操作",
        Confirmagainsentto: "再次确认，请完成验证进行操作，验证码已发送至",
        followingstoresbind: "以下店铺符合智惠盈产品准入要求，请选择您需要绑定的店铺（支持多选）：",
        Scancontract: "扫码查看合同",
        viewcontract: "查看合同",
        Someapply1: "您绑定的店铺中有部分不符合申请条件，您可以选择重新绑定店铺或继续申请",
        Someapply2: "您绑定的店铺均不符合申请条件，您可以选择更换店铺后继续申请",
        Someapply3: "恭喜，您的店铺绑定成功，请继续进行下一步申请",
        Continueapply: "继续申请",
        Changeshop: "更换店铺",
        submitSuccess: "提交成功",
        storeprocessed: "您的申请正在处理中",
        Wepatiently: "请您耐心等待，工作人员将在2个工作日内联系您。",
        backappList: "返回应用市场",
        rateMonth: "月费率",
    },
    user: {
        s0: "邮箱不能为空",
        s1: "操作员名称",
        s2: "新绑定手机号",
        s3: "请输入新绑定手机号",
        s4: "手机验证码",
        s5: "请输入手机验证码",
        s6: "注：非中国大陆用户暂时不支持绑定手机",
        s7: "获取验证码",
        s8: "已成功绑定手机号",
        s9: "获取验证码成功！",
        s10: "新绑定邮箱",
        s11: "当前绑定邮箱",
        s12: "请输入新绑定邮箱",
        s13: "邮箱验证码",
        s14: "请输入邮箱验证码",
        s15: "已成功绑定邮箱",
        s16: "当前绑定手机",
        s17: "手机号不能为空",
        v1: "会员名称",
        v2: "会员号",
        v3: "当前操作员名称：",
        v4: "定期更换密码会让您的账号更加安全。",
        v5: "密码最少6位，需使用字母、数字和符号两种及以上的组合。",
        v6: "您已绑定手机",
        v7: "您还没有设置绑定邮箱，快去设置吧！",
        v8: "您已绑定了邮箱",
        v9: "角色序号",
        v10: "角色名称",
        v11: "角色描述",
        v12: "最后修改时间",
        v13: "可操作权限",
        v14: "登录账号",
        v15: "真实姓名",
        v16: "所属部门",
        v17: "操作员状态",
        v18: "创建",
        v19: "已分配角色",
        v20: "角色分配",
        v21: "锁定",
        v22: "请输入纯数字",
        v23: "请输正确的邮箱地址",
        v24: "请输入所属部门",
        v25: "请选择操作员状态",
        v26: "您已成功修改操作员",
        v27: "配置成功",
        v28: "添加操作员失败，请重新添加。",
        v29: "已读",
        v30: "未读",
        v31: "消息主题",
        v32: "通知时间",
        v33: "不能与当前手机号相同",
        v34: "已成功修改绑定手机号",
        v35: "角色名称不能为空",
        v36: "角色描述不能为空",
        v37: "可操作权限不能为空",
        v38: "提交修改",
        v39: "请输入角色描述",
        v40: "请输入角色名称",
        v41: "您已成功修改角色",
        v42: "修改操作员失败，请重新修改。",
        v43: "当前支付密码",
        v44: "新支付密码",
        v45: "请输入当前支付密码",
        v46: "请输入新支付密码",
        v47: "安全强度",
        v48: "低",
        v49: "中",
        v50: "高",
        a1: "•请输入6~20字符，只能包含字母、数字、以及标点符号(除空格)，字母、数字、符号至少包含2种，字母区分大小写",
        ra1: "•请输入8~20字符，只能包含字母、数字、以及标点符号(除空格)，字母、数字、符号至少包含2种，字母区分大小写",
        a2: "确认新支付密码",
        a3: "请再次输入支付密码",
        a4: "请按规则输入",
        a5: "两次输入密码不一致",
        a6: "新密码不能为空",
        a7: "确认密码不能为空",
        a8: "当前登录密码不能为空",
        a9: "您已成功修改支付密码",
        a10: "支付密码重置成功！",
        a11: "登录密码重置成功！",
        a12: "必须年满18岁",
        a13: "年龄不能为空",
        a14: "您已成功修改登录密码,请重新登录",
        a15: "不能与当前邮箱相同",
        a16: "公告",
        a17: "返回消息列表",
        a18: "最后登录时间",
        a19: "关键字",
        a20: "请输入关键字",
        a21: "日志类型",
        a22: "日志内容",
        a23: "您的操作员账号存在风险，为了您的账号安全，请补全安全信息！",
        a24: "非中国大陆用户请",
        a25: "跳过绑定手机号",
        a26: "下一步",
        a27: "返回上一步",
        a28: "返回首页",
        a29: "添加收款人成功",
        a30: "我们会对您添加的提现卡进行审核，审核通过后您可以使用这张卡进行提现操作",
        a31: "继续添加提现银行卡",
        a32: "返回提现卡管理",
        a33: "我要提现",
        a34: "填写操作员信息",
        a35: "密码设置",
        a36: "操作员名称支持5-32位字母、数字、下划线组合",
        a37: "请输入操作员所属部门",
        a38: "操作员姓名",
        a39: "请输入操作员姓名",
        a40: "请输入操作员名称",
        a41: "操作员名称",
        a42: "新登录密码",
        a43: "请输入登录密码",
        a44: "•请输入8~20字符，只能包含字母、数字、以及标点符号(除空格)，字母、数字、符号至少包含2种，字母区分大小写",
        a45: "确认登录密码",
        a46: "请再次输入登录密码",
        a47: "确认支付密码",
        a48: "去设置权限",
        a49: "您已经成功添加操作员",
        a50: "快去给操作员分配权限吧！",
        b1: "请输入数字、字母或下划线",
        b2: "不能与登录密码一致",
        b3: "两次登录密码输入不一致",
        b4: "两次支付密码输入不一致",
        b5: "请输入5-32位字母、数字、下划线组合",
        b6: "真实姓名不能为空",
        b7: "操作员所属部门不能为空",
        b8: "添加收款人失败",
        b9: "您的银行卡添加失败，查看",
        b10: "解决方法",
        b11: "联系电话",
        b12: "联系地址",
        b13: "商户名称",
        b14: "修改密码",
        b15: "您还没有设置绑定手机，快去设置吧！",
        b16: "当前登录密码",
        b17: "请输入当前登录密码",
        b18: "请输入新登录密码",
        b19: "确认新登录密码",
        b20: "当前支付密码不能为空",
        b21: "请输入邮箱",
        b22: "请输入手机号",
        b23: "开始时间",
        b24: "操作时间",
        b25: "操作人员",
        b26: "操作员登录名称",
        b27: "分配角色",
        b28: "加入角色",
        b29: "您将要删除该操作员配置",
        b30: "删除成功!  您已成功删除该操作员配置!",
        b31: "操作员名称不能为空",
        b32: "支付密码不能为空",
        b33: "重置登录密码",
        b34: "重置支付密码",
        b35: "您已成功添加角色",
        b36: "修改失败",
        b37: "请输入正确的ip",
    },
    authorize: {
        authorization: "请登录iPayLinks跨境支付账号并完成授权",
        Loginaddress: "登录手机号或邮箱",
        enteraddress: "请输入手机号或邮箱",
        Authorizationconfirmation: "确认授权",
    },
    appsMarket: {
        appsMarket: "应用市场",
        detail: "应用详情",
    },
    v1014: {
        title: "通知语言",
        zh: "中文通知",
        en: "英文通知",
    },
    common: {
        index: "序号",
        actions: "操作",
        reset: "重置",
        no_data: "暂无数据",
        search: "搜索",
        cancel: "取消",
        confirm: "确认",
        delete: "删除",
        edit: "编辑",
        view: "查看",
        add: "添加",
        save: "保存",
        amount_format_error: "金额格式有误",
        amount_greater_than_balance: "付款金额不能大于可用金额",
        amount_greater_than_balance_withdraw: "提现金额不能大于余额",
        amount_empty: "请输入金额",
        loading: "加载中...",
    },
    router: {
        mobileNotVerified: "您还未完成账户持有人信息设置，请先完成设置",
        kycRequired: "请先完成实名认证",
    },
};
